/* tslint:disable */
//  This file was automatically generated and should not be edited.

export enum MenuScheme {
  dark = "dark",
  light = "light",
  transparent = "transparent",
}


export interface AllCollectionsQueryVariables {
  site?: Array< string > | null,
  type?: Array< string | null > | null,
  collectionType?: Array< string | null > | null,
  offset: number,
  itemLimit: number,
  order?: string | null,
  listExpiryDate?: Array< string | null > | null,
};

export interface AllCollectionsQuery {
  // This query is used to query for entries.
  collectionItems:  Array<( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      description:  {
        __typename: "description_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      description:  {
        __typename: "description_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The width in pixels or null if it’s not an image.
          width: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The width in pixels or null if it’s not an image.
          width2x: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The width in pixels or null if it’s not an image.
          width: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The width in pixels or null if it’s not an image.
          width2x: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      startDate: string | null,
      endDate: string | null,
      // The entry’s post date.
      date: string | null,
      location: string | null,
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      description:  {
        __typename: "description_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      description:  {
        __typename: "description_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The width in pixels or null if it’s not an image.
          width: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The width in pixels or null if it’s not an image.
          width2x: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The width in pixels or null if it’s not an image.
          width: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The width in pixels or null if it’s not an image.
          width2x: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      // The entry’s post date.
      date: string | null,
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      description:  {
        __typename: "description_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The width in pixels or null if it’s not an image.
          width: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The width in pixels or null if it’s not an image.
          width2x: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The width in pixels or null if it’s not an image.
          width: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The width in pixels or null if it’s not an image.
          width2x: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      description:  {
        __typename: "description_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The width in pixels or null if it’s not an image.
          width: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The width in pixels or null if it’s not an image.
          width2x: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The width in pixels or null if it’s not an image.
          width: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The width in pixels or null if it’s not an image.
          width2x: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      // The entry’s post date.
      date: string | null,
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null > | null,
  // This query is used to return the number of entries.
  entryCount: number,
  // This query is used to query for entries.
  collection:  Array<( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
    } | {
      __typename: "eventCollection_Entry",
      introHeading: string | null,
      introText:  {
        __typename: "introText_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
    } | {
      __typename: "newsCollection_Entry",
      introHeading: string | null,
      introText:  {
        __typename: "introText_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
    } | {
      __typename: "storyCollection_Entry",
      introHeading: string | null,
      introText:  {
        __typename: "introText_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
      featuredStories:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          description:  {
            __typename: "description_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
          heroImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
          // The entry’s post date.
          postDate: string | null,
        } | {
          __typename: "storyCollection_Entry",
        }
      ) | null >,
    }
  ) | null > | null,
};

export interface ConnectedNetworksQueryVariables {
  exchange?: Array< string > | null,
  search?: string | null,
};

export interface ConnectedNetworksQuery {
  // This query is used to query for a single entry.
  connectedNetworksPage: ( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
      // The element’s title.
      title: string | null,
      introHeading: string | null,
      introText:  {
        __typename: "introText_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
      exportLinks:  Array< {
        __typename: "exportLinks_TableRow",
        title: string | null,
        url: string | null,
      } | null > | null,
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null,
  // This query is used to query for entries.
  connectedNetworksTable:  Array<( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s title.
      title: string | null,
      memberUrl: string | null,
      asNumber: string | null,
      peeringPolicy: string | null,
      routeserver: boolean | null,
      vlan: string | null,
      colocation: string | null,
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null > | null,
  // This query is used to query for a single global set.
  connectedNetworksStats: ( {
      __typename: "commitmentModule_GlobalSet",
    } | {
      __typename: "email_GlobalSet",
    } | {
      __typename: "exchangeConfig_GlobalSet",
    } | {
      __typename: "globalStats_GlobalSet",
      routeserverPeers: string | null,
      connectedNetworks: string | null,
      customerPorts: string | null,
      ipv6Peers: string | null,
    } | {
      __typename: "glossary_GlobalSet",
    } | {
      __typename: "modalSettings_GlobalSet",
    } | {
      __typename: "smartSnippets_GlobalSet",
    } | {
      __typename: "socialMedia_GlobalSet",
    }
  ) | null,
};

export interface DocumentationQueryVariables {
  exchange?: Array< string > | null,
  slug?: Array< string > | null,
};

export interface DocumentationQuery {
  // This query is used to query for a single entry.
  entry: ( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
      // The element’s title.
      title: string | null,
      description:  {
        __typename: "description_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
      contentBlocks:  Array<( {
          __typename: "intro_Entry",
          // The ID of the entity
          id: string | null,
          heading: string | null,
          textHTML:  {
            __typename: "text_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        } | {
          __typename: "text_Entry",
          // The ID of the entity
          id: string | null,
          heading: string | null,
          textHTML:  {
            __typename: "text2_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        } | {
          __typename: "textWithImage_Entry",
          image:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
          heading: string | null,
          textHTML:  {
            __typename: "text3_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
          imageAlignment: string | null,
        } | {
          __typename: "image_Entry",
          image:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
          heading: string | null,
          text: string | null,
          buttonText: string | null,
          buttonLink:  Array<( {
              __typename: "city_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "connectedNetworkCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partnerContactRequest_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "internal_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "networkContactRequest_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "wishlist_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "registration_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "document_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "country_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "documentation_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "intro_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "text_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "textWithImage_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "image_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "graphic_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "video_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "audio_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "table_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "codeSnippet_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "contactForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "logos_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "button_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "sectionEnding_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "users_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "trafficGraph_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "applicationForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "registrationForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "event_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "eventCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "exchangePage_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "footerLink_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "getStarted_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "graph_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "info_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "menu_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "network_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "networkConnection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "news_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsletter_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsletterCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partner_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partnerCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "search_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "service_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "benefit_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "speedBlock_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "story_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "storyCollection_Entry",
              // The element’s URI.
              uri: string | null,
            }
          ) | null >,
          textAlignment: string | null,
        } | {
          __typename: "graphic_Entry",
          image:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcOriginal: string | null,
              // The width in pixels or null if it’s not an image.
              widthOriginal: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcOriginal: string | null,
              // The width in pixels or null if it’s not an image.
              widthOriginal: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "video_Entry",
          videoUrl: string | null,
        } | {
          __typename: "audio_Entry",
          podcastUrl: string | null,
          podcastDescription: string | null,
        } | {
          __typename: "table_Entry",
          heading: string | null,
          table:  {
            __typename: "table_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        } | {
          __typename: "codeSnippet_Entry",
          programmingLanguage: string | null,
          snippet:  {
            __typename: "snippet_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        } | {
          __typename: "contactForm_Entry",
          // The ID of the entity
          id: string | null,
          ctaText: string | null,
          buttonText: string | null,
          compactDisplay: boolean | null,
          documentUpload: boolean | null,
          description:  {
            __typename: "description3_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        } | {
          __typename: "logos_Entry",
          logos:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              src: string | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              src2x: string | null,
              // The element’s title.
              title: string | null,
              // The ID of the entity
              id: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              src: string | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              src2x: string | null,
              // The element’s title.
              title: string | null,
              // The ID of the entity
              id: string | null,
            }
          ) | null >,
        } | {
          __typename: "button_Entry",
          // The ID of the entity
          id: string | null,
          label: string | null,
          linkEntry:  Array<( {
              __typename: "city_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "connectedNetworkCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partnerContactRequest_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "internal_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "networkContactRequest_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "wishlist_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "registration_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "document_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "country_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "documentation_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "intro_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "text_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "textWithImage_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "image_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "graphic_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "video_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "audio_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "table_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "codeSnippet_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "contactForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "logos_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "button_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "sectionEnding_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "users_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "trafficGraph_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "applicationForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "registrationForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "event_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "eventCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "exchangePage_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "footerLink_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "getStarted_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "graph_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "info_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "menu_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "network_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "networkConnection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "news_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsletter_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsletterCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partner_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partnerCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "search_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "service_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "benefit_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "speedBlock_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "story_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "storyCollection_Entry",
              // The element’s URI.
              uri: string | null,
            }
          ) | null >,
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
          // The ID of the entity
          id: string | null,
          heading: string | null,
          users:  Array<( {
              __typename: "User",
              // The user’s full name.
              fullName: string | null,
              functionTitle: string | null,
              // The user’s photo.
              photo: ( {
                  __typename: "images_Asset",
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  url: string | null,
                } | {
                  __typename: "uploadAssets_Asset",
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  url: string | null,
                }
              ) | null,
            }
          ) | null >,
        } | {
          __typename: "trafficGraph_Entry",
          // The ID of the entity
          id: string | null,
          dataset:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
              // The element’s title.
              title: string | null,
              interval: string | null,
              peakIn: string | null,
              peakOut: string | null,
              averageIn: string | null,
              averageOut: string | null,
              currentIn: string | null,
              currentOut: string | null,
              averageInputData:  Array< {
                __typename: "averageInputData_TableRow",
                time: string | null,
                value: string | null,
              } | null > | null,
              averageOutputData:  Array< {
                __typename: "averageOutputData_TableRow",
                time: string | null,
                value: string | null,
              } | null > | null,
              peakOutputData:  Array< {
                __typename: "peakOutputData_TableRow",
                time: string | null,
                value: string | null,
              } | null > | null,
              peakInputData:  Array< {
                __typename: "peakInputData_TableRow",
                time: string | null,
                value: string | null,
              } | null > | null,
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) | null >,
        } | {
          __typename: "applicationForm_Entry",
          // The ID of the entity
          id: string | null,
          buttonText: string | null,
          applicationType: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The ID of the entity
          id: string | null,
          ctaText: string | null,
          buttonText: string | null,
          compactDisplay: boolean | null,
          description:  {
            __typename: "description4_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        }
      ) | null >,
      relatedItems:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          relatedItemImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          heroImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          relatedItemImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "menu_Entry",
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          heroImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          relatedItemImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          heroImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
          service:  Array<( {
              __typename: "city_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "connectedNetworkCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "partnerContactRequest_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "internal_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "networkContactRequest_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "wishlist_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "registration_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "document_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "country_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "documentation_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "intro_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "text_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "textWithImage_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "image_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "graphic_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "video_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "audio_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "table_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "codeSnippet_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "contactForm_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "logos_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "button_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "sectionEnding_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "users_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "trafficGraph_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "applicationForm_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "registrationForm_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "event_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "eventCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "exchangePage_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "footerLink_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "getStarted_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "graph_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "info_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "menu_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "network_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "networkConnection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "news_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "newsCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "newsletter_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "newsletterCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "partner_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "partnerCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "search_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "service_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "benefit_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "speedBlock_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "story_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "storyCollection_Entry",
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "storyCollection_Entry",
        }
      ) | null >,
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null,
};

export interface EventQueryVariables {
  exchange?: Array< string > | null,
  slug?: Array< string > | null,
};

export interface EventQuery {
  // This query is used to query for entries.
  entries:  Array<( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
      // The element’s title.
      title: string | null,
      description:  {
        __typename: "description_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
      location: string | null,
      startDate: string | null,
      endDate: string | null,
      // The entry’s post date.
      postDate: string | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      contentBlocks:  Array<( {
          __typename: "intro_Entry",
          // The ID of the entity
          id: string | null,
          heading: string | null,
          textHTML:  {
            __typename: "text_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        } | {
          __typename: "text_Entry",
          // The ID of the entity
          id: string | null,
          heading: string | null,
          textHTML:  {
            __typename: "text2_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        } | {
          __typename: "textWithImage_Entry",
          image:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
          heading: string | null,
          textHTML:  {
            __typename: "text3_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
          imageAlignment: string | null,
        } | {
          __typename: "image_Entry",
          image:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
          heading: string | null,
          text: string | null,
          buttonText: string | null,
          buttonLink:  Array<( {
              __typename: "city_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "connectedNetworkCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partnerContactRequest_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "internal_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "networkContactRequest_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "wishlist_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "registration_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "document_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "country_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "documentation_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "intro_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "text_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "textWithImage_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "image_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "graphic_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "video_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "audio_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "table_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "codeSnippet_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "contactForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "logos_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "button_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "sectionEnding_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "users_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "trafficGraph_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "applicationForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "registrationForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "event_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "eventCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "exchangePage_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "footerLink_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "getStarted_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "graph_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "info_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "menu_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "network_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "networkConnection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "news_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsletter_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsletterCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partner_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partnerCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "search_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "service_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "benefit_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "speedBlock_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "story_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "storyCollection_Entry",
              // The element’s URI.
              uri: string | null,
            }
          ) | null >,
          textAlignment: string | null,
        } | {
          __typename: "graphic_Entry",
          image:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcOriginal: string | null,
              // The width in pixels or null if it’s not an image.
              widthOriginal: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcOriginal: string | null,
              // The width in pixels or null if it’s not an image.
              widthOriginal: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "video_Entry",
          videoUrl: string | null,
        } | {
          __typename: "audio_Entry",
          podcastUrl: string | null,
          podcastDescription: string | null,
        } | {
          __typename: "table_Entry",
          heading: string | null,
          table:  {
            __typename: "table_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        } | {
          __typename: "codeSnippet_Entry",
          programmingLanguage: string | null,
          snippet:  {
            __typename: "snippet_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        } | {
          __typename: "contactForm_Entry",
          // The ID of the entity
          id: string | null,
          ctaText: string | null,
          buttonText: string | null,
          compactDisplay: boolean | null,
          documentUpload: boolean | null,
          description:  {
            __typename: "description3_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        } | {
          __typename: "logos_Entry",
          logos:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              src: string | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              src2x: string | null,
              // The element’s title.
              title: string | null,
              // The ID of the entity
              id: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              src: string | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              src2x: string | null,
              // The element’s title.
              title: string | null,
              // The ID of the entity
              id: string | null,
            }
          ) | null >,
        } | {
          __typename: "button_Entry",
          // The ID of the entity
          id: string | null,
          label: string | null,
          linkEntry:  Array<( {
              __typename: "city_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "connectedNetworkCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partnerContactRequest_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "internal_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "networkContactRequest_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "wishlist_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "registration_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "document_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "country_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "documentation_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "intro_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "text_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "textWithImage_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "image_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "graphic_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "video_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "audio_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "table_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "codeSnippet_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "contactForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "logos_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "button_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "sectionEnding_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "users_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "trafficGraph_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "applicationForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "registrationForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "event_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "eventCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "exchangePage_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "footerLink_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "getStarted_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "graph_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "info_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "menu_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "network_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "networkConnection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "news_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsletter_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsletterCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partner_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partnerCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "search_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "service_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "benefit_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "speedBlock_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "story_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "storyCollection_Entry",
              // The element’s URI.
              uri: string | null,
            }
          ) | null >,
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
          // The ID of the entity
          id: string | null,
          heading: string | null,
          users:  Array<( {
              __typename: "User",
              // The user’s full name.
              fullName: string | null,
              functionTitle: string | null,
              // The user’s photo.
              photo: ( {
                  __typename: "images_Asset",
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  url: string | null,
                } | {
                  __typename: "uploadAssets_Asset",
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  url: string | null,
                }
              ) | null,
            }
          ) | null >,
        } | {
          __typename: "trafficGraph_Entry",
          // The ID of the entity
          id: string | null,
          dataset:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
              // The element’s title.
              title: string | null,
              interval: string | null,
              peakIn: string | null,
              peakOut: string | null,
              averageIn: string | null,
              averageOut: string | null,
              currentIn: string | null,
              currentOut: string | null,
              averageInputData:  Array< {
                __typename: "averageInputData_TableRow",
                time: string | null,
                value: string | null,
              } | null > | null,
              averageOutputData:  Array< {
                __typename: "averageOutputData_TableRow",
                time: string | null,
                value: string | null,
              } | null > | null,
              peakOutputData:  Array< {
                __typename: "peakOutputData_TableRow",
                time: string | null,
                value: string | null,
              } | null > | null,
              peakInputData:  Array< {
                __typename: "peakInputData_TableRow",
                time: string | null,
                value: string | null,
              } | null > | null,
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) | null >,
        } | {
          __typename: "applicationForm_Entry",
          // The ID of the entity
          id: string | null,
          buttonText: string | null,
          applicationType: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The ID of the entity
          id: string | null,
          ctaText: string | null,
          buttonText: string | null,
          compactDisplay: boolean | null,
          description:  {
            __typename: "description4_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        }
      ) | null >,
      relatedItems:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          relatedItemImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          heroImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          relatedItemImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "menu_Entry",
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          heroImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          relatedItemImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          heroImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
          service:  Array<( {
              __typename: "city_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "connectedNetworkCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "partnerContactRequest_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "internal_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "networkContactRequest_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "wishlist_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "registration_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "document_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "country_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "documentation_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "intro_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "text_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "textWithImage_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "image_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "graphic_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "video_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "audio_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "table_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "codeSnippet_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "contactForm_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "logos_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "button_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "sectionEnding_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "users_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "trafficGraph_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "applicationForm_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "registrationForm_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "event_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "eventCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "exchangePage_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "footerLink_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "getStarted_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "graph_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "info_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "menu_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "network_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "networkConnection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "news_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "newsCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "newsletter_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "newsletterCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "partner_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "partnerCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "search_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "service_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "benefit_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "speedBlock_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "story_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "storyCollection_Entry",
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "storyCollection_Entry",
        }
      ) | null >,
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null > | null,
};

export interface MenuQueryVariables {
  site?: Array< string > | null,
};

export interface MenuQuery {
  // This query is used to query for entries.
  menuItems:  Array<( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
    } | {
      __typename: "menu_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s title.
      title: string | null,
      linkEntry:  Array<( {
          __typename: "city_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "connectedNetworkCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "internal_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "wishlist_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registration_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "document_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "country_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "documentation_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "intro_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "text_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "textWithImage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "image_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graphic_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "video_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "audio_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "table_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "codeSnippet_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "contactForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "logos_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "button_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "sectionEnding_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "users_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "trafficGraph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "applicationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "event_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "eventCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "exchangePage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "footerLink_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "getStarted_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "info_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "menu_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "network_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkConnection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "news_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletter_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletterCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partner_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "search_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "service_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "benefit_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "speedBlock_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "story_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "storyCollection_Entry",
          // The element’s URI.
          uri: string | null,
        }
      ) | null >,
      externalLink: string | null,
      // The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query.
      ancestors:  Array<( {
          __typename: "city_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "connectedNetworkCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "partnerContactRequest_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "internal_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "networkContactRequest_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "wishlist_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "registration_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "document_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "country_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "documentation_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "intro_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "text_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "textWithImage_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "image_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "graphic_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "video_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "audio_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "table_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "codeSnippet_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "contactForm_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "logos_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "button_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "sectionEnding_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "users_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "trafficGraph_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "applicationForm_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "event_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "eventCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "exchangePage_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "footerLink_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "getStarted_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "graph_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "info_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "menu_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "network_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "networkConnection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "news_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "newsCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "newsletter_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "newsletterCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "partner_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "partnerCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "search_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "service_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "benefit_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "speedBlock_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "story_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "storyCollection_Entry",
          // The element’s title.
          title: string | null,
        }
      ) >,
      menuDropdownType: string | null,
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The element’s title.
          title: string | null,
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              // The ID of the entity
              id: string | null,
              // The element’s title.
              title: string | null,
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "partnerContactRequest_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "internal_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "networkContactRequest_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "wishlist_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "registration_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "document_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "country_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "documentation_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "intro_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "text_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "textWithImage_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "image_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "graphic_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "video_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "audio_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "table_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "codeSnippet_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "contactForm_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "logos_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "button_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "sectionEnding_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "users_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "trafficGraph_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "applicationForm_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "registrationForm_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "event_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "eventCollection_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "exchangePage_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "footerLink_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "getStarted_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "graph_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "info_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "menu_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "network_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "networkConnection_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "news_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "newsCollection_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "newsletter_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "newsletterCollection_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "partner_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "partnerCollection_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "search_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "service_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "benefit_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "speedBlock_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "story_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "storyCollection_Entry",
                  // The element’s URI.
                  uri: string | null,
                }
              ) | null >,
              externalLink: string | null,
              // The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query.
              ancestors:  Array<( {
                  __typename: "city_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "partnerContactRequest_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "internal_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "networkContactRequest_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "wishlist_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "registration_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "document_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "country_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "documentation_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "intro_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "text_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "textWithImage_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "image_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "graphic_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "video_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "audio_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "table_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "codeSnippet_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "contactForm_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "logos_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "button_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "sectionEnding_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "users_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "trafficGraph_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "applicationForm_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "registrationForm_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "event_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "eventCollection_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "exchangePage_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "footerLink_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "getStarted_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "graph_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "info_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "menu_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "network_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "networkConnection_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "news_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "newsCollection_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "newsletter_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "newsletterCollection_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "partner_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "partnerCollection_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "search_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "service_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "benefit_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "speedBlock_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "story_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "storyCollection_Entry",
                  // The element’s title.
                  title: string | null,
                }
              ) >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null > | null,
  menuConfig:  {
    __typename: "MenuConfig",
    scheme: MenuScheme | null,
  },
  // This query is used to query for global sets.
  globalSets:  Array<( {
      __typename: "commitmentModule_GlobalSet",
    } | {
      __typename: "email_GlobalSet",
    } | {
      __typename: "exchangeConfig_GlobalSet",
      loginUrl: string | null,
      mailChimpSubscriptionUrl: string | null,
      footerContactFormText:  {
        __typename: "footerContactFormText_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "globalStats_GlobalSet",
    } | {
      __typename: "glossary_GlobalSet",
    } | {
      __typename: "modalSettings_GlobalSet",
      showModal: boolean | null,
      modalTitle: string | null,
      modalText: string | null,
      modalEntry:  Array<( {
          __typename: "city_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "connectedNetworkCollection_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerContactRequest_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "internal_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkContactRequest_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "wishlist_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registration_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "document_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "country_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "documentation_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "intro_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "text_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "textWithImage_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "image_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graphic_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "video_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "audio_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "table_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "codeSnippet_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "contactForm_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "logos_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "button_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "sectionEnding_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "users_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "trafficGraph_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "applicationForm_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "event_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "eventCollection_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "exchangePage_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "footerLink_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "getStarted_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graph_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "info_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "menu_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "network_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkConnection_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "news_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsCollection_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletter_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletterCollection_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partner_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerCollection_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "search_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "service_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "benefit_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "speedBlock_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "story_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "storyCollection_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
        }
      ) | null >,
    } | {
      __typename: "smartSnippets_GlobalSet",
    } | {
      __typename: "socialMedia_GlobalSet",
      facebookUrl: string | null,
      linkedinUrl: string | null,
      twitterUrl: string | null,
      youtubeUrl: string | null,
    }
  ) | null > | null,
  // This query is used to query for entries.
  footerLinks:  Array<( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s title.
      title: string | null,
      linkEntry:  Array<( {
          __typename: "city_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "connectedNetworkCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "internal_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "wishlist_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registration_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "document_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "country_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "documentation_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "intro_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "text_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "textWithImage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "image_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graphic_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "video_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "audio_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "table_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "codeSnippet_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "contactForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "logos_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "button_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "sectionEnding_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "users_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "trafficGraph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "applicationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "event_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "eventCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "exchangePage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "footerLink_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "getStarted_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "info_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "menu_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "network_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkConnection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "news_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletter_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletterCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partner_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "search_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "service_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "benefit_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "speedBlock_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "story_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "storyCollection_Entry",
          // The element’s URI.
          uri: string | null,
        }
      ) | null >,
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null > | null,
};

export interface GetStartedQueryVariables {
  exchange?: Array< string > | null,
};

export interface GetStartedQuery {
  // This query is used to query for a single entry.
  entry: ( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
      linkEntry:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
          // The element’s title.
          title: string | null,
          description:  {
            __typename: "description_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
          contentBlocks:  Array<( {
              __typename: "intro_Entry",
              // The ID of the entity
              id: string | null,
              heading: string | null,
              textHTML:  {
                __typename: "text_CkeditorField",
                // The parsed content as HTML.
                html: string | null,
              } | null,
            } | {
              __typename: "text_Entry",
              // The ID of the entity
              id: string | null,
              heading: string | null,
              textHTML:  {
                __typename: "text2_CkeditorField",
                // The parsed content as HTML.
                html: string | null,
              } | null,
            } | {
              __typename: "textWithImage_Entry",
              image:  Array<( {
                  __typename: "images_Asset",
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcSmall: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthSmall: number | null,
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcMedium: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthMedium: number | null,
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcLarge: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthLarge: number | null,
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "uploadAssets_Asset",
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcSmall: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthSmall: number | null,
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcMedium: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthMedium: number | null,
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcLarge: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthLarge: number | null,
                  // The element’s title.
                  title: string | null,
                }
              ) | null >,
              heading: string | null,
              textHTML:  {
                __typename: "text3_CkeditorField",
                // The parsed content as HTML.
                html: string | null,
              } | null,
              imageAlignment: string | null,
            } | {
              __typename: "image_Entry",
              image:  Array<( {
                  __typename: "images_Asset",
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  urlSmall: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthSmall: number | null,
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  urlMedium: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthMedium: number | null,
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  urlLarge: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthLarge: number | null,
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "uploadAssets_Asset",
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  urlSmall: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthSmall: number | null,
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  urlMedium: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthMedium: number | null,
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  urlLarge: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthLarge: number | null,
                  // The element’s title.
                  title: string | null,
                }
              ) | null >,
              heading: string | null,
              text: string | null,
              buttonText: string | null,
              buttonLink:  Array<( {
                  __typename: "city_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "partnerContactRequest_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "internal_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "networkContactRequest_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "wishlist_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "registration_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "document_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "country_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "documentation_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "intro_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "text_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "textWithImage_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "image_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "graphic_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "video_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "audio_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "table_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "codeSnippet_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "contactForm_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "logos_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "button_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "sectionEnding_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "users_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "trafficGraph_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "applicationForm_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "registrationForm_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "event_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "eventCollection_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "exchangePage_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "footerLink_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "getStarted_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "graph_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "info_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "menu_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "network_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "networkConnection_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "news_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "newsCollection_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "newsletter_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "newsletterCollection_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "partner_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "partnerCollection_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "search_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "service_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "benefit_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "speedBlock_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "story_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "storyCollection_Entry",
                  // The element’s URI.
                  uri: string | null,
                }
              ) | null >,
              textAlignment: string | null,
            } | {
              __typename: "graphic_Entry",
              image:  Array<( {
                  __typename: "images_Asset",
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcSmall: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthSmall: number | null,
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcMedium: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthMedium: number | null,
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcLarge: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthLarge: number | null,
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcOriginal: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthOriginal: number | null,
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "uploadAssets_Asset",
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcSmall: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthSmall: number | null,
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcMedium: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthMedium: number | null,
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcLarge: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthLarge: number | null,
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcOriginal: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthOriginal: number | null,
                  // The element’s title.
                  title: string | null,
                }
              ) | null >,
            } | {
              __typename: "video_Entry",
              videoUrl: string | null,
            } | {
              __typename: "audio_Entry",
              podcastUrl: string | null,
              podcastDescription: string | null,
            } | {
              __typename: "table_Entry",
              heading: string | null,
              table:  {
                __typename: "table_CkeditorField",
                // The parsed content as HTML.
                html: string | null,
              } | null,
            } | {
              __typename: "codeSnippet_Entry",
              programmingLanguage: string | null,
              snippet:  {
                __typename: "snippet_CkeditorField",
                // The parsed content as HTML.
                html: string | null,
              } | null,
            } | {
              __typename: "contactForm_Entry",
              // The ID of the entity
              id: string | null,
              ctaText: string | null,
              buttonText: string | null,
              compactDisplay: boolean | null,
              documentUpload: boolean | null,
              description:  {
                __typename: "description3_CkeditorField",
                // The parsed content as HTML.
                html: string | null,
              } | null,
            } | {
              __typename: "logos_Entry",
              logos:  Array<( {
                  __typename: "images_Asset",
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  src: string | null,
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  src2x: string | null,
                  // The element’s title.
                  title: string | null,
                  // The ID of the entity
                  id: string | null,
                } | {
                  __typename: "uploadAssets_Asset",
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  src: string | null,
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  src2x: string | null,
                  // The element’s title.
                  title: string | null,
                  // The ID of the entity
                  id: string | null,
                }
              ) | null >,
            } | {
              __typename: "button_Entry",
              // The ID of the entity
              id: string | null,
              label: string | null,
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "partnerContactRequest_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "internal_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "networkContactRequest_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "wishlist_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "registration_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "document_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "country_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "documentation_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "intro_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "text_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "textWithImage_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "image_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "graphic_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "video_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "audio_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "table_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "codeSnippet_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "contactForm_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "logos_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "button_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "sectionEnding_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "users_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "trafficGraph_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "applicationForm_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "registrationForm_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "event_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "eventCollection_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "exchangePage_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "footerLink_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "getStarted_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "graph_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "info_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "menu_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "network_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "networkConnection_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "news_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "newsCollection_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "newsletter_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "newsletterCollection_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "partner_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "partnerCollection_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "search_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "service_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "benefit_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "speedBlock_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "story_Entry",
                  // The element’s URI.
                  uri: string | null,
                } | {
                  __typename: "storyCollection_Entry",
                  // The element’s URI.
                  uri: string | null,
                }
              ) | null >,
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
              // The ID of the entity
              id: string | null,
              heading: string | null,
              users:  Array<( {
                  __typename: "User",
                  // The user’s full name.
                  fullName: string | null,
                  functionTitle: string | null,
                  // The user’s photo.
                  photo: ( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                    }
                  ) | null,
                }
              ) | null >,
            } | {
              __typename: "trafficGraph_Entry",
              // The ID of the entity
              id: string | null,
              dataset:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                  // The element’s title.
                  title: string | null,
                  interval: string | null,
                  peakIn: string | null,
                  peakOut: string | null,
                  averageIn: string | null,
                  averageOut: string | null,
                  currentIn: string | null,
                  currentOut: string | null,
                  averageInputData:  Array< {
                    __typename: "averageInputData_TableRow",
                    time: string | null,
                    value: string | null,
                  } | null > | null,
                  averageOutputData:  Array< {
                    __typename: "averageOutputData_TableRow",
                    time: string | null,
                    value: string | null,
                  } | null > | null,
                  peakOutputData:  Array< {
                    __typename: "peakOutputData_TableRow",
                    time: string | null,
                    value: string | null,
                  } | null > | null,
                  peakInputData:  Array< {
                    __typename: "peakInputData_TableRow",
                    time: string | null,
                    value: string | null,
                  } | null > | null,
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "applicationForm_Entry",
              // The ID of the entity
              id: string | null,
              buttonText: string | null,
              applicationType: string | null,
            } | {
              __typename: "registrationForm_Entry",
              // The ID of the entity
              id: string | null,
              ctaText: string | null,
              buttonText: string | null,
              compactDisplay: boolean | null,
              description:  {
                __typename: "description4_CkeditorField",
                // The parsed content as HTML.
                html: string | null,
              } | null,
            }
          ) | null >,
          relatedItems:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
              // The ID of the entity
              id: string | null,
              // The element’s URI.
              uri: string | null,
              // The element’s title.
              title: string | null,
              // The entry’s post date.
              postDate: string | null,
              relatedItemImage:  Array<( {
                  __typename: "images_Asset",
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcSmall: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthSmall: number | null,
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcMedium: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthMedium: number | null,
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcLarge: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthLarge: number | null,
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "uploadAssets_Asset",
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcSmall: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthSmall: number | null,
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcMedium: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthMedium: number | null,
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcLarge: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthLarge: number | null,
                  // The element’s title.
                  title: string | null,
                }
              ) | null >,
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
              // The ID of the entity
              id: string | null,
              // The element’s URI.
              uri: string | null,
              // The element’s title.
              title: string | null,
              // The entry’s post date.
              postDate: string | null,
              heroImage:  Array<( {
                  __typename: "images_Asset",
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcSmall: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthSmall: number | null,
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcMedium: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthMedium: number | null,
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcLarge: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthLarge: number | null,
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "uploadAssets_Asset",
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcSmall: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthSmall: number | null,
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcMedium: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthMedium: number | null,
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcLarge: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthLarge: number | null,
                  // The element’s title.
                  title: string | null,
                }
              ) | null >,
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
              // The ID of the entity
              id: string | null,
              // The element’s URI.
              uri: string | null,
              // The element’s title.
              title: string | null,
              // The entry’s post date.
              postDate: string | null,
              relatedItemImage:  Array<( {
                  __typename: "images_Asset",
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcSmall: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthSmall: number | null,
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcMedium: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthMedium: number | null,
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcLarge: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthLarge: number | null,
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "uploadAssets_Asset",
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcSmall: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthSmall: number | null,
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcMedium: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthMedium: number | null,
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcLarge: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthLarge: number | null,
                  // The element’s title.
                  title: string | null,
                }
              ) | null >,
            } | {
              __typename: "menu_Entry",
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
              // The ID of the entity
              id: string | null,
              // The element’s URI.
              uri: string | null,
              // The element’s title.
              title: string | null,
              // The entry’s post date.
              postDate: string | null,
              heroImage:  Array<( {
                  __typename: "images_Asset",
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcSmall: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthSmall: number | null,
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcMedium: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthMedium: number | null,
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcLarge: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthLarge: number | null,
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "uploadAssets_Asset",
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcSmall: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthSmall: number | null,
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcMedium: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthMedium: number | null,
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcLarge: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthLarge: number | null,
                  // The element’s title.
                  title: string | null,
                }
              ) | null >,
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
              // The ID of the entity
              id: string | null,
              // The element’s URI.
              uri: string | null,
              // The element’s title.
              title: string | null,
              // The entry’s post date.
              postDate: string | null,
              relatedItemImage:  Array<( {
                  __typename: "images_Asset",
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcSmall: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthSmall: number | null,
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcMedium: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthMedium: number | null,
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcLarge: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthLarge: number | null,
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "uploadAssets_Asset",
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcSmall: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthSmall: number | null,
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcMedium: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthMedium: number | null,
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcLarge: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthLarge: number | null,
                  // The element’s title.
                  title: string | null,
                }
              ) | null >,
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
              // The ID of the entity
              id: string | null,
              // The element’s URI.
              uri: string | null,
              // The element’s title.
              title: string | null,
              // The entry’s post date.
              postDate: string | null,
              heroImage:  Array<( {
                  __typename: "images_Asset",
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcSmall: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthSmall: number | null,
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcMedium: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthMedium: number | null,
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcLarge: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthLarge: number | null,
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "uploadAssets_Asset",
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcSmall: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthSmall: number | null,
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcMedium: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthMedium: number | null,
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  srcLarge: string | null,
                  // The width in pixels or null if it’s not an image.
                  widthLarge: number | null,
                  // The element’s title.
                  title: string | null,
                }
              ) | null >,
              service:  Array<( {
                  __typename: "city_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "partnerContactRequest_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "internal_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "networkContactRequest_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "wishlist_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "registration_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "document_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "country_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "documentation_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "intro_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "text_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "textWithImage_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "image_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "graphic_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "video_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "audio_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "table_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "codeSnippet_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "contactForm_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "logos_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "button_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "sectionEnding_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "users_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "trafficGraph_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "applicationForm_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "registrationForm_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "event_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "eventCollection_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "exchangePage_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "footerLink_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "getStarted_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "graph_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "info_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "menu_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "network_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "networkConnection_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "news_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "newsCollection_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "newsletter_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "newsletterCollection_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "partner_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "partnerCollection_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "search_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "service_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "benefit_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "speedBlock_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "story_Entry",
                  // The element’s title.
                  title: string | null,
                } | {
                  __typename: "storyCollection_Entry",
                  // The element’s title.
                  title: string | null,
                }
              ) | null >,
            } | {
              __typename: "storyCollection_Entry",
            }
          ) | null >,
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) | null >,
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null,
};

export interface GlossaryQueryVariables {
  exchange?: Array< string > | null,
};

export interface GlossaryQuery {
  // This query is used to query for global sets.
  globalSets:  Array<( {
      __typename: "commitmentModule_GlobalSet",
      // The name of the global set.
      name: string,
    } | {
      __typename: "email_GlobalSet",
      // The name of the global set.
      name: string,
    } | {
      __typename: "exchangeConfig_GlobalSet",
      // The name of the global set.
      name: string,
    } | {
      __typename: "globalStats_GlobalSet",
      // The name of the global set.
      name: string,
    } | {
      __typename: "glossary_GlobalSet",
      // The name of the global set.
      name: string,
      glossaryTable:  Array< {
        __typename: "glossaryTable_TableRow",
        word: string | null,
        meaning: string | null,
      } | null > | null,
    } | {
      __typename: "modalSettings_GlobalSet",
      // The name of the global set.
      name: string,
    } | {
      __typename: "smartSnippets_GlobalSet",
      // The name of the global set.
      name: string,
    } | {
      __typename: "socialMedia_GlobalSet",
      // The name of the global set.
      name: string,
    }
  ) | null > | null,
};

export interface HomeQueryVariables {
  site?: Array< string > | null,
};

export interface HomeQuery {
  // This query is used to query for entries.
  exchangePage:  Array<( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
      contactFormText:  {
        __typename: "contactFormText_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
      contactBlockCtaText:  {
        __typename: "contactBlockCtaText_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null > | null,
};

export interface InfoQueryVariables {
  exchange?: Array< string > | null,
  slug?: Array< string > | null,
};

export interface InfoQuery {
  // This query is used to query for a single entry.
  entry: ( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
      // The element’s title.
      title: string | null,
      description:  {
        __typename: "description_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
      contentBlocks:  Array<( {
          __typename: "intro_Entry",
          // The ID of the entity
          id: string | null,
          heading: string | null,
          textHTML:  {
            __typename: "text_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        } | {
          __typename: "text_Entry",
          // The ID of the entity
          id: string | null,
          heading: string | null,
          textHTML:  {
            __typename: "text2_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        } | {
          __typename: "textWithImage_Entry",
          image:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
          heading: string | null,
          textHTML:  {
            __typename: "text3_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
          imageAlignment: string | null,
        } | {
          __typename: "image_Entry",
          image:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
          heading: string | null,
          text: string | null,
          buttonText: string | null,
          buttonLink:  Array<( {
              __typename: "city_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "connectedNetworkCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partnerContactRequest_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "internal_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "networkContactRequest_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "wishlist_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "registration_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "document_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "country_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "documentation_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "intro_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "text_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "textWithImage_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "image_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "graphic_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "video_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "audio_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "table_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "codeSnippet_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "contactForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "logos_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "button_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "sectionEnding_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "users_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "trafficGraph_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "applicationForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "registrationForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "event_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "eventCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "exchangePage_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "footerLink_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "getStarted_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "graph_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "info_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "menu_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "network_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "networkConnection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "news_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsletter_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsletterCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partner_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partnerCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "search_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "service_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "benefit_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "speedBlock_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "story_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "storyCollection_Entry",
              // The element’s URI.
              uri: string | null,
            }
          ) | null >,
          textAlignment: string | null,
        } | {
          __typename: "graphic_Entry",
          image:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcOriginal: string | null,
              // The width in pixels or null if it’s not an image.
              widthOriginal: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcOriginal: string | null,
              // The width in pixels or null if it’s not an image.
              widthOriginal: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "video_Entry",
          videoUrl: string | null,
        } | {
          __typename: "audio_Entry",
          podcastUrl: string | null,
          podcastDescription: string | null,
        } | {
          __typename: "table_Entry",
          heading: string | null,
          table:  {
            __typename: "table_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        } | {
          __typename: "codeSnippet_Entry",
          programmingLanguage: string | null,
          snippet:  {
            __typename: "snippet_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        } | {
          __typename: "contactForm_Entry",
          // The ID of the entity
          id: string | null,
          ctaText: string | null,
          buttonText: string | null,
          compactDisplay: boolean | null,
          documentUpload: boolean | null,
          description:  {
            __typename: "description3_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        } | {
          __typename: "logos_Entry",
          logos:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              src: string | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              src2x: string | null,
              // The element’s title.
              title: string | null,
              // The ID of the entity
              id: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              src: string | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              src2x: string | null,
              // The element’s title.
              title: string | null,
              // The ID of the entity
              id: string | null,
            }
          ) | null >,
        } | {
          __typename: "button_Entry",
          // The ID of the entity
          id: string | null,
          label: string | null,
          linkEntry:  Array<( {
              __typename: "city_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "connectedNetworkCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partnerContactRequest_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "internal_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "networkContactRequest_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "wishlist_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "registration_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "document_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "country_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "documentation_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "intro_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "text_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "textWithImage_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "image_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "graphic_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "video_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "audio_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "table_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "codeSnippet_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "contactForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "logos_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "button_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "sectionEnding_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "users_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "trafficGraph_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "applicationForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "registrationForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "event_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "eventCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "exchangePage_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "footerLink_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "getStarted_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "graph_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "info_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "menu_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "network_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "networkConnection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "news_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsletter_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsletterCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partner_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partnerCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "search_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "service_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "benefit_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "speedBlock_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "story_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "storyCollection_Entry",
              // The element’s URI.
              uri: string | null,
            }
          ) | null >,
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
          // The ID of the entity
          id: string | null,
          heading: string | null,
          users:  Array<( {
              __typename: "User",
              // The user’s full name.
              fullName: string | null,
              functionTitle: string | null,
              // The user’s photo.
              photo: ( {
                  __typename: "images_Asset",
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  url: string | null,
                } | {
                  __typename: "uploadAssets_Asset",
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  url: string | null,
                }
              ) | null,
            }
          ) | null >,
        } | {
          __typename: "trafficGraph_Entry",
          // The ID of the entity
          id: string | null,
          dataset:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
              // The element’s title.
              title: string | null,
              interval: string | null,
              peakIn: string | null,
              peakOut: string | null,
              averageIn: string | null,
              averageOut: string | null,
              currentIn: string | null,
              currentOut: string | null,
              averageInputData:  Array< {
                __typename: "averageInputData_TableRow",
                time: string | null,
                value: string | null,
              } | null > | null,
              averageOutputData:  Array< {
                __typename: "averageOutputData_TableRow",
                time: string | null,
                value: string | null,
              } | null > | null,
              peakOutputData:  Array< {
                __typename: "peakOutputData_TableRow",
                time: string | null,
                value: string | null,
              } | null > | null,
              peakInputData:  Array< {
                __typename: "peakInputData_TableRow",
                time: string | null,
                value: string | null,
              } | null > | null,
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) | null >,
        } | {
          __typename: "applicationForm_Entry",
          // The ID of the entity
          id: string | null,
          buttonText: string | null,
          applicationType: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The ID of the entity
          id: string | null,
          ctaText: string | null,
          buttonText: string | null,
          compactDisplay: boolean | null,
          description:  {
            __typename: "description4_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        }
      ) | null >,
      relatedItems:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          relatedItemImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          heroImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          relatedItemImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "menu_Entry",
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          heroImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          relatedItemImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          heroImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
          service:  Array<( {
              __typename: "city_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "connectedNetworkCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "partnerContactRequest_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "internal_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "networkContactRequest_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "wishlist_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "registration_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "document_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "country_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "documentation_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "intro_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "text_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "textWithImage_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "image_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "graphic_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "video_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "audio_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "table_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "codeSnippet_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "contactForm_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "logos_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "button_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "sectionEnding_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "users_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "trafficGraph_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "applicationForm_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "registrationForm_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "event_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "eventCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "exchangePage_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "footerLink_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "getStarted_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "graph_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "info_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "menu_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "network_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "networkConnection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "news_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "newsCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "newsletter_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "newsletterCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "partner_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "partnerCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "search_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "service_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "benefit_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "speedBlock_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "story_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "storyCollection_Entry",
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "storyCollection_Entry",
        }
      ) | null >,
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null,
};

export interface SingleNewsPageQueryVariables {
  exchange?: Array< string > | null,
  slug?: Array< string > | null,
};

export interface SingleNewsPageQuery {
  // This query is used to query for a single entry.
  entry: ( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
      // The element’s title.
      title: string | null,
      description:  {
        __typename: "description_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
      // The entry’s post date.
      postDate: string | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The width in pixels or null if it’s not an image.
          width: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The width in pixels or null if it’s not an image.
          width2x: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The width in pixels or null if it’s not an image.
          width: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The width in pixels or null if it’s not an image.
          width2x: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      // The primary entry author.
      author: ( {
          __typename: "User",
          // The user’s full name or username.
          name: string,
          functionTitle: string | null,
          // The user’s photo.
          photo: ( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              url: string | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              url: string | null,
              // The element’s title.
              title: string | null,
            }
          ) | null,
        }
      ) | null,
      contentBlocks:  Array<( {
          __typename: "intro_Entry",
          // The ID of the entity
          id: string | null,
          heading: string | null,
          textHTML:  {
            __typename: "text_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        } | {
          __typename: "text_Entry",
          // The ID of the entity
          id: string | null,
          heading: string | null,
          textHTML:  {
            __typename: "text2_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        } | {
          __typename: "textWithImage_Entry",
          image:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
          heading: string | null,
          textHTML:  {
            __typename: "text3_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
          imageAlignment: string | null,
        } | {
          __typename: "image_Entry",
          image:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
          heading: string | null,
          text: string | null,
          buttonText: string | null,
          buttonLink:  Array<( {
              __typename: "city_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "connectedNetworkCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partnerContactRequest_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "internal_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "networkContactRequest_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "wishlist_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "registration_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "document_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "country_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "documentation_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "intro_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "text_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "textWithImage_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "image_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "graphic_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "video_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "audio_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "table_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "codeSnippet_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "contactForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "logos_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "button_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "sectionEnding_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "users_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "trafficGraph_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "applicationForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "registrationForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "event_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "eventCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "exchangePage_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "footerLink_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "getStarted_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "graph_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "info_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "menu_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "network_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "networkConnection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "news_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsletter_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsletterCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partner_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partnerCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "search_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "service_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "benefit_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "speedBlock_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "story_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "storyCollection_Entry",
              // The element’s URI.
              uri: string | null,
            }
          ) | null >,
          textAlignment: string | null,
        } | {
          __typename: "graphic_Entry",
          image:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcOriginal: string | null,
              // The width in pixels or null if it’s not an image.
              widthOriginal: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcOriginal: string | null,
              // The width in pixels or null if it’s not an image.
              widthOriginal: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "video_Entry",
          videoUrl: string | null,
        } | {
          __typename: "audio_Entry",
          podcastUrl: string | null,
          podcastDescription: string | null,
        } | {
          __typename: "table_Entry",
          heading: string | null,
          table:  {
            __typename: "table_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        } | {
          __typename: "codeSnippet_Entry",
          programmingLanguage: string | null,
          snippet:  {
            __typename: "snippet_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        } | {
          __typename: "contactForm_Entry",
          // The ID of the entity
          id: string | null,
          ctaText: string | null,
          buttonText: string | null,
          compactDisplay: boolean | null,
          documentUpload: boolean | null,
          description:  {
            __typename: "description3_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        } | {
          __typename: "logos_Entry",
          logos:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              src: string | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              src2x: string | null,
              // The element’s title.
              title: string | null,
              // The ID of the entity
              id: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              src: string | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              src2x: string | null,
              // The element’s title.
              title: string | null,
              // The ID of the entity
              id: string | null,
            }
          ) | null >,
        } | {
          __typename: "button_Entry",
          // The ID of the entity
          id: string | null,
          label: string | null,
          linkEntry:  Array<( {
              __typename: "city_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "connectedNetworkCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partnerContactRequest_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "internal_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "networkContactRequest_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "wishlist_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "registration_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "document_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "country_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "documentation_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "intro_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "text_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "textWithImage_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "image_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "graphic_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "video_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "audio_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "table_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "codeSnippet_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "contactForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "logos_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "button_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "sectionEnding_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "users_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "trafficGraph_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "applicationForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "registrationForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "event_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "eventCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "exchangePage_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "footerLink_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "getStarted_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "graph_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "info_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "menu_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "network_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "networkConnection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "news_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsletter_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsletterCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partner_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partnerCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "search_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "service_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "benefit_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "speedBlock_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "story_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "storyCollection_Entry",
              // The element’s URI.
              uri: string | null,
            }
          ) | null >,
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
          // The ID of the entity
          id: string | null,
          heading: string | null,
          users:  Array<( {
              __typename: "User",
              // The user’s full name.
              fullName: string | null,
              functionTitle: string | null,
              // The user’s photo.
              photo: ( {
                  __typename: "images_Asset",
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  url: string | null,
                } | {
                  __typename: "uploadAssets_Asset",
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  url: string | null,
                }
              ) | null,
            }
          ) | null >,
        } | {
          __typename: "trafficGraph_Entry",
          // The ID of the entity
          id: string | null,
          dataset:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
              // The element’s title.
              title: string | null,
              interval: string | null,
              peakIn: string | null,
              peakOut: string | null,
              averageIn: string | null,
              averageOut: string | null,
              currentIn: string | null,
              currentOut: string | null,
              averageInputData:  Array< {
                __typename: "averageInputData_TableRow",
                time: string | null,
                value: string | null,
              } | null > | null,
              averageOutputData:  Array< {
                __typename: "averageOutputData_TableRow",
                time: string | null,
                value: string | null,
              } | null > | null,
              peakOutputData:  Array< {
                __typename: "peakOutputData_TableRow",
                time: string | null,
                value: string | null,
              } | null > | null,
              peakInputData:  Array< {
                __typename: "peakInputData_TableRow",
                time: string | null,
                value: string | null,
              } | null > | null,
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) | null >,
        } | {
          __typename: "applicationForm_Entry",
          // The ID of the entity
          id: string | null,
          buttonText: string | null,
          applicationType: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The ID of the entity
          id: string | null,
          ctaText: string | null,
          buttonText: string | null,
          compactDisplay: boolean | null,
          description:  {
            __typename: "description4_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        }
      ) | null >,
      relatedItems:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          relatedItemImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          heroImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          relatedItemImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "menu_Entry",
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          heroImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          relatedItemImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          heroImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
          service:  Array<( {
              __typename: "city_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "connectedNetworkCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "partnerContactRequest_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "internal_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "networkContactRequest_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "wishlist_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "registration_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "document_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "country_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "documentation_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "intro_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "text_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "textWithImage_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "image_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "graphic_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "video_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "audio_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "table_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "codeSnippet_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "contactForm_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "logos_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "button_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "sectionEnding_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "users_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "trafficGraph_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "applicationForm_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "registrationForm_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "event_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "eventCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "exchangePage_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "footerLink_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "getStarted_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "graph_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "info_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "menu_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "network_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "networkConnection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "news_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "newsCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "newsletter_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "newsletterCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "partner_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "partnerCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "search_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "service_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "benefit_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "speedBlock_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "story_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "storyCollection_Entry",
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "storyCollection_Entry",
        }
      ) | null >,
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null,
};

export interface PartnersQueryVariables {
  exchange?: Array< string > | null,
  country?: Array< string | null > | null,
  city?: Array< string | null > | null,
  search?: string | null,
  partnerType?: Array< string | null > | null,
};

export interface PartnersQuery {
  // This query is used to query for a single entry.
  partnerPage: ( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
      // The element’s title.
      title: string | null,
      introHeading: string | null,
      introText:  {
        __typename: "introText_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null,
  // This query is used to query for entries.
  partnersTable:  Array<( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s title.
      title: string | null,
      datacenter: string | null,
      city: string | null,
      country: string | null,
      partnerType: string | null,
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null > | null,
  // This query is used to query for entries.
  countries:  Array<( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "documentation_Entry",
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null > | null,
  // This query is used to query for entries.
  cities:  Array<( {
      __typename: "city_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null > | null,
};

export interface SearchQueryVariables {
  site?: Array< string > | null,
  offset?: number | null,
  itemLimit?: number | null,
  query?: string | null,
};

export interface SearchQuery {
  // This query is used to query for entries.
  items:  Array<( {
      __typename: "city_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "connectedNetworkCollection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "partnerContactRequest_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "internal_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "networkContactRequest_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "wishlist_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "registration_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "document_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "country_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "documentation_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      description:  {
        __typename: "description_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "intro_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "text_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "textWithImage_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "image_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "graphic_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "video_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "audio_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "table_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "codeSnippet_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "contactForm_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "logos_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "button_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "sectionEnding_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "users_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "trafficGraph_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "applicationForm_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "registrationForm_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "event_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      description:  {
        __typename: "description_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The width in pixels or null if it’s not an image.
          width: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The width in pixels or null if it’s not an image.
          width2x: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The width in pixels or null if it’s not an image.
          width: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The width in pixels or null if it’s not an image.
          width2x: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      startDate: string | null,
      endDate: string | null,
      // The entry’s post date.
      date: string | null,
      location: string | null,
    } | {
      __typename: "eventCollection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "exchangePage_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "footerLink_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "getStarted_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "graph_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "info_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      description:  {
        __typename: "description_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "menu_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "network_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "networkConnection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "news_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      description:  {
        __typename: "description_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The width in pixels or null if it’s not an image.
          width: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The width in pixels or null if it’s not an image.
          width2x: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The width in pixels or null if it’s not an image.
          width: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The width in pixels or null if it’s not an image.
          width2x: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      // The entry’s post date.
      date: string | null,
    } | {
      __typename: "newsCollection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "newsletter_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "newsletterCollection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "partner_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "partnerCollection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "search_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "service_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      description:  {
        __typename: "description_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The width in pixels or null if it’s not an image.
          width: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The width in pixels or null if it’s not an image.
          width2x: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The width in pixels or null if it’s not an image.
          width: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The width in pixels or null if it’s not an image.
          width2x: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "benefit_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "speedBlock_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "story_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      description:  {
        __typename: "description_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The width in pixels or null if it’s not an image.
          width: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The width in pixels or null if it’s not an image.
          width2x: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The width in pixels or null if it’s not an image.
          width: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The width in pixels or null if it’s not an image.
          width2x: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      // The entry’s post date.
      date: string | null,
    } | {
      __typename: "storyCollection_Entry",
      // The element’s title.
      title: string | null,
    }
  ) | null > | null,
  // This query is used to query for a single entry.
  page: ( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
      introHeading: string | null,
      introText:  {
        __typename: "introText_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "service_Entry",
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null,
};

export interface ServiceQueryVariables {
  exchange?: Array< string > | null,
  slug?: Array< string > | null,
};

export interface ServiceQuery {
  // This query is used to query for a single entry.
  service: ( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s title.
      title: string | null,
      howItWorks:  {
        __typename: "howItWorks_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
      description:  {
        __typename: "description_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
      pricing:  {
        __typename: "pricing_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
      showDurationSwitch: boolean | null,
      showContactPricing: boolean | null,
      commitmentModule:  Array<( {
          __typename: "speedBlock_Entry",
          blockTitle: string | null,
          price3Months: string | null,
          price12Months: string | null,
          price24Months: string | null,
          price36Months: string | null,
          checkmarkList:  Array< {
            __typename: "checkmarkList_TableRow",
            listItem: string | null,
          } | null > | null,
        }
      ) | null >,
      icon:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The width in pixels or null if it’s not an image.
          width: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The width in pixels or null if it’s not an image.
          width2x: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The width in pixels or null if it’s not an image.
          width: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The width in pixels or null if it’s not an image.
          width2x: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      benefits:  Array<( {
          __typename: "benefit_Entry",
          icon:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              url: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              url: string | null,
            }
          ) | null >,
          heading: string | null,
          description: string | null,
        }
      ) | null >,
      storyShowcase:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
          description:  {
            __typename: "description_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
          heroImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "storyCollection_Entry",
        }
      ) | null >,
      contactBlockCtaText:  {
        __typename: "contactBlockCtaText_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
      contactFormText:  {
        __typename: "contactFormText_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
      relatedItems:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          relatedItemImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          heroImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          relatedItemImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "menu_Entry",
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          heroImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          relatedItemImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          heroImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
          service:  Array<( {
              __typename: "city_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "connectedNetworkCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "partnerContactRequest_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "internal_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "networkContactRequest_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "wishlist_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "registration_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "document_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "country_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "documentation_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "intro_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "text_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "textWithImage_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "image_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "graphic_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "video_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "audio_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "table_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "codeSnippet_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "contactForm_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "logos_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "button_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "sectionEnding_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "users_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "trafficGraph_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "applicationForm_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "registrationForm_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "event_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "eventCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "exchangePage_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "footerLink_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "getStarted_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "graph_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "info_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "menu_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "network_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "networkConnection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "news_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "newsCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "newsletter_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "newsletterCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "partner_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "partnerCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "search_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "service_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "benefit_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "speedBlock_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "story_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "storyCollection_Entry",
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "storyCollection_Entry",
        }
      ) | null >,
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null,
};

export interface StoryQueryVariables {
  exchange?: Array< string > | null,
  slug?: Array< string > | null,
};

export interface StoryQuery {
  // This query is used to query for a single entry.
  entry: ( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
      // The element’s title.
      title: string | null,
      description:  {
        __typename: "description_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
      // The entry’s post date.
      postDate: string | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      // The primary entry author.
      author: ( {
          __typename: "User",
          // The user’s full name or username.
          name: string,
          functionTitle: string | null,
          // The user’s photo.
          photo: ( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              url: string | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              url: string | null,
              // The element’s title.
              title: string | null,
            }
          ) | null,
        }
      ) | null,
      service:  Array<( {
          __typename: "city_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "connectedNetworkCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "partnerContactRequest_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "internal_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "networkContactRequest_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "wishlist_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "registration_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "document_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "country_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "documentation_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "intro_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "text_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "textWithImage_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "image_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "graphic_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "video_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "audio_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "table_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "codeSnippet_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "contactForm_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "logos_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "button_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "sectionEnding_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "users_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "trafficGraph_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "applicationForm_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "event_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "eventCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "exchangePage_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "footerLink_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "getStarted_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "graph_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "info_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "menu_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "network_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "networkConnection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "news_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "newsCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "newsletter_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "newsletterCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "partner_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "partnerCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "search_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "service_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "benefit_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "speedBlock_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "story_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "storyCollection_Entry",
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      contentBlocks:  Array<( {
          __typename: "intro_Entry",
          // The ID of the entity
          id: string | null,
          heading: string | null,
          textHTML:  {
            __typename: "text_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        } | {
          __typename: "text_Entry",
          // The ID of the entity
          id: string | null,
          heading: string | null,
          textHTML:  {
            __typename: "text2_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        } | {
          __typename: "textWithImage_Entry",
          image:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
          heading: string | null,
          textHTML:  {
            __typename: "text3_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
          imageAlignment: string | null,
        } | {
          __typename: "image_Entry",
          image:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
          heading: string | null,
          text: string | null,
          buttonText: string | null,
          buttonLink:  Array<( {
              __typename: "city_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "connectedNetworkCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partnerContactRequest_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "internal_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "networkContactRequest_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "wishlist_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "registration_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "document_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "country_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "documentation_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "intro_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "text_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "textWithImage_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "image_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "graphic_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "video_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "audio_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "table_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "codeSnippet_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "contactForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "logos_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "button_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "sectionEnding_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "users_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "trafficGraph_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "applicationForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "registrationForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "event_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "eventCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "exchangePage_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "footerLink_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "getStarted_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "graph_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "info_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "menu_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "network_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "networkConnection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "news_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsletter_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsletterCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partner_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partnerCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "search_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "service_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "benefit_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "speedBlock_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "story_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "storyCollection_Entry",
              // The element’s URI.
              uri: string | null,
            }
          ) | null >,
          textAlignment: string | null,
        } | {
          __typename: "graphic_Entry",
          image:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcOriginal: string | null,
              // The width in pixels or null if it’s not an image.
              widthOriginal: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcOriginal: string | null,
              // The width in pixels or null if it’s not an image.
              widthOriginal: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "video_Entry",
          videoUrl: string | null,
        } | {
          __typename: "audio_Entry",
          podcastUrl: string | null,
          podcastDescription: string | null,
        } | {
          __typename: "table_Entry",
          heading: string | null,
          table:  {
            __typename: "table_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        } | {
          __typename: "codeSnippet_Entry",
          programmingLanguage: string | null,
          snippet:  {
            __typename: "snippet_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        } | {
          __typename: "contactForm_Entry",
          // The ID of the entity
          id: string | null,
          ctaText: string | null,
          buttonText: string | null,
          compactDisplay: boolean | null,
          documentUpload: boolean | null,
          description:  {
            __typename: "description3_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        } | {
          __typename: "logos_Entry",
          logos:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              src: string | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              src2x: string | null,
              // The element’s title.
              title: string | null,
              // The ID of the entity
              id: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              src: string | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              src2x: string | null,
              // The element’s title.
              title: string | null,
              // The ID of the entity
              id: string | null,
            }
          ) | null >,
        } | {
          __typename: "button_Entry",
          // The ID of the entity
          id: string | null,
          label: string | null,
          linkEntry:  Array<( {
              __typename: "city_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "connectedNetworkCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partnerContactRequest_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "internal_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "networkContactRequest_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "wishlist_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "registration_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "document_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "country_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "documentation_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "intro_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "text_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "textWithImage_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "image_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "graphic_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "video_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "audio_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "table_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "codeSnippet_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "contactForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "logos_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "button_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "sectionEnding_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "users_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "trafficGraph_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "applicationForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "registrationForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "event_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "eventCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "exchangePage_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "footerLink_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "getStarted_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "graph_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "info_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "menu_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "network_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "networkConnection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "news_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsletter_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsletterCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partner_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partnerCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "search_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "service_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "benefit_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "speedBlock_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "story_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "storyCollection_Entry",
              // The element’s URI.
              uri: string | null,
            }
          ) | null >,
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
          // The ID of the entity
          id: string | null,
          heading: string | null,
          users:  Array<( {
              __typename: "User",
              // The user’s full name.
              fullName: string | null,
              functionTitle: string | null,
              // The user’s photo.
              photo: ( {
                  __typename: "images_Asset",
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  url: string | null,
                } | {
                  __typename: "uploadAssets_Asset",
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  url: string | null,
                }
              ) | null,
            }
          ) | null >,
        } | {
          __typename: "trafficGraph_Entry",
          // The ID of the entity
          id: string | null,
          dataset:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
              // The element’s title.
              title: string | null,
              interval: string | null,
              peakIn: string | null,
              peakOut: string | null,
              averageIn: string | null,
              averageOut: string | null,
              currentIn: string | null,
              currentOut: string | null,
              averageInputData:  Array< {
                __typename: "averageInputData_TableRow",
                time: string | null,
                value: string | null,
              } | null > | null,
              averageOutputData:  Array< {
                __typename: "averageOutputData_TableRow",
                time: string | null,
                value: string | null,
              } | null > | null,
              peakOutputData:  Array< {
                __typename: "peakOutputData_TableRow",
                time: string | null,
                value: string | null,
              } | null > | null,
              peakInputData:  Array< {
                __typename: "peakInputData_TableRow",
                time: string | null,
                value: string | null,
              } | null > | null,
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) | null >,
        } | {
          __typename: "applicationForm_Entry",
          // The ID of the entity
          id: string | null,
          buttonText: string | null,
          applicationType: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The ID of the entity
          id: string | null,
          ctaText: string | null,
          buttonText: string | null,
          compactDisplay: boolean | null,
          description:  {
            __typename: "description4_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        }
      ) | null >,
      relatedItems:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          relatedItemImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          heroImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          relatedItemImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "menu_Entry",
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          heroImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          relatedItemImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          heroImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
          service:  Array<( {
              __typename: "city_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "connectedNetworkCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "partnerContactRequest_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "internal_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "networkContactRequest_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "wishlist_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "registration_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "document_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "country_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "documentation_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "intro_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "text_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "textWithImage_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "image_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "graphic_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "video_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "audio_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "table_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "codeSnippet_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "contactForm_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "logos_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "button_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "sectionEnding_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "users_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "trafficGraph_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "applicationForm_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "registrationForm_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "event_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "eventCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "exchangePage_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "footerLink_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "getStarted_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "graph_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "info_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "menu_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "network_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "networkConnection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "news_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "newsCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "newsletter_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "newsletterCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "partner_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "partnerCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "search_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "service_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "benefit_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "speedBlock_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "story_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "storyCollection_Entry",
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "storyCollection_Entry",
        }
      ) | null >,
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null,
};

export interface sendContactRequestMutationVariables {
  siteId?: number | null,
  subject?: string | null,
  comment?: string | null,
  emailAddress?: string | null,
  fullName?: string | null,
  company?: string | null,
  phoneNumber?: string | null,
  contactFormId?: string | null,
  recaptcha?: string | null,
  siteLocation?: string | null,
  authorId: string,
};

export interface sendContactRequestMutation {
  // Save a “Internal” entry in the “Contact Request” section.
  save_contactRequest_internal_Entry:  {
    __typename: "internal_Entry",
    mailSent: boolean | null,
  } | null,
};

export interface sendContactRequestDocumentMutationVariables {
  siteId?: number | null,
  comment?: string | null,
  emailAddress?: string | null,
  fullName?: string | null,
  company?: string | null,
  phoneNumber?: string | null,
  contactFormId?: string | null,
  recaptcha?: string | null,
  cv?: Array< number | null > | null,
  siteLocation?: string | null,
  authorId: string,
};

export interface sendContactRequestDocumentMutation {
  // Save a “Document” entry in the “Contact Request” section.
  save_contactRequest_document_Entry:  {
    __typename: "document_Entry",
    mailSent: boolean | null,
  } | null,
};

export interface sendContactRequestToPartnerMutationVariables {
  siteId?: number | null,
  comment?: string | null,
  emailAddress?: string | null,
  fullName?: string | null,
  company?: string | null,
  phoneNumber?: string | null,
  partner?: Array< number | null > | null,
  recaptcha?: string | null,
  siteLocation?: string | null,
  authorId: string,
};

export interface sendContactRequestToPartnerMutation {
  // Save a “Partner Contact Request” entry in the “Contact Request” section.
  save_contactRequest_partnerContactRequest_Entry:  {
    __typename: "partnerContactRequest_Entry",
    mailSent: boolean | null,
  } | null,
};

export interface sendContactRequestToNetworkMutationVariables {
  siteId?: number | null,
  comment?: string | null,
  emailAddress?: string | null,
  fullName?: string | null,
  company?: string | null,
  phoneNumber?: string | null,
  connectedNetwork?: Array< number | null > | null,
  recaptcha?: string | null,
  siteLocation?: string | null,
  authorId: string,
};

export interface sendContactRequestToNetworkMutation {
  // Save a “Network Contact Request” entry in the “Contact Request” section.
  save_contactRequest_networkContactRequest_Entry:  {
    __typename: "networkContactRequest_Entry",
    mailSent: boolean | null,
  } | null,
};

export interface sendContactRequestForWishlistMutationVariables {
  siteId?: number | null,
  subject?: string | null,
  emailAddress?: string | null,
  fullName?: string | null,
  company?: string | null,
  contactFormId?: string | null,
  recaptcha?: string | null,
  siteLocation?: string | null,
  requestedAs?: string | null,
  yourAsNumber?: string | null,
  authorId: string,
};

export interface sendContactRequestForWishlistMutation {
  // Save a “Wishlist” entry in the “Contact Request” section.
  save_contactRequest_wishlist_Entry:  {
    __typename: "wishlist_Entry",
    mailSent: boolean | null,
  } | null,
};

export interface sendContactRequestForRegistrationMutationVariables {
  siteId?: number | null,
  firstName?: string | null,
  lastName?: string | null,
  organization?: string | null,
  jobTitle?: string | null,
  workEmail?: string | null,
  contactFormId?: string | null,
  recaptcha?: string | null,
  siteLocation?: string | null,
  authorId: string,
};

export interface sendContactRequestForRegistrationMutation {
  // Save a “Registration” entry in the “Contact Request” section.
  save_contactRequest_registration_Entry:  {
    __typename: "registration_Entry",
    mailSent: boolean | null,
  } | null,
};

export interface MenuStatsQueryVariables {
  site?: Array< string > | null,
};

export interface MenuStatsQuery {
  // This query is used to query for entries.
  stats:  Array<( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
      averageInputData:  Array< {
        __typename: "averageInputData_TableRow",
        time: string | null,
        value: string | null,
      } | null > | null,
    } | {
      __typename: "info_Entry",
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null > | null,
  // This query is used to query for a single global set.
  vitals: ( {
      __typename: "commitmentModule_GlobalSet",
    } | {
      __typename: "email_GlobalSet",
    } | {
      __typename: "exchangeConfig_GlobalSet",
    } | {
      __typename: "globalStats_GlobalSet",
      currentTraffic: string | null,
      peakTraffic: string | null,
      connectedNetworks: string | null,
    } | {
      __typename: "glossary_GlobalSet",
    } | {
      __typename: "modalSettings_GlobalSet",
    } | {
      __typename: "smartSnippets_GlobalSet",
    } | {
      __typename: "socialMedia_GlobalSet",
    }
  ) | null,
};

export interface GlossaryQueryQuery {
  // This query is used to query for a single global set.
  glossary: ( {
      __typename: "commitmentModule_GlobalSet",
    } | {
      __typename: "email_GlobalSet",
    } | {
      __typename: "exchangeConfig_GlobalSet",
    } | {
      __typename: "globalStats_GlobalSet",
    } | {
      __typename: "glossary_GlobalSet",
      glossaryTable:  Array< {
        __typename: "glossaryTable_TableRow",
        word: string | null,
        meaning: string | null,
      } | null > | null,
    } | {
      __typename: "modalSettings_GlobalSet",
    } | {
      __typename: "smartSnippets_GlobalSet",
    } | {
      __typename: "socialMedia_GlobalSet",
    }
  ) | null,
};

export interface DropDownStatsQueryVariables {
  site?: Array< string > | null,
};

export interface DropDownStatsQuery {
  // This query is used to query for entries.
  dropdownStats:  Array<( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
      // The element’s title.
      title: string | null,
      interval: string | null,
      peakIn: string | null,
      peakOut: string | null,
      averageIn: string | null,
      averageOut: string | null,
      currentIn: string | null,
      currentOut: string | null,
      averageInputData:  Array< {
        __typename: "averageInputData_TableRow",
        time: string | null,
        value: string | null,
      } | null > | null,
    } | {
      __typename: "info_Entry",
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null > | null,
  // This query is used to query for a single global set.
  vitals: ( {
      __typename: "commitmentModule_GlobalSet",
    } | {
      __typename: "email_GlobalSet",
    } | {
      __typename: "exchangeConfig_GlobalSet",
    } | {
      __typename: "globalStats_GlobalSet",
      peakTraffic: string | null,
    } | {
      __typename: "glossary_GlobalSet",
    } | {
      __typename: "modalSettings_GlobalSet",
    } | {
      __typename: "smartSnippets_GlobalSet",
    } | {
      __typename: "socialMedia_GlobalSet",
    }
  ) | null,
};

export interface PinpointCardStatsQueryVariables {
  ams: string,
  car: string,
  hk: string,
  mum: string,
  kol: string,
  sin: string,
  hyd: string,
  lag: string,
  ban: string,
  dji: string,
  mnl: string,
};

export interface PinpointCardStatsQuery {
  // This query is used to query for a single global set.
  vitalsAms: ( {
      __typename: "commitmentModule_GlobalSet",
    } | {
      __typename: "email_GlobalSet",
    } | {
      __typename: "exchangeConfig_GlobalSet",
    } | {
      __typename: "globalStats_GlobalSet",
      peakTraffic: string | null,
      connectedNetworks: string | null,
    } | {
      __typename: "glossary_GlobalSet",
    } | {
      __typename: "modalSettings_GlobalSet",
    } | {
      __typename: "smartSnippets_GlobalSet",
    } | {
      __typename: "socialMedia_GlobalSet",
    }
  ) | null,
  // This query is used to query for a single global set.
  vitalsCar: ( {
      __typename: "commitmentModule_GlobalSet",
    } | {
      __typename: "email_GlobalSet",
    } | {
      __typename: "exchangeConfig_GlobalSet",
    } | {
      __typename: "globalStats_GlobalSet",
      peakTraffic: string | null,
      connectedNetworks: string | null,
    } | {
      __typename: "glossary_GlobalSet",
    } | {
      __typename: "modalSettings_GlobalSet",
    } | {
      __typename: "smartSnippets_GlobalSet",
    } | {
      __typename: "socialMedia_GlobalSet",
    }
  ) | null,
  // This query is used to query for a single global set.
  vitalsHK: ( {
      __typename: "commitmentModule_GlobalSet",
    } | {
      __typename: "email_GlobalSet",
    } | {
      __typename: "exchangeConfig_GlobalSet",
    } | {
      __typename: "globalStats_GlobalSet",
      peakTraffic: string | null,
      connectedNetworks: string | null,
    } | {
      __typename: "glossary_GlobalSet",
    } | {
      __typename: "modalSettings_GlobalSet",
    } | {
      __typename: "smartSnippets_GlobalSet",
    } | {
      __typename: "socialMedia_GlobalSet",
    }
  ) | null,
  // This query is used to query for a single global set.
  vitalsMum: ( {
      __typename: "commitmentModule_GlobalSet",
    } | {
      __typename: "email_GlobalSet",
    } | {
      __typename: "exchangeConfig_GlobalSet",
    } | {
      __typename: "globalStats_GlobalSet",
      peakTraffic: string | null,
      connectedNetworks: string | null,
    } | {
      __typename: "glossary_GlobalSet",
    } | {
      __typename: "modalSettings_GlobalSet",
    } | {
      __typename: "smartSnippets_GlobalSet",
    } | {
      __typename: "socialMedia_GlobalSet",
    }
  ) | null,
  // This query is used to query for a single global set.
  vitalsKol: ( {
      __typename: "commitmentModule_GlobalSet",
    } | {
      __typename: "email_GlobalSet",
    } | {
      __typename: "exchangeConfig_GlobalSet",
    } | {
      __typename: "globalStats_GlobalSet",
      peakTraffic: string | null,
      connectedNetworks: string | null,
    } | {
      __typename: "glossary_GlobalSet",
    } | {
      __typename: "modalSettings_GlobalSet",
    } | {
      __typename: "smartSnippets_GlobalSet",
    } | {
      __typename: "socialMedia_GlobalSet",
    }
  ) | null,
  // This query is used to query for a single global set.
  vitalsSin: ( {
      __typename: "commitmentModule_GlobalSet",
    } | {
      __typename: "email_GlobalSet",
    } | {
      __typename: "exchangeConfig_GlobalSet",
    } | {
      __typename: "globalStats_GlobalSet",
      peakTraffic: string | null,
      connectedNetworks: string | null,
    } | {
      __typename: "glossary_GlobalSet",
    } | {
      __typename: "modalSettings_GlobalSet",
    } | {
      __typename: "smartSnippets_GlobalSet",
    } | {
      __typename: "socialMedia_GlobalSet",
    }
  ) | null,
  // This query is used to query for a single global set.
  vitalsHyd: ( {
      __typename: "commitmentModule_GlobalSet",
    } | {
      __typename: "email_GlobalSet",
    } | {
      __typename: "exchangeConfig_GlobalSet",
    } | {
      __typename: "globalStats_GlobalSet",
      peakTraffic: string | null,
      connectedNetworks: string | null,
    } | {
      __typename: "glossary_GlobalSet",
    } | {
      __typename: "modalSettings_GlobalSet",
    } | {
      __typename: "smartSnippets_GlobalSet",
    } | {
      __typename: "socialMedia_GlobalSet",
    }
  ) | null,
  // This query is used to query for a single global set.
  vitalsLag: ( {
      __typename: "commitmentModule_GlobalSet",
    } | {
      __typename: "email_GlobalSet",
    } | {
      __typename: "exchangeConfig_GlobalSet",
    } | {
      __typename: "globalStats_GlobalSet",
      peakTraffic: string | null,
      connectedNetworks: string | null,
    } | {
      __typename: "glossary_GlobalSet",
    } | {
      __typename: "modalSettings_GlobalSet",
    } | {
      __typename: "smartSnippets_GlobalSet",
    } | {
      __typename: "socialMedia_GlobalSet",
    }
  ) | null,
  // This query is used to query for a single global set.
  vitalsBan: ( {
      __typename: "commitmentModule_GlobalSet",
    } | {
      __typename: "email_GlobalSet",
    } | {
      __typename: "exchangeConfig_GlobalSet",
    } | {
      __typename: "globalStats_GlobalSet",
      peakTraffic: string | null,
      connectedNetworks: string | null,
    } | {
      __typename: "glossary_GlobalSet",
    } | {
      __typename: "modalSettings_GlobalSet",
    } | {
      __typename: "smartSnippets_GlobalSet",
    } | {
      __typename: "socialMedia_GlobalSet",
    }
  ) | null,
  // This query is used to query for a single global set.
  vitalsDji: ( {
      __typename: "commitmentModule_GlobalSet",
    } | {
      __typename: "email_GlobalSet",
    } | {
      __typename: "exchangeConfig_GlobalSet",
    } | {
      __typename: "globalStats_GlobalSet",
      peakTraffic: string | null,
      connectedNetworks: string | null,
    } | {
      __typename: "glossary_GlobalSet",
    } | {
      __typename: "modalSettings_GlobalSet",
    } | {
      __typename: "smartSnippets_GlobalSet",
    } | {
      __typename: "socialMedia_GlobalSet",
    }
  ) | null,
  // This query is used to query for a single global set.
  vitalsMnl: ( {
      __typename: "commitmentModule_GlobalSet",
    } | {
      __typename: "email_GlobalSet",
    } | {
      __typename: "exchangeConfig_GlobalSet",
    } | {
      __typename: "globalStats_GlobalSet",
      peakTraffic: string | null,
      connectedNetworks: string | null,
    } | {
      __typename: "glossary_GlobalSet",
    } | {
      __typename: "modalSettings_GlobalSet",
    } | {
      __typename: "smartSnippets_GlobalSet",
    } | {
      __typename: "socialMedia_GlobalSet",
    }
  ) | null,
};

export interface StatsQueryVariables {
  site?: Array< string > | null,
};

export interface StatsQuery {
  // This query is used to query for a single entry.
  exchangePage: ( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
      numbersCtaText: string | null,
      hideColocations: boolean | null,
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null,
  // This query is used to query for a single global set.
  vitals: ( {
      __typename: "commitmentModule_GlobalSet",
    } | {
      __typename: "email_GlobalSet",
    } | {
      __typename: "exchangeConfig_GlobalSet",
    } | {
      __typename: "globalStats_GlobalSet",
      connectedNetworks: string | null,
      peakTraffic: string | null,
      colocations: string | null,
    } | {
      __typename: "glossary_GlobalSet",
    } | {
      __typename: "modalSettings_GlobalSet",
    } | {
      __typename: "smartSnippets_GlobalSet",
    } | {
      __typename: "socialMedia_GlobalSet",
    }
  ) | null,
  // This query is used to query for a single entry.
  whereToConnectPage: ( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
    } | {
      __typename: "menu_Entry",
      linkEntry:  Array<( {
          __typename: "city_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "connectedNetworkCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "internal_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "wishlist_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registration_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "document_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "country_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "documentation_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "intro_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "text_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "textWithImage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "image_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graphic_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "video_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "audio_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "table_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "codeSnippet_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "contactForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "logos_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "button_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "sectionEnding_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "users_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "trafficGraph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "applicationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "event_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "eventCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "exchangePage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "footerLink_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "getStarted_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "info_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "menu_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "network_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkConnection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "news_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletter_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletterCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partner_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "search_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "service_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "benefit_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "speedBlock_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "story_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "storyCollection_Entry",
          // The element’s URI.
          uri: string | null,
        }
      ) | null >,
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null,
};

export interface ConnectedNetworkQueryVariables {
  exchange?: Array< string > | null,
  id?: Array< string | null > | null,
};

export interface ConnectedNetworkQuery {
  // This query is used to query for a single entry.
  connectedNetwork: ( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
      connections:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
          IPv4: string | null,
          IPv6: string | null,
          Speed: string | null,
          Location: string | null,
          VLAN: string | null,
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) | null >,
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null,
};

export interface ContactSlideoverQueryVariables {
  site?: Array< string > | null,
};

export interface ContactSlideoverQuery {
  // This query is used to query for a single global set.
  exchangeConfig: ( {
      __typename: "commitmentModule_GlobalSet",
    } | {
      __typename: "email_GlobalSet",
    } | {
      __typename: "exchangeConfig_GlobalSet",
      address: string | null,
      contactInfo: string | null,
    } | {
      __typename: "globalStats_GlobalSet",
    } | {
      __typename: "glossary_GlobalSet",
    } | {
      __typename: "modalSettings_GlobalSet",
    } | {
      __typename: "smartSnippets_GlobalSet",
    } | {
      __typename: "socialMedia_GlobalSet",
    }
  ) | null,
  // This query is used to query for a single global set.
  socialMedia: ( {
      __typename: "commitmentModule_GlobalSet",
    } | {
      __typename: "email_GlobalSet",
    } | {
      __typename: "exchangeConfig_GlobalSet",
    } | {
      __typename: "globalStats_GlobalSet",
    } | {
      __typename: "glossary_GlobalSet",
    } | {
      __typename: "modalSettings_GlobalSet",
    } | {
      __typename: "smartSnippets_GlobalSet",
    } | {
      __typename: "socialMedia_GlobalSet",
      facebookUrl: string | null,
      linkedinUrl: string | null,
      twitterUrl: string | null,
      youtubeUrl: string | null,
    }
  ) | null,
  // This query is used to query for a single global set.
  email: ( {
      __typename: "commitmentModule_GlobalSet",
    } | {
      __typename: "email_GlobalSet",
      registrationEmailAdditionalSubject: string | null,
    } | {
      __typename: "exchangeConfig_GlobalSet",
    } | {
      __typename: "globalStats_GlobalSet",
    } | {
      __typename: "glossary_GlobalSet",
    } | {
      __typename: "modalSettings_GlobalSet",
    } | {
      __typename: "smartSnippets_GlobalSet",
    } | {
      __typename: "socialMedia_GlobalSet",
    }
  ) | null,
};

export interface EventsQueryVariables {
  listExpiryDate: Array< string | null >,
  site?: Array< string > | null,
};

export interface EventsQuery {
  // This query is used to query for entries.
  events:  Array<( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
      // The element’s title.
      title: string | null,
      location: string | null,
      startDate: string | null,
      endDate: string | null,
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null > | null,
  // This query is used to query for entries.
  next:  Array<( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
      // The element’s title.
      title: string | null,
      location: string | null,
      startDate: string | null,
      endDate: string | null,
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null > | null,
  // This query is used to query for entries.
  exchangePage:  Array<( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
      featuredEvent:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
          // The element’s title.
          title: string | null,
          location: string | null,
          startDate: string | null,
          endDate: string | null,
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          heroImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) | null >,
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null > | null,
};

export interface HeroQueryVariables {
  site?: Array< string > | null,
};

export interface HeroQuery {
  // This query is used to query for entries.
  exchangePage:  Array<( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
      description:  {
        __typename: "description_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null > | null,
};

export interface NewsQueryVariables {
  site?: Array< string > | null,
};

export interface NewsQuery {
  // This query is used to query for entries.
  news:  Array<( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The width in pixels or null if it’s not an image.
          width: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The width in pixels or null if it’s not an image.
          width2x: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The width in pixels or null if it’s not an image.
          width: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The width in pixels or null if it’s not an image.
          width2x: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      // The entry’s post date.
      postDate: string | null,
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null > | null,
};

export interface PricingPageQueryVariables {
  exchange?: Array< string > | null,
  slug?: Array< string > | null,
};

export interface PricingPageQuery {
  // This query is used to query for a single entry.
  service: ( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
      // The ID of the entity
      id: string | null,
      contentBlocks:  Array<( {
          __typename: "intro_Entry",
          // The ID of the entity
          id: string | null,
          heading: string | null,
          textHTML:  {
            __typename: "text_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        } | {
          __typename: "text_Entry",
          // The ID of the entity
          id: string | null,
          heading: string | null,
          textHTML:  {
            __typename: "text2_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        } | {
          __typename: "textWithImage_Entry",
          image:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
          heading: string | null,
          textHTML:  {
            __typename: "text3_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
          imageAlignment: string | null,
        } | {
          __typename: "image_Entry",
          image:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
          heading: string | null,
          text: string | null,
          buttonText: string | null,
          buttonLink:  Array<( {
              __typename: "city_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "connectedNetworkCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partnerContactRequest_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "internal_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "networkContactRequest_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "wishlist_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "registration_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "document_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "country_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "documentation_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "intro_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "text_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "textWithImage_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "image_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "graphic_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "video_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "audio_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "table_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "codeSnippet_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "contactForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "logos_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "button_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "sectionEnding_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "users_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "trafficGraph_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "applicationForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "registrationForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "event_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "eventCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "exchangePage_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "footerLink_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "getStarted_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "graph_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "info_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "menu_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "network_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "networkConnection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "news_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsletter_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsletterCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partner_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partnerCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "search_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "service_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "benefit_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "speedBlock_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "story_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "storyCollection_Entry",
              // The element’s URI.
              uri: string | null,
            }
          ) | null >,
          textAlignment: string | null,
        } | {
          __typename: "graphic_Entry",
          image:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcOriginal: string | null,
              // The width in pixels or null if it’s not an image.
              widthOriginal: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcOriginal: string | null,
              // The width in pixels or null if it’s not an image.
              widthOriginal: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "video_Entry",
          videoUrl: string | null,
        } | {
          __typename: "audio_Entry",
          podcastUrl: string | null,
          podcastDescription: string | null,
        } | {
          __typename: "table_Entry",
          heading: string | null,
          table:  {
            __typename: "table_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        } | {
          __typename: "codeSnippet_Entry",
          programmingLanguage: string | null,
          snippet:  {
            __typename: "snippet_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        } | {
          __typename: "contactForm_Entry",
          // The ID of the entity
          id: string | null,
          ctaText: string | null,
          buttonText: string | null,
          compactDisplay: boolean | null,
          documentUpload: boolean | null,
          description:  {
            __typename: "description3_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        } | {
          __typename: "logos_Entry",
          logos:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              src: string | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              src2x: string | null,
              // The element’s title.
              title: string | null,
              // The ID of the entity
              id: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              src: string | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              src2x: string | null,
              // The element’s title.
              title: string | null,
              // The ID of the entity
              id: string | null,
            }
          ) | null >,
        } | {
          __typename: "button_Entry",
          // The ID of the entity
          id: string | null,
          label: string | null,
          linkEntry:  Array<( {
              __typename: "city_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "connectedNetworkCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partnerContactRequest_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "internal_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "networkContactRequest_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "wishlist_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "registration_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "document_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "country_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "documentation_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "intro_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "text_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "textWithImage_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "image_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "graphic_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "video_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "audio_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "table_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "codeSnippet_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "contactForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "logos_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "button_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "sectionEnding_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "users_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "trafficGraph_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "applicationForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "registrationForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "event_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "eventCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "exchangePage_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "footerLink_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "getStarted_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "graph_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "info_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "menu_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "network_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "networkConnection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "news_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsletter_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsletterCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partner_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partnerCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "search_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "service_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "benefit_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "speedBlock_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "story_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "storyCollection_Entry",
              // The element’s URI.
              uri: string | null,
            }
          ) | null >,
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
          // The ID of the entity
          id: string | null,
          heading: string | null,
          users:  Array<( {
              __typename: "User",
              // The user’s full name.
              fullName: string | null,
              functionTitle: string | null,
              // The user’s photo.
              photo: ( {
                  __typename: "images_Asset",
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  url: string | null,
                } | {
                  __typename: "uploadAssets_Asset",
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  url: string | null,
                }
              ) | null,
            }
          ) | null >,
        } | {
          __typename: "trafficGraph_Entry",
          // The ID of the entity
          id: string | null,
          dataset:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
              // The element’s title.
              title: string | null,
              interval: string | null,
              peakIn: string | null,
              peakOut: string | null,
              averageIn: string | null,
              averageOut: string | null,
              currentIn: string | null,
              currentOut: string | null,
              averageInputData:  Array< {
                __typename: "averageInputData_TableRow",
                time: string | null,
                value: string | null,
              } | null > | null,
              averageOutputData:  Array< {
                __typename: "averageOutputData_TableRow",
                time: string | null,
                value: string | null,
              } | null > | null,
              peakOutputData:  Array< {
                __typename: "peakOutputData_TableRow",
                time: string | null,
                value: string | null,
              } | null > | null,
              peakInputData:  Array< {
                __typename: "peakInputData_TableRow",
                time: string | null,
                value: string | null,
              } | null > | null,
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) | null >,
        } | {
          __typename: "applicationForm_Entry",
          // The ID of the entity
          id: string | null,
          buttonText: string | null,
          applicationType: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The ID of the entity
          id: string | null,
          ctaText: string | null,
          buttonText: string | null,
          compactDisplay: boolean | null,
          description:  {
            __typename: "description4_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        }
      ) | null >,
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null,
};

export interface FeaturedStoriesQueryVariables {
  site?: Array< string > | null,
};

export interface FeaturedStoriesQuery {
  // This query is used to query for a single entry.
  exchangePage: ( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
      featuredStories:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s title.
          title: string | null,
          // The element’s URI.
          uri: string | null,
          heroImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
          description:  {
            __typename: "description_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
          service:  Array<( {
              __typename: "city_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "connectedNetworkCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "partnerContactRequest_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "internal_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "networkContactRequest_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "wishlist_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "registration_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "document_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "country_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "documentation_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "intro_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "text_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "textWithImage_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "image_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "graphic_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "video_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "audio_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "table_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "codeSnippet_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "contactForm_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "logos_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "button_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "sectionEnding_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "users_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "trafficGraph_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "applicationForm_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "registrationForm_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "event_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "eventCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "exchangePage_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "footerLink_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "getStarted_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "graph_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "info_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "menu_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "network_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "networkConnection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "news_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "newsCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "newsletter_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "newsletterCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "partner_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "partnerCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "search_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "service_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "benefit_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "speedBlock_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "story_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "storyCollection_Entry",
              // The element’s title.
              title: string | null,
            }
          ) | null >,
          // The entry’s post date.
          postDate: string | null,
        } | {
          __typename: "storyCollection_Entry",
        }
      ) | null >,
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null,
};

export interface ServiceHowItWorksQueryVariables {
  exchange?: Array< string > | null,
  slug?: Array< string > | null,
};

export interface ServiceHowItWorksQuery {
  // This query is used to query for a single entry.
  service: ( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
      // The ID of the entity
      id: string | null,
      contentBlocks:  Array<( {
          __typename: "intro_Entry",
          // The ID of the entity
          id: string | null,
          heading: string | null,
          textHTML:  {
            __typename: "text_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        } | {
          __typename: "text_Entry",
          // The ID of the entity
          id: string | null,
          heading: string | null,
          textHTML:  {
            __typename: "text2_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        } | {
          __typename: "textWithImage_Entry",
          image:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
          heading: string | null,
          textHTML:  {
            __typename: "text3_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
          imageAlignment: string | null,
        } | {
          __typename: "image_Entry",
          image:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
          heading: string | null,
          text: string | null,
          buttonText: string | null,
          buttonLink:  Array<( {
              __typename: "city_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "connectedNetworkCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partnerContactRequest_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "internal_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "networkContactRequest_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "wishlist_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "registration_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "document_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "country_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "documentation_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "intro_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "text_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "textWithImage_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "image_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "graphic_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "video_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "audio_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "table_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "codeSnippet_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "contactForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "logos_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "button_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "sectionEnding_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "users_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "trafficGraph_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "applicationForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "registrationForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "event_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "eventCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "exchangePage_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "footerLink_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "getStarted_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "graph_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "info_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "menu_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "network_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "networkConnection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "news_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsletter_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsletterCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partner_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partnerCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "search_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "service_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "benefit_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "speedBlock_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "story_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "storyCollection_Entry",
              // The element’s URI.
              uri: string | null,
            }
          ) | null >,
          textAlignment: string | null,
        } | {
          __typename: "graphic_Entry",
          image:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcOriginal: string | null,
              // The width in pixels or null if it’s not an image.
              widthOriginal: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcOriginal: string | null,
              // The width in pixels or null if it’s not an image.
              widthOriginal: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "video_Entry",
          videoUrl: string | null,
        } | {
          __typename: "audio_Entry",
          podcastUrl: string | null,
          podcastDescription: string | null,
        } | {
          __typename: "table_Entry",
          heading: string | null,
          table:  {
            __typename: "table_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        } | {
          __typename: "codeSnippet_Entry",
          programmingLanguage: string | null,
          snippet:  {
            __typename: "snippet_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        } | {
          __typename: "contactForm_Entry",
          // The ID of the entity
          id: string | null,
          ctaText: string | null,
          buttonText: string | null,
          compactDisplay: boolean | null,
          documentUpload: boolean | null,
          description:  {
            __typename: "description3_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        } | {
          __typename: "logos_Entry",
          logos:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              src: string | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              src2x: string | null,
              // The element’s title.
              title: string | null,
              // The ID of the entity
              id: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              src: string | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              src2x: string | null,
              // The element’s title.
              title: string | null,
              // The ID of the entity
              id: string | null,
            }
          ) | null >,
        } | {
          __typename: "button_Entry",
          // The ID of the entity
          id: string | null,
          label: string | null,
          linkEntry:  Array<( {
              __typename: "city_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "connectedNetworkCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partnerContactRequest_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "internal_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "networkContactRequest_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "wishlist_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "registration_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "document_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "country_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "documentation_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "intro_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "text_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "textWithImage_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "image_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "graphic_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "video_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "audio_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "table_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "codeSnippet_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "contactForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "logos_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "button_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "sectionEnding_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "users_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "trafficGraph_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "applicationForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "registrationForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "event_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "eventCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "exchangePage_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "footerLink_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "getStarted_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "graph_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "info_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "menu_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "network_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "networkConnection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "news_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsletter_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsletterCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partner_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partnerCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "search_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "service_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "benefit_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "speedBlock_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "story_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "storyCollection_Entry",
              // The element’s URI.
              uri: string | null,
            }
          ) | null >,
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
          // The ID of the entity
          id: string | null,
          heading: string | null,
          users:  Array<( {
              __typename: "User",
              // The user’s full name.
              fullName: string | null,
              functionTitle: string | null,
              // The user’s photo.
              photo: ( {
                  __typename: "images_Asset",
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  url: string | null,
                } | {
                  __typename: "uploadAssets_Asset",
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  url: string | null,
                }
              ) | null,
            }
          ) | null >,
        } | {
          __typename: "trafficGraph_Entry",
          // The ID of the entity
          id: string | null,
          dataset:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
              // The element’s title.
              title: string | null,
              interval: string | null,
              peakIn: string | null,
              peakOut: string | null,
              averageIn: string | null,
              averageOut: string | null,
              currentIn: string | null,
              currentOut: string | null,
              averageInputData:  Array< {
                __typename: "averageInputData_TableRow",
                time: string | null,
                value: string | null,
              } | null > | null,
              averageOutputData:  Array< {
                __typename: "averageOutputData_TableRow",
                time: string | null,
                value: string | null,
              } | null > | null,
              peakOutputData:  Array< {
                __typename: "peakOutputData_TableRow",
                time: string | null,
                value: string | null,
              } | null > | null,
              peakInputData:  Array< {
                __typename: "peakInputData_TableRow",
                time: string | null,
                value: string | null,
              } | null > | null,
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) | null >,
        } | {
          __typename: "applicationForm_Entry",
          // The ID of the entity
          id: string | null,
          buttonText: string | null,
          applicationType: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The ID of the entity
          id: string | null,
          ctaText: string | null,
          buttonText: string | null,
          compactDisplay: boolean | null,
          description:  {
            __typename: "description4_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        }
      ) | null >,
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null,
};

export interface ServicesQueryVariables {
  site?: Array< string > | null,
};

export interface ServicesQuery {
  // This query is used to query for a single entry.
  services: ( {
      __typename: "city_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "connectedNetworkCollection_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "partnerContactRequest_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "internal_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "networkContactRequest_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "wishlist_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "registration_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "document_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "country_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "documentation_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "intro_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "text_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "textWithImage_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "image_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "graphic_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "video_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "audio_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "table_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "codeSnippet_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "contactForm_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "logos_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "button_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "sectionEnding_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "users_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "trafficGraph_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "applicationForm_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "registrationForm_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "event_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "eventCollection_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "exchangePage_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "footerLink_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "getStarted_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "graph_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "info_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "menu_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "network_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "networkConnection_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "news_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "newsCollection_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "newsletter_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "newsletterCollection_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "partner_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "partnerCollection_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "search_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "service_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "benefit_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "speedBlock_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "story_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "storyCollection_Entry",
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
          children:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
              linkEntry:  Array<( {
                  __typename: "city_Entry",
                } | {
                  __typename: "connectedNetworkCollection_Entry",
                } | {
                  __typename: "partnerContactRequest_Entry",
                } | {
                  __typename: "internal_Entry",
                } | {
                  __typename: "networkContactRequest_Entry",
                } | {
                  __typename: "wishlist_Entry",
                } | {
                  __typename: "registration_Entry",
                } | {
                  __typename: "document_Entry",
                } | {
                  __typename: "country_Entry",
                } | {
                  __typename: "documentation_Entry",
                } | {
                  __typename: "intro_Entry",
                } | {
                  __typename: "text_Entry",
                } | {
                  __typename: "textWithImage_Entry",
                } | {
                  __typename: "image_Entry",
                } | {
                  __typename: "graphic_Entry",
                } | {
                  __typename: "video_Entry",
                } | {
                  __typename: "audio_Entry",
                } | {
                  __typename: "table_Entry",
                } | {
                  __typename: "codeSnippet_Entry",
                } | {
                  __typename: "contactForm_Entry",
                } | {
                  __typename: "logos_Entry",
                } | {
                  __typename: "button_Entry",
                } | {
                  __typename: "sectionEnding_Entry",
                } | {
                  __typename: "users_Entry",
                } | {
                  __typename: "trafficGraph_Entry",
                } | {
                  __typename: "applicationForm_Entry",
                } | {
                  __typename: "registrationForm_Entry",
                } | {
                  __typename: "event_Entry",
                } | {
                  __typename: "eventCollection_Entry",
                } | {
                  __typename: "exchangePage_Entry",
                } | {
                  __typename: "footerLink_Entry",
                } | {
                  __typename: "getStarted_Entry",
                } | {
                  __typename: "graph_Entry",
                } | {
                  __typename: "info_Entry",
                } | {
                  __typename: "menu_Entry",
                } | {
                  __typename: "network_Entry",
                } | {
                  __typename: "networkConnection_Entry",
                } | {
                  __typename: "news_Entry",
                } | {
                  __typename: "newsCollection_Entry",
                } | {
                  __typename: "newsletter_Entry",
                } | {
                  __typename: "newsletterCollection_Entry",
                } | {
                  __typename: "partner_Entry",
                } | {
                  __typename: "partnerCollection_Entry",
                } | {
                  __typename: "search_Entry",
                } | {
                  __typename: "service_Entry",
                  // The ID of the entity
                  id: string | null,
                  // The element’s title.
                  title: string | null,
                  description:  {
                    __typename: "description_CkeditorField",
                    // The parsed content as HTML.
                    html: string | null,
                  } | null,
                  // The element’s URI.
                  uri: string | null,
                  // The element’s slug.
                  slug: string | null,
                  icon:  Array<( {
                      __typename: "images_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    } | {
                      __typename: "uploadAssets_Asset",
                      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                      url: string | null,
                      // The element’s title.
                      title: string | null,
                    }
                  ) | null >,
                } | {
                  __typename: "benefit_Entry",
                } | {
                  __typename: "speedBlock_Entry",
                } | {
                  __typename: "story_Entry",
                } | {
                  __typename: "storyCollection_Entry",
                }
              ) | null >,
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    }
  ) | null,
};

export interface WishlistSlideOverQueryVariables {
  site?: Array< string > | null,
};

export interface WishlistSlideOverQuery {
  // This query is used to query for a single global set.
  exchangeConfig: ( {
      __typename: "commitmentModule_GlobalSet",
    } | {
      __typename: "email_GlobalSet",
    } | {
      __typename: "exchangeConfig_GlobalSet",
      address: string | null,
      contactInfo: string | null,
    } | {
      __typename: "globalStats_GlobalSet",
    } | {
      __typename: "glossary_GlobalSet",
    } | {
      __typename: "modalSettings_GlobalSet",
    } | {
      __typename: "smartSnippets_GlobalSet",
    } | {
      __typename: "socialMedia_GlobalSet",
    }
  ) | null,
  // This query is used to query for a single global set.
  socialMedia: ( {
      __typename: "commitmentModule_GlobalSet",
    } | {
      __typename: "email_GlobalSet",
    } | {
      __typename: "exchangeConfig_GlobalSet",
    } | {
      __typename: "globalStats_GlobalSet",
    } | {
      __typename: "glossary_GlobalSet",
    } | {
      __typename: "modalSettings_GlobalSet",
    } | {
      __typename: "smartSnippets_GlobalSet",
    } | {
      __typename: "socialMedia_GlobalSet",
      facebookUrl: string | null,
      linkedinUrl: string | null,
      twitterUrl: string | null,
      youtubeUrl: string | null,
    }
  ) | null,
};

export interface setSchemeMutationVariables {
  theme?: MenuScheme | null,
};

export interface setSchemeMutation {
  setScheme:  {
    __typename: "MenuConfig",
    scheme: MenuScheme | null,
  } | null,
};

export interface EventCollectionPageFragment {
  __typename: "eventCollection_Entry",
  introHeading: string | null,
  introText:  {
    __typename: "introText_CkeditorField",
    // The parsed content as HTML.
    html: string | null,
  } | null,
};

export interface NewsCollectionPageFragment {
  __typename: "newsCollection_Entry",
  introHeading: string | null,
  introText:  {
    __typename: "introText_CkeditorField",
    // The parsed content as HTML.
    html: string | null,
  } | null,
};

export interface StoriesCollectionPageFragment {
  __typename: "storyCollection_Entry",
  introHeading: string | null,
  introText:  {
    __typename: "introText_CkeditorField",
    // The parsed content as HTML.
    html: string | null,
  } | null,
  featuredStories:  Array<( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      description:  {
        __typename: "description_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      // The entry’s post date.
      postDate: string | null,
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null >,
};

export interface ConnectedNetworksStatsFragment {
  __typename: "globalStats_GlobalSet",
  routeserverPeers: string | null,
  connectedNetworks: string | null,
  customerPorts: string | null,
  ipv6Peers: string | null,
};

export interface ConnectedNetworkInfoFragment {
  __typename: "connectedNetworkCollection_Entry",
  // The element’s title.
  title: string | null,
  introHeading: string | null,
  introText:  {
    __typename: "introText_CkeditorField",
    // The parsed content as HTML.
    html: string | null,
  } | null,
  exportLinks:  Array< {
    __typename: "exportLinks_TableRow",
    title: string | null,
    url: string | null,
  } | null > | null,
};

export interface ConnectedNetworkkRowFragment {
  __typename: "network_Entry",
  // The ID of the entity
  id: string | null,
  // The element’s title.
  title: string | null,
  memberUrl: string | null,
  asNumber: string | null,
  peeringPolicy: string | null,
  routeserver: boolean | null,
  vlan: string | null,
  colocation: string | null,
};

export interface DocumentationFragment {
  __typename: "documentation_Entry",
  // The element’s title.
  title: string | null,
  description:  {
    __typename: "description_CkeditorField",
    // The parsed content as HTML.
    html: string | null,
  } | null,
  contentBlocks:  Array<( {
      __typename: "intro_Entry",
      // The ID of the entity
      id: string | null,
      heading: string | null,
      textHTML:  {
        __typename: "text_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "text_Entry",
      // The ID of the entity
      id: string | null,
      heading: string | null,
      textHTML:  {
        __typename: "text2_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "textWithImage_Entry",
      image:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      heading: string | null,
      textHTML:  {
        __typename: "text3_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
      imageAlignment: string | null,
    } | {
      __typename: "image_Entry",
      image:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      heading: string | null,
      text: string | null,
      buttonText: string | null,
      buttonLink:  Array<( {
          __typename: "city_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "connectedNetworkCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "internal_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "wishlist_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registration_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "document_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "country_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "documentation_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "intro_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "text_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "textWithImage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "image_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graphic_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "video_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "audio_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "table_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "codeSnippet_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "contactForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "logos_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "button_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "sectionEnding_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "users_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "trafficGraph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "applicationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "event_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "eventCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "exchangePage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "footerLink_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "getStarted_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "info_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "menu_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "network_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkConnection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "news_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletter_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletterCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partner_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "search_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "service_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "benefit_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "speedBlock_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "story_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "storyCollection_Entry",
          // The element’s URI.
          uri: string | null,
        }
      ) | null >,
      textAlignment: string | null,
    } | {
      __typename: "graphic_Entry",
      image:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcOriginal: string | null,
          // The width in pixels or null if it’s not an image.
          widthOriginal: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcOriginal: string | null,
          // The width in pixels or null if it’s not an image.
          widthOriginal: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "video_Entry",
      videoUrl: string | null,
    } | {
      __typename: "audio_Entry",
      podcastUrl: string | null,
      podcastDescription: string | null,
    } | {
      __typename: "table_Entry",
      heading: string | null,
      table:  {
        __typename: "table_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "codeSnippet_Entry",
      programmingLanguage: string | null,
      snippet:  {
        __typename: "snippet_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "contactForm_Entry",
      // The ID of the entity
      id: string | null,
      ctaText: string | null,
      buttonText: string | null,
      compactDisplay: boolean | null,
      documentUpload: boolean | null,
      description:  {
        __typename: "description3_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "logos_Entry",
      logos:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The element’s title.
          title: string | null,
          // The ID of the entity
          id: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The element’s title.
          title: string | null,
          // The ID of the entity
          id: string | null,
        }
      ) | null >,
    } | {
      __typename: "button_Entry",
      // The ID of the entity
      id: string | null,
      label: string | null,
      linkEntry:  Array<( {
          __typename: "city_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "connectedNetworkCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "internal_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "wishlist_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registration_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "document_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "country_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "documentation_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "intro_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "text_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "textWithImage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "image_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graphic_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "video_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "audio_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "table_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "codeSnippet_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "contactForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "logos_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "button_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "sectionEnding_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "users_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "trafficGraph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "applicationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "event_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "eventCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "exchangePage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "footerLink_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "getStarted_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "info_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "menu_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "network_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkConnection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "news_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletter_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletterCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partner_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "search_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "service_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "benefit_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "speedBlock_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "story_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "storyCollection_Entry",
          // The element’s URI.
          uri: string | null,
        }
      ) | null >,
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
      // The ID of the entity
      id: string | null,
      heading: string | null,
      users:  Array<( {
          __typename: "User",
          // The user’s full name.
          fullName: string | null,
          functionTitle: string | null,
          // The user’s photo.
          photo: ( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              url: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              url: string | null,
            }
          ) | null,
        }
      ) | null >,
    } | {
      __typename: "trafficGraph_Entry",
      // The ID of the entity
      id: string | null,
      dataset:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
          // The element’s title.
          title: string | null,
          interval: string | null,
          peakIn: string | null,
          peakOut: string | null,
          averageIn: string | null,
          averageOut: string | null,
          currentIn: string | null,
          currentOut: string | null,
          averageInputData:  Array< {
            __typename: "averageInputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
          averageOutputData:  Array< {
            __typename: "averageOutputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
          peakOutputData:  Array< {
            __typename: "peakOutputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
          peakInputData:  Array< {
            __typename: "peakInputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) | null >,
    } | {
      __typename: "applicationForm_Entry",
      // The ID of the entity
      id: string | null,
      buttonText: string | null,
      applicationType: string | null,
    } | {
      __typename: "registrationForm_Entry",
      // The ID of the entity
      id: string | null,
      ctaText: string | null,
      buttonText: string | null,
      compactDisplay: boolean | null,
      description:  {
        __typename: "description4_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    }
  ) | null >,
  relatedItems:  Array<( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      relatedItemImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      relatedItemImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      relatedItemImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      service:  Array<( {
          __typename: "city_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "connectedNetworkCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "partnerContactRequest_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "internal_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "networkContactRequest_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "wishlist_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "registration_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "document_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "country_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "documentation_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "intro_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "text_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "textWithImage_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "image_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "graphic_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "video_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "audio_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "table_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "codeSnippet_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "contactForm_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "logos_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "button_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "sectionEnding_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "users_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "trafficGraph_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "applicationForm_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "event_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "eventCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "exchangePage_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "footerLink_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "getStarted_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "graph_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "info_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "menu_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "network_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "networkConnection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "news_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "newsCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "newsletter_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "newsletterCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "partner_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "partnerCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "search_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "service_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "benefit_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "speedBlock_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "story_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "storyCollection_Entry",
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null >,
};

export interface EventFragment {
  __typename: "event_Entry",
  // The element’s title.
  title: string | null,
  description:  {
    __typename: "description_CkeditorField",
    // The parsed content as HTML.
    html: string | null,
  } | null,
  location: string | null,
  startDate: string | null,
  endDate: string | null,
  // The entry’s post date.
  postDate: string | null,
  heroImage:  Array<( {
      __typename: "images_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcSmall: string | null,
      // The width in pixels or null if it’s not an image.
      widthSmall: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcMedium: string | null,
      // The width in pixels or null if it’s not an image.
      widthMedium: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcLarge: string | null,
      // The width in pixels or null if it’s not an image.
      widthLarge: number | null,
      // The element’s title.
      title: string | null,
    } | {
      __typename: "uploadAssets_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcSmall: string | null,
      // The width in pixels or null if it’s not an image.
      widthSmall: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcMedium: string | null,
      // The width in pixels or null if it’s not an image.
      widthMedium: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcLarge: string | null,
      // The width in pixels or null if it’s not an image.
      widthLarge: number | null,
      // The element’s title.
      title: string | null,
    }
  ) | null >,
  contentBlocks:  Array<( {
      __typename: "intro_Entry",
      // The ID of the entity
      id: string | null,
      heading: string | null,
      textHTML:  {
        __typename: "text_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "text_Entry",
      // The ID of the entity
      id: string | null,
      heading: string | null,
      textHTML:  {
        __typename: "text2_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "textWithImage_Entry",
      image:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      heading: string | null,
      textHTML:  {
        __typename: "text3_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
      imageAlignment: string | null,
    } | {
      __typename: "image_Entry",
      image:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      heading: string | null,
      text: string | null,
      buttonText: string | null,
      buttonLink:  Array<( {
          __typename: "city_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "connectedNetworkCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "internal_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "wishlist_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registration_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "document_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "country_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "documentation_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "intro_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "text_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "textWithImage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "image_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graphic_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "video_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "audio_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "table_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "codeSnippet_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "contactForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "logos_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "button_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "sectionEnding_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "users_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "trafficGraph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "applicationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "event_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "eventCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "exchangePage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "footerLink_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "getStarted_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "info_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "menu_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "network_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkConnection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "news_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletter_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletterCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partner_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "search_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "service_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "benefit_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "speedBlock_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "story_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "storyCollection_Entry",
          // The element’s URI.
          uri: string | null,
        }
      ) | null >,
      textAlignment: string | null,
    } | {
      __typename: "graphic_Entry",
      image:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcOriginal: string | null,
          // The width in pixels or null if it’s not an image.
          widthOriginal: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcOriginal: string | null,
          // The width in pixels or null if it’s not an image.
          widthOriginal: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "video_Entry",
      videoUrl: string | null,
    } | {
      __typename: "audio_Entry",
      podcastUrl: string | null,
      podcastDescription: string | null,
    } | {
      __typename: "table_Entry",
      heading: string | null,
      table:  {
        __typename: "table_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "codeSnippet_Entry",
      programmingLanguage: string | null,
      snippet:  {
        __typename: "snippet_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "contactForm_Entry",
      // The ID of the entity
      id: string | null,
      ctaText: string | null,
      buttonText: string | null,
      compactDisplay: boolean | null,
      documentUpload: boolean | null,
      description:  {
        __typename: "description3_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "logos_Entry",
      logos:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The element’s title.
          title: string | null,
          // The ID of the entity
          id: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The element’s title.
          title: string | null,
          // The ID of the entity
          id: string | null,
        }
      ) | null >,
    } | {
      __typename: "button_Entry",
      // The ID of the entity
      id: string | null,
      label: string | null,
      linkEntry:  Array<( {
          __typename: "city_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "connectedNetworkCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "internal_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "wishlist_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registration_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "document_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "country_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "documentation_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "intro_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "text_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "textWithImage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "image_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graphic_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "video_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "audio_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "table_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "codeSnippet_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "contactForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "logos_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "button_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "sectionEnding_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "users_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "trafficGraph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "applicationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "event_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "eventCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "exchangePage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "footerLink_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "getStarted_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "info_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "menu_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "network_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkConnection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "news_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletter_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletterCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partner_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "search_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "service_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "benefit_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "speedBlock_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "story_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "storyCollection_Entry",
          // The element’s URI.
          uri: string | null,
        }
      ) | null >,
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
      // The ID of the entity
      id: string | null,
      heading: string | null,
      users:  Array<( {
          __typename: "User",
          // The user’s full name.
          fullName: string | null,
          functionTitle: string | null,
          // The user’s photo.
          photo: ( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              url: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              url: string | null,
            }
          ) | null,
        }
      ) | null >,
    } | {
      __typename: "trafficGraph_Entry",
      // The ID of the entity
      id: string | null,
      dataset:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
          // The element’s title.
          title: string | null,
          interval: string | null,
          peakIn: string | null,
          peakOut: string | null,
          averageIn: string | null,
          averageOut: string | null,
          currentIn: string | null,
          currentOut: string | null,
          averageInputData:  Array< {
            __typename: "averageInputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
          averageOutputData:  Array< {
            __typename: "averageOutputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
          peakOutputData:  Array< {
            __typename: "peakOutputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
          peakInputData:  Array< {
            __typename: "peakInputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) | null >,
    } | {
      __typename: "applicationForm_Entry",
      // The ID of the entity
      id: string | null,
      buttonText: string | null,
      applicationType: string | null,
    } | {
      __typename: "registrationForm_Entry",
      // The ID of the entity
      id: string | null,
      ctaText: string | null,
      buttonText: string | null,
      compactDisplay: boolean | null,
      description:  {
        __typename: "description4_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    }
  ) | null >,
  relatedItems:  Array<( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      relatedItemImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      relatedItemImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      relatedItemImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      service:  Array<( {
          __typename: "city_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "connectedNetworkCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "partnerContactRequest_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "internal_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "networkContactRequest_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "wishlist_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "registration_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "document_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "country_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "documentation_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "intro_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "text_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "textWithImage_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "image_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "graphic_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "video_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "audio_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "table_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "codeSnippet_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "contactForm_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "logos_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "button_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "sectionEnding_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "users_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "trafficGraph_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "applicationForm_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "event_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "eventCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "exchangePage_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "footerLink_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "getStarted_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "graph_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "info_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "menu_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "network_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "networkConnection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "news_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "newsCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "newsletter_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "newsletterCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "partner_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "partnerCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "search_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "service_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "benefit_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "speedBlock_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "story_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "storyCollection_Entry",
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null >,
};

export interface SingleEventFragment {
  __typename: "event_Entry",
  // The element’s title.
  title: string | null,
  description:  {
    __typename: "description_CkeditorField",
    // The parsed content as HTML.
    html: string | null,
  } | null,
  location: string | null,
  startDate: string | null,
  endDate: string | null,
  // The entry’s post date.
  postDate: string | null,
  heroImage:  Array<( {
      __typename: "images_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcSmall: string | null,
      // The width in pixels or null if it’s not an image.
      widthSmall: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcMedium: string | null,
      // The width in pixels or null if it’s not an image.
      widthMedium: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcLarge: string | null,
      // The width in pixels or null if it’s not an image.
      widthLarge: number | null,
      // The element’s title.
      title: string | null,
    } | {
      __typename: "uploadAssets_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcSmall: string | null,
      // The width in pixels or null if it’s not an image.
      widthSmall: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcMedium: string | null,
      // The width in pixels or null if it’s not an image.
      widthMedium: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcLarge: string | null,
      // The width in pixels or null if it’s not an image.
      widthLarge: number | null,
      // The element’s title.
      title: string | null,
    }
  ) | null >,
  contentBlocks:  Array<( {
      __typename: "intro_Entry",
      // The ID of the entity
      id: string | null,
      heading: string | null,
      textHTML:  {
        __typename: "text_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "text_Entry",
      // The ID of the entity
      id: string | null,
      heading: string | null,
      textHTML:  {
        __typename: "text2_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "textWithImage_Entry",
      image:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      heading: string | null,
      textHTML:  {
        __typename: "text3_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
      imageAlignment: string | null,
    } | {
      __typename: "image_Entry",
      image:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      heading: string | null,
      text: string | null,
      buttonText: string | null,
      buttonLink:  Array<( {
          __typename: "city_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "connectedNetworkCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "internal_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "wishlist_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registration_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "document_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "country_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "documentation_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "intro_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "text_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "textWithImage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "image_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graphic_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "video_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "audio_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "table_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "codeSnippet_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "contactForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "logos_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "button_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "sectionEnding_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "users_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "trafficGraph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "applicationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "event_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "eventCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "exchangePage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "footerLink_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "getStarted_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "info_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "menu_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "network_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkConnection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "news_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletter_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletterCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partner_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "search_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "service_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "benefit_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "speedBlock_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "story_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "storyCollection_Entry",
          // The element’s URI.
          uri: string | null,
        }
      ) | null >,
      textAlignment: string | null,
    } | {
      __typename: "graphic_Entry",
      image:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcOriginal: string | null,
          // The width in pixels or null if it’s not an image.
          widthOriginal: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcOriginal: string | null,
          // The width in pixels or null if it’s not an image.
          widthOriginal: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "video_Entry",
      videoUrl: string | null,
    } | {
      __typename: "audio_Entry",
      podcastUrl: string | null,
      podcastDescription: string | null,
    } | {
      __typename: "table_Entry",
      heading: string | null,
      table:  {
        __typename: "table_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "codeSnippet_Entry",
      programmingLanguage: string | null,
      snippet:  {
        __typename: "snippet_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "contactForm_Entry",
      // The ID of the entity
      id: string | null,
      ctaText: string | null,
      buttonText: string | null,
      compactDisplay: boolean | null,
      documentUpload: boolean | null,
      description:  {
        __typename: "description3_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "logos_Entry",
      logos:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The element’s title.
          title: string | null,
          // The ID of the entity
          id: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The element’s title.
          title: string | null,
          // The ID of the entity
          id: string | null,
        }
      ) | null >,
    } | {
      __typename: "button_Entry",
      // The ID of the entity
      id: string | null,
      label: string | null,
      linkEntry:  Array<( {
          __typename: "city_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "connectedNetworkCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "internal_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "wishlist_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registration_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "document_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "country_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "documentation_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "intro_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "text_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "textWithImage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "image_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graphic_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "video_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "audio_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "table_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "codeSnippet_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "contactForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "logos_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "button_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "sectionEnding_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "users_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "trafficGraph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "applicationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "event_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "eventCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "exchangePage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "footerLink_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "getStarted_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "info_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "menu_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "network_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkConnection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "news_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletter_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletterCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partner_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "search_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "service_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "benefit_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "speedBlock_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "story_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "storyCollection_Entry",
          // The element’s URI.
          uri: string | null,
        }
      ) | null >,
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
      // The ID of the entity
      id: string | null,
      heading: string | null,
      users:  Array<( {
          __typename: "User",
          // The user’s full name.
          fullName: string | null,
          functionTitle: string | null,
          // The user’s photo.
          photo: ( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              url: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              url: string | null,
            }
          ) | null,
        }
      ) | null >,
    } | {
      __typename: "trafficGraph_Entry",
      // The ID of the entity
      id: string | null,
      dataset:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
          // The element’s title.
          title: string | null,
          interval: string | null,
          peakIn: string | null,
          peakOut: string | null,
          averageIn: string | null,
          averageOut: string | null,
          currentIn: string | null,
          currentOut: string | null,
          averageInputData:  Array< {
            __typename: "averageInputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
          averageOutputData:  Array< {
            __typename: "averageOutputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
          peakOutputData:  Array< {
            __typename: "peakOutputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
          peakInputData:  Array< {
            __typename: "peakInputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) | null >,
    } | {
      __typename: "applicationForm_Entry",
      // The ID of the entity
      id: string | null,
      buttonText: string | null,
      applicationType: string | null,
    } | {
      __typename: "registrationForm_Entry",
      // The ID of the entity
      id: string | null,
      ctaText: string | null,
      buttonText: string | null,
      compactDisplay: boolean | null,
      description:  {
        __typename: "description4_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    }
  ) | null >,
};

export interface FooterSocialsFragment {
  __typename: "socialMedia_GlobalSet",
  facebookUrl: string | null,
  linkedinUrl: string | null,
  twitterUrl: string | null,
  youtubeUrl: string | null,
};

export interface GetStartedFragment {
  __typename: "getStarted_Entry",
  linkEntry:  Array<( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
      // The element’s title.
      title: string | null,
      description:  {
        __typename: "description_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
      contentBlocks:  Array<( {
          __typename: "intro_Entry",
          // The ID of the entity
          id: string | null,
          heading: string | null,
          textHTML:  {
            __typename: "text_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        } | {
          __typename: "text_Entry",
          // The ID of the entity
          id: string | null,
          heading: string | null,
          textHTML:  {
            __typename: "text2_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        } | {
          __typename: "textWithImage_Entry",
          image:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
          heading: string | null,
          textHTML:  {
            __typename: "text3_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
          imageAlignment: string | null,
        } | {
          __typename: "image_Entry",
          image:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              urlLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
          heading: string | null,
          text: string | null,
          buttonText: string | null,
          buttonLink:  Array<( {
              __typename: "city_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "connectedNetworkCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partnerContactRequest_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "internal_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "networkContactRequest_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "wishlist_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "registration_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "document_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "country_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "documentation_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "intro_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "text_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "textWithImage_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "image_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "graphic_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "video_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "audio_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "table_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "codeSnippet_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "contactForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "logos_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "button_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "sectionEnding_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "users_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "trafficGraph_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "applicationForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "registrationForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "event_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "eventCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "exchangePage_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "footerLink_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "getStarted_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "graph_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "info_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "menu_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "network_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "networkConnection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "news_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsletter_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsletterCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partner_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partnerCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "search_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "service_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "benefit_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "speedBlock_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "story_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "storyCollection_Entry",
              // The element’s URI.
              uri: string | null,
            }
          ) | null >,
          textAlignment: string | null,
        } | {
          __typename: "graphic_Entry",
          image:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcOriginal: string | null,
              // The width in pixels or null if it’s not an image.
              widthOriginal: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcOriginal: string | null,
              // The width in pixels or null if it’s not an image.
              widthOriginal: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "video_Entry",
          videoUrl: string | null,
        } | {
          __typename: "audio_Entry",
          podcastUrl: string | null,
          podcastDescription: string | null,
        } | {
          __typename: "table_Entry",
          heading: string | null,
          table:  {
            __typename: "table_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        } | {
          __typename: "codeSnippet_Entry",
          programmingLanguage: string | null,
          snippet:  {
            __typename: "snippet_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        } | {
          __typename: "contactForm_Entry",
          // The ID of the entity
          id: string | null,
          ctaText: string | null,
          buttonText: string | null,
          compactDisplay: boolean | null,
          documentUpload: boolean | null,
          description:  {
            __typename: "description3_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        } | {
          __typename: "logos_Entry",
          logos:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              src: string | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              src2x: string | null,
              // The element’s title.
              title: string | null,
              // The ID of the entity
              id: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              src: string | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              src2x: string | null,
              // The element’s title.
              title: string | null,
              // The ID of the entity
              id: string | null,
            }
          ) | null >,
        } | {
          __typename: "button_Entry",
          // The ID of the entity
          id: string | null,
          label: string | null,
          linkEntry:  Array<( {
              __typename: "city_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "connectedNetworkCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partnerContactRequest_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "internal_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "networkContactRequest_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "wishlist_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "registration_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "document_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "country_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "documentation_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "intro_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "text_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "textWithImage_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "image_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "graphic_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "video_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "audio_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "table_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "codeSnippet_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "contactForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "logos_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "button_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "sectionEnding_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "users_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "trafficGraph_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "applicationForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "registrationForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "event_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "eventCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "exchangePage_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "footerLink_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "getStarted_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "graph_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "info_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "menu_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "network_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "networkConnection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "news_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsletter_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsletterCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partner_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partnerCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "search_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "service_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "benefit_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "speedBlock_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "story_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "storyCollection_Entry",
              // The element’s URI.
              uri: string | null,
            }
          ) | null >,
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
          // The ID of the entity
          id: string | null,
          heading: string | null,
          users:  Array<( {
              __typename: "User",
              // The user’s full name.
              fullName: string | null,
              functionTitle: string | null,
              // The user’s photo.
              photo: ( {
                  __typename: "images_Asset",
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  url: string | null,
                } | {
                  __typename: "uploadAssets_Asset",
                  // The full URL of the asset. This field accepts the same fields as the `transform` directive.
                  url: string | null,
                }
              ) | null,
            }
          ) | null >,
        } | {
          __typename: "trafficGraph_Entry",
          // The ID of the entity
          id: string | null,
          dataset:  Array<( {
              __typename: "city_Entry",
            } | {
              __typename: "connectedNetworkCollection_Entry",
            } | {
              __typename: "partnerContactRequest_Entry",
            } | {
              __typename: "internal_Entry",
            } | {
              __typename: "networkContactRequest_Entry",
            } | {
              __typename: "wishlist_Entry",
            } | {
              __typename: "registration_Entry",
            } | {
              __typename: "document_Entry",
            } | {
              __typename: "country_Entry",
            } | {
              __typename: "documentation_Entry",
            } | {
              __typename: "intro_Entry",
            } | {
              __typename: "text_Entry",
            } | {
              __typename: "textWithImage_Entry",
            } | {
              __typename: "image_Entry",
            } | {
              __typename: "graphic_Entry",
            } | {
              __typename: "video_Entry",
            } | {
              __typename: "audio_Entry",
            } | {
              __typename: "table_Entry",
            } | {
              __typename: "codeSnippet_Entry",
            } | {
              __typename: "contactForm_Entry",
            } | {
              __typename: "logos_Entry",
            } | {
              __typename: "button_Entry",
            } | {
              __typename: "sectionEnding_Entry",
            } | {
              __typename: "users_Entry",
            } | {
              __typename: "trafficGraph_Entry",
            } | {
              __typename: "applicationForm_Entry",
            } | {
              __typename: "registrationForm_Entry",
            } | {
              __typename: "event_Entry",
            } | {
              __typename: "eventCollection_Entry",
            } | {
              __typename: "exchangePage_Entry",
            } | {
              __typename: "footerLink_Entry",
            } | {
              __typename: "getStarted_Entry",
            } | {
              __typename: "graph_Entry",
              // The element’s title.
              title: string | null,
              interval: string | null,
              peakIn: string | null,
              peakOut: string | null,
              averageIn: string | null,
              averageOut: string | null,
              currentIn: string | null,
              currentOut: string | null,
              averageInputData:  Array< {
                __typename: "averageInputData_TableRow",
                time: string | null,
                value: string | null,
              } | null > | null,
              averageOutputData:  Array< {
                __typename: "averageOutputData_TableRow",
                time: string | null,
                value: string | null,
              } | null > | null,
              peakOutputData:  Array< {
                __typename: "peakOutputData_TableRow",
                time: string | null,
                value: string | null,
              } | null > | null,
              peakInputData:  Array< {
                __typename: "peakInputData_TableRow",
                time: string | null,
                value: string | null,
              } | null > | null,
            } | {
              __typename: "info_Entry",
            } | {
              __typename: "menu_Entry",
            } | {
              __typename: "network_Entry",
            } | {
              __typename: "networkConnection_Entry",
            } | {
              __typename: "news_Entry",
            } | {
              __typename: "newsCollection_Entry",
            } | {
              __typename: "newsletter_Entry",
            } | {
              __typename: "newsletterCollection_Entry",
            } | {
              __typename: "partner_Entry",
            } | {
              __typename: "partnerCollection_Entry",
            } | {
              __typename: "search_Entry",
            } | {
              __typename: "service_Entry",
            } | {
              __typename: "benefit_Entry",
            } | {
              __typename: "speedBlock_Entry",
            } | {
              __typename: "story_Entry",
            } | {
              __typename: "storyCollection_Entry",
            }
          ) | null >,
        } | {
          __typename: "applicationForm_Entry",
          // The ID of the entity
          id: string | null,
          buttonText: string | null,
          applicationType: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The ID of the entity
          id: string | null,
          ctaText: string | null,
          buttonText: string | null,
          compactDisplay: boolean | null,
          description:  {
            __typename: "description4_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
        }
      ) | null >,
      relatedItems:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          relatedItemImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          heroImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          relatedItemImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "menu_Entry",
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          heroImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          relatedItemImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s URI.
          uri: string | null,
          // The element’s title.
          title: string | null,
          // The entry’s post date.
          postDate: string | null,
          heroImage:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcSmall: string | null,
              // The width in pixels or null if it’s not an image.
              widthSmall: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcMedium: string | null,
              // The width in pixels or null if it’s not an image.
              widthMedium: number | null,
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              srcLarge: string | null,
              // The width in pixels or null if it’s not an image.
              widthLarge: number | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
          service:  Array<( {
              __typename: "city_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "connectedNetworkCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "partnerContactRequest_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "internal_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "networkContactRequest_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "wishlist_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "registration_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "document_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "country_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "documentation_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "intro_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "text_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "textWithImage_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "image_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "graphic_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "video_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "audio_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "table_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "codeSnippet_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "contactForm_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "logos_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "button_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "sectionEnding_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "users_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "trafficGraph_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "applicationForm_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "registrationForm_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "event_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "eventCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "exchangePage_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "footerLink_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "getStarted_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "graph_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "info_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "menu_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "network_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "networkConnection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "news_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "newsCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "newsletter_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "newsletterCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "partner_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "partnerCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "search_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "service_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "benefit_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "speedBlock_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "story_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "storyCollection_Entry",
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "storyCollection_Entry",
        }
      ) | null >,
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null >,
};

export interface GetStartedPageFragment {
  __typename: "documentation_Entry",
  // The element’s title.
  title: string | null,
  description:  {
    __typename: "description_CkeditorField",
    // The parsed content as HTML.
    html: string | null,
  } | null,
  contentBlocks:  Array<( {
      __typename: "intro_Entry",
      // The ID of the entity
      id: string | null,
      heading: string | null,
      textHTML:  {
        __typename: "text_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "text_Entry",
      // The ID of the entity
      id: string | null,
      heading: string | null,
      textHTML:  {
        __typename: "text2_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "textWithImage_Entry",
      image:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      heading: string | null,
      textHTML:  {
        __typename: "text3_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
      imageAlignment: string | null,
    } | {
      __typename: "image_Entry",
      image:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      heading: string | null,
      text: string | null,
      buttonText: string | null,
      buttonLink:  Array<( {
          __typename: "city_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "connectedNetworkCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "internal_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "wishlist_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registration_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "document_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "country_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "documentation_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "intro_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "text_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "textWithImage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "image_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graphic_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "video_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "audio_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "table_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "codeSnippet_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "contactForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "logos_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "button_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "sectionEnding_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "users_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "trafficGraph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "applicationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "event_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "eventCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "exchangePage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "footerLink_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "getStarted_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "info_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "menu_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "network_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkConnection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "news_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletter_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletterCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partner_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "search_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "service_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "benefit_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "speedBlock_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "story_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "storyCollection_Entry",
          // The element’s URI.
          uri: string | null,
        }
      ) | null >,
      textAlignment: string | null,
    } | {
      __typename: "graphic_Entry",
      image:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcOriginal: string | null,
          // The width in pixels or null if it’s not an image.
          widthOriginal: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcOriginal: string | null,
          // The width in pixels or null if it’s not an image.
          widthOriginal: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "video_Entry",
      videoUrl: string | null,
    } | {
      __typename: "audio_Entry",
      podcastUrl: string | null,
      podcastDescription: string | null,
    } | {
      __typename: "table_Entry",
      heading: string | null,
      table:  {
        __typename: "table_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "codeSnippet_Entry",
      programmingLanguage: string | null,
      snippet:  {
        __typename: "snippet_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "contactForm_Entry",
      // The ID of the entity
      id: string | null,
      ctaText: string | null,
      buttonText: string | null,
      compactDisplay: boolean | null,
      documentUpload: boolean | null,
      description:  {
        __typename: "description3_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "logos_Entry",
      logos:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The element’s title.
          title: string | null,
          // The ID of the entity
          id: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The element’s title.
          title: string | null,
          // The ID of the entity
          id: string | null,
        }
      ) | null >,
    } | {
      __typename: "button_Entry",
      // The ID of the entity
      id: string | null,
      label: string | null,
      linkEntry:  Array<( {
          __typename: "city_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "connectedNetworkCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "internal_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "wishlist_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registration_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "document_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "country_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "documentation_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "intro_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "text_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "textWithImage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "image_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graphic_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "video_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "audio_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "table_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "codeSnippet_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "contactForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "logos_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "button_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "sectionEnding_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "users_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "trafficGraph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "applicationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "event_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "eventCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "exchangePage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "footerLink_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "getStarted_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "info_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "menu_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "network_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkConnection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "news_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletter_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletterCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partner_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "search_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "service_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "benefit_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "speedBlock_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "story_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "storyCollection_Entry",
          // The element’s URI.
          uri: string | null,
        }
      ) | null >,
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
      // The ID of the entity
      id: string | null,
      heading: string | null,
      users:  Array<( {
          __typename: "User",
          // The user’s full name.
          fullName: string | null,
          functionTitle: string | null,
          // The user’s photo.
          photo: ( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              url: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              url: string | null,
            }
          ) | null,
        }
      ) | null >,
    } | {
      __typename: "trafficGraph_Entry",
      // The ID of the entity
      id: string | null,
      dataset:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
          // The element’s title.
          title: string | null,
          interval: string | null,
          peakIn: string | null,
          peakOut: string | null,
          averageIn: string | null,
          averageOut: string | null,
          currentIn: string | null,
          currentOut: string | null,
          averageInputData:  Array< {
            __typename: "averageInputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
          averageOutputData:  Array< {
            __typename: "averageOutputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
          peakOutputData:  Array< {
            __typename: "peakOutputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
          peakInputData:  Array< {
            __typename: "peakInputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) | null >,
    } | {
      __typename: "applicationForm_Entry",
      // The ID of the entity
      id: string | null,
      buttonText: string | null,
      applicationType: string | null,
    } | {
      __typename: "registrationForm_Entry",
      // The ID of the entity
      id: string | null,
      ctaText: string | null,
      buttonText: string | null,
      compactDisplay: boolean | null,
      description:  {
        __typename: "description4_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    }
  ) | null >,
  relatedItems:  Array<( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      relatedItemImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      relatedItemImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      relatedItemImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      service:  Array<( {
          __typename: "city_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "connectedNetworkCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "partnerContactRequest_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "internal_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "networkContactRequest_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "wishlist_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "registration_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "document_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "country_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "documentation_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "intro_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "text_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "textWithImage_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "image_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "graphic_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "video_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "audio_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "table_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "codeSnippet_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "contactForm_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "logos_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "button_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "sectionEnding_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "users_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "trafficGraph_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "applicationForm_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "event_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "eventCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "exchangePage_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "footerLink_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "getStarted_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "graph_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "info_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "menu_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "network_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "networkConnection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "news_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "newsCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "newsletter_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "newsletterCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "partner_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "partnerCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "search_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "service_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "benefit_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "speedBlock_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "story_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "storyCollection_Entry",
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null >,
};

export interface GlossaryFragment {
  __typename: "glossary_GlobalSet",
  glossaryTable:  Array< {
    __typename: "glossaryTable_TableRow",
    word: string | null,
    meaning: string | null,
  } | null > | null,
};

export interface InfoFragment {
  __typename: "info_Entry",
  // The element’s title.
  title: string | null,
  description:  {
    __typename: "description_CkeditorField",
    // The parsed content as HTML.
    html: string | null,
  } | null,
  contentBlocks:  Array<( {
      __typename: "intro_Entry",
      // The ID of the entity
      id: string | null,
      heading: string | null,
      textHTML:  {
        __typename: "text_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "text_Entry",
      // The ID of the entity
      id: string | null,
      heading: string | null,
      textHTML:  {
        __typename: "text2_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "textWithImage_Entry",
      image:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      heading: string | null,
      textHTML:  {
        __typename: "text3_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
      imageAlignment: string | null,
    } | {
      __typename: "image_Entry",
      image:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      heading: string | null,
      text: string | null,
      buttonText: string | null,
      buttonLink:  Array<( {
          __typename: "city_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "connectedNetworkCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "internal_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "wishlist_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registration_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "document_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "country_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "documentation_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "intro_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "text_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "textWithImage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "image_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graphic_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "video_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "audio_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "table_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "codeSnippet_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "contactForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "logos_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "button_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "sectionEnding_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "users_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "trafficGraph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "applicationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "event_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "eventCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "exchangePage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "footerLink_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "getStarted_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "info_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "menu_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "network_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkConnection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "news_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletter_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletterCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partner_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "search_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "service_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "benefit_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "speedBlock_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "story_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "storyCollection_Entry",
          // The element’s URI.
          uri: string | null,
        }
      ) | null >,
      textAlignment: string | null,
    } | {
      __typename: "graphic_Entry",
      image:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcOriginal: string | null,
          // The width in pixels or null if it’s not an image.
          widthOriginal: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcOriginal: string | null,
          // The width in pixels or null if it’s not an image.
          widthOriginal: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "video_Entry",
      videoUrl: string | null,
    } | {
      __typename: "audio_Entry",
      podcastUrl: string | null,
      podcastDescription: string | null,
    } | {
      __typename: "table_Entry",
      heading: string | null,
      table:  {
        __typename: "table_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "codeSnippet_Entry",
      programmingLanguage: string | null,
      snippet:  {
        __typename: "snippet_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "contactForm_Entry",
      // The ID of the entity
      id: string | null,
      ctaText: string | null,
      buttonText: string | null,
      compactDisplay: boolean | null,
      documentUpload: boolean | null,
      description:  {
        __typename: "description3_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "logos_Entry",
      logos:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The element’s title.
          title: string | null,
          // The ID of the entity
          id: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The element’s title.
          title: string | null,
          // The ID of the entity
          id: string | null,
        }
      ) | null >,
    } | {
      __typename: "button_Entry",
      // The ID of the entity
      id: string | null,
      label: string | null,
      linkEntry:  Array<( {
          __typename: "city_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "connectedNetworkCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "internal_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "wishlist_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registration_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "document_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "country_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "documentation_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "intro_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "text_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "textWithImage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "image_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graphic_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "video_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "audio_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "table_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "codeSnippet_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "contactForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "logos_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "button_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "sectionEnding_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "users_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "trafficGraph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "applicationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "event_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "eventCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "exchangePage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "footerLink_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "getStarted_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "info_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "menu_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "network_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkConnection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "news_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletter_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletterCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partner_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "search_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "service_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "benefit_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "speedBlock_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "story_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "storyCollection_Entry",
          // The element’s URI.
          uri: string | null,
        }
      ) | null >,
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
      // The ID of the entity
      id: string | null,
      heading: string | null,
      users:  Array<( {
          __typename: "User",
          // The user’s full name.
          fullName: string | null,
          functionTitle: string | null,
          // The user’s photo.
          photo: ( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              url: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              url: string | null,
            }
          ) | null,
        }
      ) | null >,
    } | {
      __typename: "trafficGraph_Entry",
      // The ID of the entity
      id: string | null,
      dataset:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
          // The element’s title.
          title: string | null,
          interval: string | null,
          peakIn: string | null,
          peakOut: string | null,
          averageIn: string | null,
          averageOut: string | null,
          currentIn: string | null,
          currentOut: string | null,
          averageInputData:  Array< {
            __typename: "averageInputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
          averageOutputData:  Array< {
            __typename: "averageOutputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
          peakOutputData:  Array< {
            __typename: "peakOutputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
          peakInputData:  Array< {
            __typename: "peakInputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) | null >,
    } | {
      __typename: "applicationForm_Entry",
      // The ID of the entity
      id: string | null,
      buttonText: string | null,
      applicationType: string | null,
    } | {
      __typename: "registrationForm_Entry",
      // The ID of the entity
      id: string | null,
      ctaText: string | null,
      buttonText: string | null,
      compactDisplay: boolean | null,
      description:  {
        __typename: "description4_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    }
  ) | null >,
  relatedItems:  Array<( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      relatedItemImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      relatedItemImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      relatedItemImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      service:  Array<( {
          __typename: "city_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "connectedNetworkCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "partnerContactRequest_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "internal_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "networkContactRequest_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "wishlist_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "registration_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "document_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "country_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "documentation_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "intro_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "text_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "textWithImage_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "image_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "graphic_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "video_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "audio_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "table_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "codeSnippet_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "contactForm_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "logos_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "button_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "sectionEnding_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "users_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "trafficGraph_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "applicationForm_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "event_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "eventCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "exchangePage_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "footerLink_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "getStarted_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "graph_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "info_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "menu_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "network_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "networkConnection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "news_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "newsCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "newsletter_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "newsletterCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "partner_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "partnerCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "search_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "service_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "benefit_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "speedBlock_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "story_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "storyCollection_Entry",
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null >,
};

export interface SingleNewsPageFragment {
  __typename: "news_Entry",
  // The element’s title.
  title: string | null,
  description:  {
    __typename: "description_CkeditorField",
    // The parsed content as HTML.
    html: string | null,
  } | null,
  // The entry’s post date.
  postDate: string | null,
  heroImage:  Array<( {
      __typename: "images_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src: string | null,
      // The width in pixels or null if it’s not an image.
      width: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src2x: string | null,
      // The width in pixels or null if it’s not an image.
      width2x: number | null,
      // The element’s title.
      title: string | null,
    } | {
      __typename: "uploadAssets_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src: string | null,
      // The width in pixels or null if it’s not an image.
      width: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src2x: string | null,
      // The width in pixels or null if it’s not an image.
      width2x: number | null,
      // The element’s title.
      title: string | null,
    }
  ) | null >,
  // The primary entry author.
  author: ( {
      __typename: "User",
      // The user’s full name or username.
      name: string,
      functionTitle: string | null,
      // The user’s photo.
      photo: ( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          url: string | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          url: string | null,
          // The element’s title.
          title: string | null,
        }
      ) | null,
    }
  ) | null,
  contentBlocks:  Array<( {
      __typename: "intro_Entry",
      // The ID of the entity
      id: string | null,
      heading: string | null,
      textHTML:  {
        __typename: "text_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "text_Entry",
      // The ID of the entity
      id: string | null,
      heading: string | null,
      textHTML:  {
        __typename: "text2_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "textWithImage_Entry",
      image:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      heading: string | null,
      textHTML:  {
        __typename: "text3_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
      imageAlignment: string | null,
    } | {
      __typename: "image_Entry",
      image:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      heading: string | null,
      text: string | null,
      buttonText: string | null,
      buttonLink:  Array<( {
          __typename: "city_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "connectedNetworkCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "internal_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "wishlist_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registration_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "document_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "country_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "documentation_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "intro_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "text_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "textWithImage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "image_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graphic_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "video_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "audio_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "table_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "codeSnippet_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "contactForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "logos_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "button_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "sectionEnding_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "users_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "trafficGraph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "applicationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "event_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "eventCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "exchangePage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "footerLink_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "getStarted_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "info_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "menu_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "network_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkConnection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "news_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletter_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletterCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partner_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "search_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "service_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "benefit_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "speedBlock_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "story_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "storyCollection_Entry",
          // The element’s URI.
          uri: string | null,
        }
      ) | null >,
      textAlignment: string | null,
    } | {
      __typename: "graphic_Entry",
      image:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcOriginal: string | null,
          // The width in pixels or null if it’s not an image.
          widthOriginal: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcOriginal: string | null,
          // The width in pixels or null if it’s not an image.
          widthOriginal: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "video_Entry",
      videoUrl: string | null,
    } | {
      __typename: "audio_Entry",
      podcastUrl: string | null,
      podcastDescription: string | null,
    } | {
      __typename: "table_Entry",
      heading: string | null,
      table:  {
        __typename: "table_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "codeSnippet_Entry",
      programmingLanguage: string | null,
      snippet:  {
        __typename: "snippet_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "contactForm_Entry",
      // The ID of the entity
      id: string | null,
      ctaText: string | null,
      buttonText: string | null,
      compactDisplay: boolean | null,
      documentUpload: boolean | null,
      description:  {
        __typename: "description3_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "logos_Entry",
      logos:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The element’s title.
          title: string | null,
          // The ID of the entity
          id: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The element’s title.
          title: string | null,
          // The ID of the entity
          id: string | null,
        }
      ) | null >,
    } | {
      __typename: "button_Entry",
      // The ID of the entity
      id: string | null,
      label: string | null,
      linkEntry:  Array<( {
          __typename: "city_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "connectedNetworkCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "internal_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "wishlist_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registration_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "document_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "country_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "documentation_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "intro_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "text_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "textWithImage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "image_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graphic_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "video_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "audio_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "table_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "codeSnippet_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "contactForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "logos_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "button_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "sectionEnding_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "users_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "trafficGraph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "applicationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "event_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "eventCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "exchangePage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "footerLink_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "getStarted_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "info_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "menu_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "network_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkConnection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "news_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletter_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletterCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partner_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "search_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "service_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "benefit_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "speedBlock_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "story_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "storyCollection_Entry",
          // The element’s URI.
          uri: string | null,
        }
      ) | null >,
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
      // The ID of the entity
      id: string | null,
      heading: string | null,
      users:  Array<( {
          __typename: "User",
          // The user’s full name.
          fullName: string | null,
          functionTitle: string | null,
          // The user’s photo.
          photo: ( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              url: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              url: string | null,
            }
          ) | null,
        }
      ) | null >,
    } | {
      __typename: "trafficGraph_Entry",
      // The ID of the entity
      id: string | null,
      dataset:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
          // The element’s title.
          title: string | null,
          interval: string | null,
          peakIn: string | null,
          peakOut: string | null,
          averageIn: string | null,
          averageOut: string | null,
          currentIn: string | null,
          currentOut: string | null,
          averageInputData:  Array< {
            __typename: "averageInputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
          averageOutputData:  Array< {
            __typename: "averageOutputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
          peakOutputData:  Array< {
            __typename: "peakOutputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
          peakInputData:  Array< {
            __typename: "peakInputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) | null >,
    } | {
      __typename: "applicationForm_Entry",
      // The ID of the entity
      id: string | null,
      buttonText: string | null,
      applicationType: string | null,
    } | {
      __typename: "registrationForm_Entry",
      // The ID of the entity
      id: string | null,
      ctaText: string | null,
      buttonText: string | null,
      compactDisplay: boolean | null,
      description:  {
        __typename: "description4_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    }
  ) | null >,
  relatedItems:  Array<( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      relatedItemImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      relatedItemImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      relatedItemImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      service:  Array<( {
          __typename: "city_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "connectedNetworkCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "partnerContactRequest_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "internal_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "networkContactRequest_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "wishlist_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "registration_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "document_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "country_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "documentation_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "intro_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "text_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "textWithImage_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "image_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "graphic_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "video_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "audio_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "table_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "codeSnippet_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "contactForm_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "logos_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "button_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "sectionEnding_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "users_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "trafficGraph_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "applicationForm_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "event_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "eventCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "exchangePage_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "footerLink_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "getStarted_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "graph_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "info_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "menu_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "network_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "networkConnection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "news_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "newsCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "newsletter_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "newsletterCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "partner_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "partnerCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "search_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "service_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "benefit_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "speedBlock_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "story_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "storyCollection_Entry",
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null >,
};

export interface SingleNewsFragment {
  __typename: "news_Entry",
  // The element’s title.
  title: string | null,
  description:  {
    __typename: "description_CkeditorField",
    // The parsed content as HTML.
    html: string | null,
  } | null,
  // The entry’s post date.
  postDate: string | null,
  heroImage:  Array<( {
      __typename: "images_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src: string | null,
      // The width in pixels or null if it’s not an image.
      width: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src2x: string | null,
      // The width in pixels or null if it’s not an image.
      width2x: number | null,
      // The element’s title.
      title: string | null,
    } | {
      __typename: "uploadAssets_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src: string | null,
      // The width in pixels or null if it’s not an image.
      width: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src2x: string | null,
      // The width in pixels or null if it’s not an image.
      width2x: number | null,
      // The element’s title.
      title: string | null,
    }
  ) | null >,
  // The primary entry author.
  author: ( {
      __typename: "User",
      // The user’s full name or username.
      name: string,
      functionTitle: string | null,
      // The user’s photo.
      photo: ( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          url: string | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          url: string | null,
          // The element’s title.
          title: string | null,
        }
      ) | null,
    }
  ) | null,
  contentBlocks:  Array<( {
      __typename: "intro_Entry",
      // The ID of the entity
      id: string | null,
      heading: string | null,
      textHTML:  {
        __typename: "text_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "text_Entry",
      // The ID of the entity
      id: string | null,
      heading: string | null,
      textHTML:  {
        __typename: "text2_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "textWithImage_Entry",
      image:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      heading: string | null,
      textHTML:  {
        __typename: "text3_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
      imageAlignment: string | null,
    } | {
      __typename: "image_Entry",
      image:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      heading: string | null,
      text: string | null,
      buttonText: string | null,
      buttonLink:  Array<( {
          __typename: "city_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "connectedNetworkCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "internal_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "wishlist_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registration_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "document_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "country_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "documentation_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "intro_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "text_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "textWithImage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "image_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graphic_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "video_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "audio_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "table_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "codeSnippet_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "contactForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "logos_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "button_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "sectionEnding_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "users_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "trafficGraph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "applicationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "event_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "eventCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "exchangePage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "footerLink_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "getStarted_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "info_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "menu_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "network_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkConnection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "news_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletter_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletterCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partner_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "search_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "service_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "benefit_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "speedBlock_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "story_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "storyCollection_Entry",
          // The element’s URI.
          uri: string | null,
        }
      ) | null >,
      textAlignment: string | null,
    } | {
      __typename: "graphic_Entry",
      image:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcOriginal: string | null,
          // The width in pixels or null if it’s not an image.
          widthOriginal: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcOriginal: string | null,
          // The width in pixels or null if it’s not an image.
          widthOriginal: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "video_Entry",
      videoUrl: string | null,
    } | {
      __typename: "audio_Entry",
      podcastUrl: string | null,
      podcastDescription: string | null,
    } | {
      __typename: "table_Entry",
      heading: string | null,
      table:  {
        __typename: "table_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "codeSnippet_Entry",
      programmingLanguage: string | null,
      snippet:  {
        __typename: "snippet_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "contactForm_Entry",
      // The ID of the entity
      id: string | null,
      ctaText: string | null,
      buttonText: string | null,
      compactDisplay: boolean | null,
      documentUpload: boolean | null,
      description:  {
        __typename: "description3_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "logos_Entry",
      logos:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The element’s title.
          title: string | null,
          // The ID of the entity
          id: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The element’s title.
          title: string | null,
          // The ID of the entity
          id: string | null,
        }
      ) | null >,
    } | {
      __typename: "button_Entry",
      // The ID of the entity
      id: string | null,
      label: string | null,
      linkEntry:  Array<( {
          __typename: "city_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "connectedNetworkCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "internal_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "wishlist_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registration_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "document_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "country_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "documentation_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "intro_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "text_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "textWithImage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "image_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graphic_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "video_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "audio_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "table_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "codeSnippet_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "contactForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "logos_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "button_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "sectionEnding_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "users_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "trafficGraph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "applicationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "event_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "eventCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "exchangePage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "footerLink_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "getStarted_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "info_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "menu_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "network_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkConnection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "news_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletter_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletterCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partner_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "search_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "service_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "benefit_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "speedBlock_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "story_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "storyCollection_Entry",
          // The element’s URI.
          uri: string | null,
        }
      ) | null >,
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
      // The ID of the entity
      id: string | null,
      heading: string | null,
      users:  Array<( {
          __typename: "User",
          // The user’s full name.
          fullName: string | null,
          functionTitle: string | null,
          // The user’s photo.
          photo: ( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              url: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              url: string | null,
            }
          ) | null,
        }
      ) | null >,
    } | {
      __typename: "trafficGraph_Entry",
      // The ID of the entity
      id: string | null,
      dataset:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
          // The element’s title.
          title: string | null,
          interval: string | null,
          peakIn: string | null,
          peakOut: string | null,
          averageIn: string | null,
          averageOut: string | null,
          currentIn: string | null,
          currentOut: string | null,
          averageInputData:  Array< {
            __typename: "averageInputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
          averageOutputData:  Array< {
            __typename: "averageOutputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
          peakOutputData:  Array< {
            __typename: "peakOutputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
          peakInputData:  Array< {
            __typename: "peakInputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) | null >,
    } | {
      __typename: "applicationForm_Entry",
      // The ID of the entity
      id: string | null,
      buttonText: string | null,
      applicationType: string | null,
    } | {
      __typename: "registrationForm_Entry",
      // The ID of the entity
      id: string | null,
      ctaText: string | null,
      buttonText: string | null,
      compactDisplay: boolean | null,
      description:  {
        __typename: "description4_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    }
  ) | null >,
};

export type PartnerInfoFragment = ( {
      __typename: "partnerCollection_Entry",
      // The element’s title.
      title: string | null,
      introHeading: string | null,
      introText:  {
        __typename: "introText_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    }
  );

export interface PartnerTableRowFragment {
  __typename: "partner_Entry",
  // The ID of the entity
  id: string | null,
  // The element’s title.
  title: string | null,
  datacenter: string | null,
  city: string | null,
  country: string | null,
  partnerType: string | null,
};

export interface CountriesFragment {
  __typename: "country_Entry",
  // The element’s title.
  title: string | null,
};

export interface CitiesFragment {
  __typename: "city_Entry",
  // The element’s title.
  title: string | null,
};

export interface SearchPageFragment {
  __typename: "search_Entry",
  introHeading: string | null,
  introText:  {
    __typename: "introText_CkeditorField",
    // The parsed content as HTML.
    html: string | null,
  } | null,
};

export interface ServicePageFragment {
  __typename: "service_Entry",
  // The ID of the entity
  id: string | null,
  // The element’s title.
  title: string | null,
  howItWorks:  {
    __typename: "howItWorks_CkeditorField",
    // The parsed content as HTML.
    html: string | null,
  } | null,
  description:  {
    __typename: "description_CkeditorField",
    // The parsed content as HTML.
    html: string | null,
  } | null,
  pricing:  {
    __typename: "pricing_CkeditorField",
    // The parsed content as HTML.
    html: string | null,
  } | null,
  showDurationSwitch: boolean | null,
  showContactPricing: boolean | null,
  commitmentModule:  Array<( {
      __typename: "speedBlock_Entry",
      blockTitle: string | null,
      price3Months: string | null,
      price12Months: string | null,
      price24Months: string | null,
      price36Months: string | null,
      checkmarkList:  Array< {
        __typename: "checkmarkList_TableRow",
        listItem: string | null,
      } | null > | null,
    }
  ) | null >,
  icon:  Array<( {
      __typename: "images_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src: string | null,
      // The width in pixels or null if it’s not an image.
      width: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src2x: string | null,
      // The width in pixels or null if it’s not an image.
      width2x: number | null,
      // The element’s title.
      title: string | null,
    } | {
      __typename: "uploadAssets_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src: string | null,
      // The width in pixels or null if it’s not an image.
      width: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src2x: string | null,
      // The width in pixels or null if it’s not an image.
      width2x: number | null,
      // The element’s title.
      title: string | null,
    }
  ) | null >,
  benefits:  Array<( {
      __typename: "benefit_Entry",
      icon:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          url: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          url: string | null,
        }
      ) | null >,
      heading: string | null,
      description: string | null,
    }
  ) | null >,
  storyShowcase:  Array<( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
      // The element’s title.
      title: string | null,
      // The element’s URI.
      uri: string | null,
      description:  {
        __typename: "description_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null >,
  contactBlockCtaText:  {
    __typename: "contactBlockCtaText_CkeditorField",
    // The parsed content as HTML.
    html: string | null,
  } | null,
  contactFormText:  {
    __typename: "contactFormText_CkeditorField",
    // The parsed content as HTML.
    html: string | null,
  } | null,
  relatedItems:  Array<( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      relatedItemImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      relatedItemImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      relatedItemImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      service:  Array<( {
          __typename: "city_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "connectedNetworkCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "partnerContactRequest_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "internal_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "networkContactRequest_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "wishlist_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "registration_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "document_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "country_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "documentation_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "intro_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "text_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "textWithImage_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "image_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "graphic_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "video_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "audio_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "table_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "codeSnippet_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "contactForm_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "logos_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "button_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "sectionEnding_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "users_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "trafficGraph_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "applicationForm_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "event_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "eventCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "exchangePage_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "footerLink_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "getStarted_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "graph_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "info_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "menu_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "network_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "networkConnection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "news_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "newsCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "newsletter_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "newsletterCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "partner_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "partnerCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "search_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "service_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "benefit_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "speedBlock_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "story_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "storyCollection_Entry",
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null >,
};

export interface StoryFragment {
  __typename: "story_Entry",
  // The element’s title.
  title: string | null,
  description:  {
    __typename: "description_CkeditorField",
    // The parsed content as HTML.
    html: string | null,
  } | null,
  // The entry’s post date.
  postDate: string | null,
  heroImage:  Array<( {
      __typename: "images_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcSmall: string | null,
      // The width in pixels or null if it’s not an image.
      widthSmall: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcMedium: string | null,
      // The width in pixels or null if it’s not an image.
      widthMedium: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcLarge: string | null,
      // The width in pixels or null if it’s not an image.
      widthLarge: number | null,
      // The element’s title.
      title: string | null,
    } | {
      __typename: "uploadAssets_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcSmall: string | null,
      // The width in pixels or null if it’s not an image.
      widthSmall: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcMedium: string | null,
      // The width in pixels or null if it’s not an image.
      widthMedium: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcLarge: string | null,
      // The width in pixels or null if it’s not an image.
      widthLarge: number | null,
      // The element’s title.
      title: string | null,
    }
  ) | null >,
  // The primary entry author.
  author: ( {
      __typename: "User",
      // The user’s full name or username.
      name: string,
      functionTitle: string | null,
      // The user’s photo.
      photo: ( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          url: string | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          url: string | null,
          // The element’s title.
          title: string | null,
        }
      ) | null,
    }
  ) | null,
  service:  Array<( {
      __typename: "city_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "connectedNetworkCollection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "partnerContactRequest_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "internal_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "networkContactRequest_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "wishlist_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "registration_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "document_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "country_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "documentation_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "intro_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "text_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "textWithImage_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "image_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "graphic_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "video_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "audio_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "table_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "codeSnippet_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "contactForm_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "logos_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "button_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "sectionEnding_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "users_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "trafficGraph_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "applicationForm_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "registrationForm_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "event_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "eventCollection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "exchangePage_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "footerLink_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "getStarted_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "graph_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "info_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "menu_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "network_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "networkConnection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "news_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "newsCollection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "newsletter_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "newsletterCollection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "partner_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "partnerCollection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "search_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "service_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "benefit_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "speedBlock_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "story_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "storyCollection_Entry",
      // The element’s title.
      title: string | null,
    }
  ) | null >,
  contentBlocks:  Array<( {
      __typename: "intro_Entry",
      // The ID of the entity
      id: string | null,
      heading: string | null,
      textHTML:  {
        __typename: "text_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "text_Entry",
      // The ID of the entity
      id: string | null,
      heading: string | null,
      textHTML:  {
        __typename: "text2_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "textWithImage_Entry",
      image:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      heading: string | null,
      textHTML:  {
        __typename: "text3_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
      imageAlignment: string | null,
    } | {
      __typename: "image_Entry",
      image:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      heading: string | null,
      text: string | null,
      buttonText: string | null,
      buttonLink:  Array<( {
          __typename: "city_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "connectedNetworkCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "internal_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "wishlist_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registration_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "document_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "country_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "documentation_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "intro_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "text_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "textWithImage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "image_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graphic_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "video_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "audio_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "table_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "codeSnippet_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "contactForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "logos_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "button_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "sectionEnding_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "users_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "trafficGraph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "applicationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "event_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "eventCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "exchangePage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "footerLink_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "getStarted_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "info_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "menu_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "network_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkConnection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "news_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletter_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletterCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partner_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "search_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "service_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "benefit_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "speedBlock_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "story_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "storyCollection_Entry",
          // The element’s URI.
          uri: string | null,
        }
      ) | null >,
      textAlignment: string | null,
    } | {
      __typename: "graphic_Entry",
      image:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcOriginal: string | null,
          // The width in pixels or null if it’s not an image.
          widthOriginal: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcOriginal: string | null,
          // The width in pixels or null if it’s not an image.
          widthOriginal: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "video_Entry",
      videoUrl: string | null,
    } | {
      __typename: "audio_Entry",
      podcastUrl: string | null,
      podcastDescription: string | null,
    } | {
      __typename: "table_Entry",
      heading: string | null,
      table:  {
        __typename: "table_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "codeSnippet_Entry",
      programmingLanguage: string | null,
      snippet:  {
        __typename: "snippet_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "contactForm_Entry",
      // The ID of the entity
      id: string | null,
      ctaText: string | null,
      buttonText: string | null,
      compactDisplay: boolean | null,
      documentUpload: boolean | null,
      description:  {
        __typename: "description3_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "logos_Entry",
      logos:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The element’s title.
          title: string | null,
          // The ID of the entity
          id: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The element’s title.
          title: string | null,
          // The ID of the entity
          id: string | null,
        }
      ) | null >,
    } | {
      __typename: "button_Entry",
      // The ID of the entity
      id: string | null,
      label: string | null,
      linkEntry:  Array<( {
          __typename: "city_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "connectedNetworkCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "internal_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "wishlist_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registration_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "document_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "country_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "documentation_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "intro_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "text_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "textWithImage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "image_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graphic_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "video_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "audio_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "table_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "codeSnippet_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "contactForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "logos_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "button_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "sectionEnding_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "users_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "trafficGraph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "applicationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "event_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "eventCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "exchangePage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "footerLink_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "getStarted_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "info_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "menu_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "network_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkConnection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "news_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletter_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletterCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partner_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "search_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "service_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "benefit_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "speedBlock_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "story_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "storyCollection_Entry",
          // The element’s URI.
          uri: string | null,
        }
      ) | null >,
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
      // The ID of the entity
      id: string | null,
      heading: string | null,
      users:  Array<( {
          __typename: "User",
          // The user’s full name.
          fullName: string | null,
          functionTitle: string | null,
          // The user’s photo.
          photo: ( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              url: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              url: string | null,
            }
          ) | null,
        }
      ) | null >,
    } | {
      __typename: "trafficGraph_Entry",
      // The ID of the entity
      id: string | null,
      dataset:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
          // The element’s title.
          title: string | null,
          interval: string | null,
          peakIn: string | null,
          peakOut: string | null,
          averageIn: string | null,
          averageOut: string | null,
          currentIn: string | null,
          currentOut: string | null,
          averageInputData:  Array< {
            __typename: "averageInputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
          averageOutputData:  Array< {
            __typename: "averageOutputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
          peakOutputData:  Array< {
            __typename: "peakOutputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
          peakInputData:  Array< {
            __typename: "peakInputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) | null >,
    } | {
      __typename: "applicationForm_Entry",
      // The ID of the entity
      id: string | null,
      buttonText: string | null,
      applicationType: string | null,
    } | {
      __typename: "registrationForm_Entry",
      // The ID of the entity
      id: string | null,
      ctaText: string | null,
      buttonText: string | null,
      compactDisplay: boolean | null,
      description:  {
        __typename: "description4_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    }
  ) | null >,
  relatedItems:  Array<( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      relatedItemImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      relatedItemImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      relatedItemImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      service:  Array<( {
          __typename: "city_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "connectedNetworkCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "partnerContactRequest_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "internal_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "networkContactRequest_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "wishlist_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "registration_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "document_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "country_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "documentation_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "intro_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "text_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "textWithImage_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "image_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "graphic_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "video_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "audio_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "table_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "codeSnippet_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "contactForm_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "logos_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "button_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "sectionEnding_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "users_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "trafficGraph_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "applicationForm_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "event_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "eventCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "exchangePage_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "footerLink_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "getStarted_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "graph_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "info_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "menu_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "network_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "networkConnection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "news_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "newsCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "newsletter_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "newsletterCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "partner_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "partnerCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "search_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "service_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "benefit_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "speedBlock_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "story_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "storyCollection_Entry",
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null >,
};

export interface SingleStoryFragment {
  __typename: "story_Entry",
  // The element’s title.
  title: string | null,
  description:  {
    __typename: "description_CkeditorField",
    // The parsed content as HTML.
    html: string | null,
  } | null,
  // The entry’s post date.
  postDate: string | null,
  heroImage:  Array<( {
      __typename: "images_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcSmall: string | null,
      // The width in pixels or null if it’s not an image.
      widthSmall: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcMedium: string | null,
      // The width in pixels or null if it’s not an image.
      widthMedium: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcLarge: string | null,
      // The width in pixels or null if it’s not an image.
      widthLarge: number | null,
      // The element’s title.
      title: string | null,
    } | {
      __typename: "uploadAssets_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcSmall: string | null,
      // The width in pixels or null if it’s not an image.
      widthSmall: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcMedium: string | null,
      // The width in pixels or null if it’s not an image.
      widthMedium: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcLarge: string | null,
      // The width in pixels or null if it’s not an image.
      widthLarge: number | null,
      // The element’s title.
      title: string | null,
    }
  ) | null >,
  // The primary entry author.
  author: ( {
      __typename: "User",
      // The user’s full name or username.
      name: string,
      functionTitle: string | null,
      // The user’s photo.
      photo: ( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          url: string | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          url: string | null,
          // The element’s title.
          title: string | null,
        }
      ) | null,
    }
  ) | null,
  service:  Array<( {
      __typename: "city_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "connectedNetworkCollection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "partnerContactRequest_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "internal_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "networkContactRequest_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "wishlist_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "registration_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "document_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "country_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "documentation_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "intro_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "text_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "textWithImage_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "image_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "graphic_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "video_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "audio_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "table_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "codeSnippet_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "contactForm_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "logos_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "button_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "sectionEnding_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "users_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "trafficGraph_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "applicationForm_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "registrationForm_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "event_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "eventCollection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "exchangePage_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "footerLink_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "getStarted_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "graph_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "info_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "menu_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "network_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "networkConnection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "news_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "newsCollection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "newsletter_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "newsletterCollection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "partner_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "partnerCollection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "search_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "service_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "benefit_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "speedBlock_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "story_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "storyCollection_Entry",
      // The element’s title.
      title: string | null,
    }
  ) | null >,
  contentBlocks:  Array<( {
      __typename: "intro_Entry",
      // The ID of the entity
      id: string | null,
      heading: string | null,
      textHTML:  {
        __typename: "text_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "text_Entry",
      // The ID of the entity
      id: string | null,
      heading: string | null,
      textHTML:  {
        __typename: "text2_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "textWithImage_Entry",
      image:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      heading: string | null,
      textHTML:  {
        __typename: "text3_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
      imageAlignment: string | null,
    } | {
      __typename: "image_Entry",
      image:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      heading: string | null,
      text: string | null,
      buttonText: string | null,
      buttonLink:  Array<( {
          __typename: "city_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "connectedNetworkCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "internal_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "wishlist_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registration_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "document_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "country_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "documentation_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "intro_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "text_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "textWithImage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "image_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graphic_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "video_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "audio_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "table_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "codeSnippet_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "contactForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "logos_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "button_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "sectionEnding_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "users_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "trafficGraph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "applicationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "event_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "eventCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "exchangePage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "footerLink_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "getStarted_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "info_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "menu_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "network_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkConnection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "news_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletter_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletterCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partner_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "search_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "service_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "benefit_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "speedBlock_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "story_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "storyCollection_Entry",
          // The element’s URI.
          uri: string | null,
        }
      ) | null >,
      textAlignment: string | null,
    } | {
      __typename: "graphic_Entry",
      image:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcOriginal: string | null,
          // The width in pixels or null if it’s not an image.
          widthOriginal: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcOriginal: string | null,
          // The width in pixels or null if it’s not an image.
          widthOriginal: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "video_Entry",
      videoUrl: string | null,
    } | {
      __typename: "audio_Entry",
      podcastUrl: string | null,
      podcastDescription: string | null,
    } | {
      __typename: "table_Entry",
      heading: string | null,
      table:  {
        __typename: "table_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "codeSnippet_Entry",
      programmingLanguage: string | null,
      snippet:  {
        __typename: "snippet_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "contactForm_Entry",
      // The ID of the entity
      id: string | null,
      ctaText: string | null,
      buttonText: string | null,
      compactDisplay: boolean | null,
      documentUpload: boolean | null,
      description:  {
        __typename: "description3_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "logos_Entry",
      logos:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The element’s title.
          title: string | null,
          // The ID of the entity
          id: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The element’s title.
          title: string | null,
          // The ID of the entity
          id: string | null,
        }
      ) | null >,
    } | {
      __typename: "button_Entry",
      // The ID of the entity
      id: string | null,
      label: string | null,
      linkEntry:  Array<( {
          __typename: "city_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "connectedNetworkCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "internal_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "wishlist_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registration_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "document_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "country_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "documentation_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "intro_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "text_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "textWithImage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "image_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graphic_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "video_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "audio_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "table_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "codeSnippet_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "contactForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "logos_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "button_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "sectionEnding_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "users_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "trafficGraph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "applicationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "event_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "eventCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "exchangePage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "footerLink_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "getStarted_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "info_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "menu_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "network_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkConnection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "news_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletter_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletterCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partner_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "search_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "service_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "benefit_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "speedBlock_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "story_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "storyCollection_Entry",
          // The element’s URI.
          uri: string | null,
        }
      ) | null >,
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
      // The ID of the entity
      id: string | null,
      heading: string | null,
      users:  Array<( {
          __typename: "User",
          // The user’s full name.
          fullName: string | null,
          functionTitle: string | null,
          // The user’s photo.
          photo: ( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              url: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              url: string | null,
            }
          ) | null,
        }
      ) | null >,
    } | {
      __typename: "trafficGraph_Entry",
      // The ID of the entity
      id: string | null,
      dataset:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
          // The element’s title.
          title: string | null,
          interval: string | null,
          peakIn: string | null,
          peakOut: string | null,
          averageIn: string | null,
          averageOut: string | null,
          currentIn: string | null,
          currentOut: string | null,
          averageInputData:  Array< {
            __typename: "averageInputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
          averageOutputData:  Array< {
            __typename: "averageOutputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
          peakOutputData:  Array< {
            __typename: "peakOutputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
          peakInputData:  Array< {
            __typename: "peakInputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) | null >,
    } | {
      __typename: "applicationForm_Entry",
      // The ID of the entity
      id: string | null,
      buttonText: string | null,
      applicationType: string | null,
    } | {
      __typename: "registrationForm_Entry",
      // The ID of the entity
      id: string | null,
      ctaText: string | null,
      buttonText: string | null,
      compactDisplay: boolean | null,
      description:  {
        __typename: "description4_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    }
  ) | null >,
};

export interface ApplicationFormContentBlockFragment {
  __typename: "applicationForm_Entry",
  // The ID of the entity
  id: string | null,
  buttonText: string | null,
  applicationType: string | null,
};

export interface AudioContentBlockFragment {
  __typename: "audio_Entry",
  podcastUrl: string | null,
  podcastDescription: string | null,
};

export interface ButtonContentBlockFragment {
  __typename: "button_Entry",
  // The ID of the entity
  id: string | null,
  label: string | null,
  linkEntry:  Array<( {
      __typename: "city_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "connectedNetworkCollection_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "partnerContactRequest_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "internal_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "networkContactRequest_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "wishlist_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "registration_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "document_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "country_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "documentation_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "intro_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "text_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "textWithImage_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "image_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "graphic_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "video_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "audio_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "table_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "codeSnippet_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "contactForm_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "logos_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "button_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "sectionEnding_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "users_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "trafficGraph_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "applicationForm_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "registrationForm_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "event_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "eventCollection_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "exchangePage_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "footerLink_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "getStarted_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "graph_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "info_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "menu_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "network_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "networkConnection_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "news_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "newsCollection_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "newsletter_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "newsletterCollection_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "partner_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "partnerCollection_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "search_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "service_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "benefit_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "speedBlock_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "story_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "storyCollection_Entry",
      // The element’s URI.
      uri: string | null,
    }
  ) | null >,
};

export interface CodeContentBlockFragment {
  __typename: "codeSnippet_Entry",
  programmingLanguage: string | null,
  snippet:  {
    __typename: "snippet_CkeditorField",
    // The parsed content as HTML.
    html: string | null,
  } | null,
};

export interface ContactFormContentBlockFragment {
  __typename: "contactForm_Entry",
  // The ID of the entity
  id: string | null,
  ctaText: string | null,
  buttonText: string | null,
  compactDisplay: boolean | null,
  documentUpload: boolean | null,
  description:  {
    __typename: "description3_CkeditorField",
    // The parsed content as HTML.
    html: string | null,
  } | null,
};

export interface ContactInfoSocialsFragment {
  __typename: "socialMedia_GlobalSet",
  facebookUrl: string | null,
  linkedinUrl: string | null,
  twitterUrl: string | null,
  youtubeUrl: string | null,
};

export interface GraphicContentBlockFragment {
  __typename: "graphic_Entry",
  image:  Array<( {
      __typename: "images_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcSmall: string | null,
      // The width in pixels or null if it’s not an image.
      widthSmall: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcMedium: string | null,
      // The width in pixels or null if it’s not an image.
      widthMedium: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcLarge: string | null,
      // The width in pixels or null if it’s not an image.
      widthLarge: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcOriginal: string | null,
      // The width in pixels or null if it’s not an image.
      widthOriginal: number | null,
      // The element’s title.
      title: string | null,
    } | {
      __typename: "uploadAssets_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcSmall: string | null,
      // The width in pixels or null if it’s not an image.
      widthSmall: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcMedium: string | null,
      // The width in pixels or null if it’s not an image.
      widthMedium: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcLarge: string | null,
      // The width in pixels or null if it’s not an image.
      widthLarge: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcOriginal: string | null,
      // The width in pixels or null if it’s not an image.
      widthOriginal: number | null,
      // The element’s title.
      title: string | null,
    }
  ) | null >,
};

export interface MenuStatsFragment {
  __typename: "graph_Entry",
  averageInputData:  Array< {
    __typename: "averageInputData_TableRow",
    time: string | null,
    value: string | null,
  } | null > | null,
};

export interface ImageContentBlockFragment {
  __typename: "image_Entry",
  image:  Array<( {
      __typename: "images_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      urlSmall: string | null,
      // The width in pixels or null if it’s not an image.
      widthSmall: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      urlMedium: string | null,
      // The width in pixels or null if it’s not an image.
      widthMedium: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      urlLarge: string | null,
      // The width in pixels or null if it’s not an image.
      widthLarge: number | null,
      // The element’s title.
      title: string | null,
    } | {
      __typename: "uploadAssets_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      urlSmall: string | null,
      // The width in pixels or null if it’s not an image.
      widthSmall: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      urlMedium: string | null,
      // The width in pixels or null if it’s not an image.
      widthMedium: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      urlLarge: string | null,
      // The width in pixels or null if it’s not an image.
      widthLarge: number | null,
      // The element’s title.
      title: string | null,
    }
  ) | null >,
  heading: string | null,
  text: string | null,
  buttonText: string | null,
  buttonLink:  Array<( {
      __typename: "city_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "connectedNetworkCollection_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "partnerContactRequest_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "internal_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "networkContactRequest_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "wishlist_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "registration_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "document_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "country_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "documentation_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "intro_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "text_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "textWithImage_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "image_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "graphic_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "video_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "audio_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "table_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "codeSnippet_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "contactForm_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "logos_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "button_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "sectionEnding_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "users_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "trafficGraph_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "applicationForm_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "registrationForm_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "event_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "eventCollection_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "exchangePage_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "footerLink_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "getStarted_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "graph_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "info_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "menu_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "network_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "networkConnection_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "news_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "newsCollection_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "newsletter_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "newsletterCollection_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "partner_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "partnerCollection_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "search_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "service_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "benefit_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "speedBlock_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "story_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "storyCollection_Entry",
      // The element’s URI.
      uri: string | null,
    }
  ) | null >,
  textAlignment: string | null,
};

export interface IntroContentBlockFragment {
  __typename: "intro_Entry",
  // The ID of the entity
  id: string | null,
  heading: string | null,
  textHTML:  {
    __typename: "text_CkeditorField",
    // The parsed content as HTML.
    html: string | null,
  } | null,
};

export interface LogosContentBlockFragment {
  __typename: "logos_Entry",
  logos:  Array<( {
      __typename: "images_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src: string | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src2x: string | null,
      // The element’s title.
      title: string | null,
      // The ID of the entity
      id: string | null,
    } | {
      __typename: "uploadAssets_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src: string | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src2x: string | null,
      // The element’s title.
      title: string | null,
      // The ID of the entity
      id: string | null,
    }
  ) | null >,
};

export interface RegistrationFormContentBlockFragment {
  __typename: "registrationForm_Entry",
  // The ID of the entity
  id: string | null,
  ctaText: string | null,
  buttonText: string | null,
  compactDisplay: boolean | null,
  description:  {
    __typename: "description4_CkeditorField",
    // The parsed content as HTML.
    html: string | null,
  } | null,
};

export interface ServicePageBenefitFragment {
  __typename: "benefit_Entry",
  icon:  Array<( {
      __typename: "images_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      url: string | null,
    } | {
      __typename: "uploadAssets_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      url: string | null,
    }
  ) | null >,
  heading: string | null,
  description: string | null,
};

export interface ShowcaseStoryFragment {
  __typename: "story_Entry",
  // The element’s title.
  title: string | null,
  // The element’s URI.
  uri: string | null,
  description:  {
    __typename: "description_CkeditorField",
    // The parsed content as HTML.
    html: string | null,
  } | null,
  heroImage:  Array<( {
      __typename: "images_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcSmall: string | null,
      // The width in pixels or null if it’s not an image.
      widthSmall: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcMedium: string | null,
      // The width in pixels or null if it’s not an image.
      widthMedium: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcLarge: string | null,
      // The width in pixels or null if it’s not an image.
      widthLarge: number | null,
      // The element’s title.
      title: string | null,
    } | {
      __typename: "uploadAssets_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcSmall: string | null,
      // The width in pixels or null if it’s not an image.
      widthSmall: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcMedium: string | null,
      // The width in pixels or null if it’s not an image.
      widthMedium: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcLarge: string | null,
      // The width in pixels or null if it’s not an image.
      widthLarge: number | null,
      // The element’s title.
      title: string | null,
    }
  ) | null >,
};

export interface TableContentBlockFragment {
  __typename: "table_Entry",
  heading: string | null,
  table:  {
    __typename: "table_CkeditorField",
    // The parsed content as HTML.
    html: string | null,
  } | null,
};

export interface TextContentBlockFragment {
  __typename: "text_Entry",
  // The ID of the entity
  id: string | null,
  heading: string | null,
  textHTML:  {
    __typename: "text2_CkeditorField",
    // The parsed content as HTML.
    html: string | null,
  } | null,
};

export interface TextWithImageContentBlockFragment {
  __typename: "textWithImage_Entry",
  image:  Array<( {
      __typename: "images_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcSmall: string | null,
      // The width in pixels or null if it’s not an image.
      widthSmall: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcMedium: string | null,
      // The width in pixels or null if it’s not an image.
      widthMedium: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcLarge: string | null,
      // The width in pixels or null if it’s not an image.
      widthLarge: number | null,
      // The element’s title.
      title: string | null,
    } | {
      __typename: "uploadAssets_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcSmall: string | null,
      // The width in pixels or null if it’s not an image.
      widthSmall: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcMedium: string | null,
      // The width in pixels or null if it’s not an image.
      widthMedium: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcLarge: string | null,
      // The width in pixels or null if it’s not an image.
      widthLarge: number | null,
      // The element’s title.
      title: string | null,
    }
  ) | null >,
  heading: string | null,
  textHTML:  {
    __typename: "text3_CkeditorField",
    // The parsed content as HTML.
    html: string | null,
  } | null,
  imageAlignment: string | null,
};

export interface TrafficGraphContentBlockFragment {
  __typename: "trafficGraph_Entry",
  // The ID of the entity
  id: string | null,
  dataset:  Array<( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
      // The element’s title.
      title: string | null,
      interval: string | null,
      peakIn: string | null,
      peakOut: string | null,
      averageIn: string | null,
      averageOut: string | null,
      currentIn: string | null,
      currentOut: string | null,
      averageInputData:  Array< {
        __typename: "averageInputData_TableRow",
        time: string | null,
        value: string | null,
      } | null > | null,
      averageOutputData:  Array< {
        __typename: "averageOutputData_TableRow",
        time: string | null,
        value: string | null,
      } | null > | null,
      peakOutputData:  Array< {
        __typename: "peakOutputData_TableRow",
        time: string | null,
        value: string | null,
      } | null > | null,
      peakInputData:  Array< {
        __typename: "peakInputData_TableRow",
        time: string | null,
        value: string | null,
      } | null > | null,
    } | {
      __typename: "info_Entry",
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null >,
};

export interface DropdownStatsCompleteFragment {
  __typename: "graph_Entry",
  // The element’s title.
  title: string | null,
  interval: string | null,
  peakIn: string | null,
  peakOut: string | null,
  averageIn: string | null,
  averageOut: string | null,
  currentIn: string | null,
  currentOut: string | null,
  averageInputData:  Array< {
    __typename: "averageInputData_TableRow",
    time: string | null,
    value: string | null,
  } | null > | null,
  averageOutputData:  Array< {
    __typename: "averageOutputData_TableRow",
    time: string | null,
    value: string | null,
  } | null > | null,
  peakOutputData:  Array< {
    __typename: "peakOutputData_TableRow",
    time: string | null,
    value: string | null,
  } | null > | null,
  peakInputData:  Array< {
    __typename: "peakInputData_TableRow",
    time: string | null,
    value: string | null,
  } | null > | null,
};

export interface UsersContentBlockFragment {
  __typename: "users_Entry",
  // The ID of the entity
  id: string | null,
  heading: string | null,
  users:  Array<( {
      __typename: "User",
      // The user’s full name.
      fullName: string | null,
      functionTitle: string | null,
      // The user’s photo.
      photo: ( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          url: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          url: string | null,
        }
      ) | null,
    }
  ) | null >,
};

export interface VideoContentBlockFragment {
  __typename: "video_Entry",
  videoUrl: string | null,
};

export interface DropdownStatsFragment {
  __typename: "graph_Entry",
  // The element’s title.
  title: string | null,
  interval: string | null,
  peakIn: string | null,
  peakOut: string | null,
  averageIn: string | null,
  averageOut: string | null,
  currentIn: string | null,
  currentOut: string | null,
  averageInputData:  Array< {
    __typename: "averageInputData_TableRow",
    time: string | null,
    value: string | null,
  } | null > | null,
};

export interface WhereToConnectLinkFragment {
  __typename: "menu_Entry",
  linkEntry:  Array<( {
      __typename: "city_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "connectedNetworkCollection_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "partnerContactRequest_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "internal_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "networkContactRequest_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "wishlist_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "registration_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "document_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "country_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "documentation_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "intro_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "text_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "textWithImage_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "image_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "graphic_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "video_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "audio_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "table_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "codeSnippet_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "contactForm_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "logos_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "button_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "sectionEnding_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "users_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "trafficGraph_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "applicationForm_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "registrationForm_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "event_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "eventCollection_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "exchangePage_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "footerLink_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "getStarted_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "graph_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "info_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "menu_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "network_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "networkConnection_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "news_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "newsCollection_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "newsletter_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "newsletterCollection_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "partner_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "partnerCollection_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "search_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "service_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "benefit_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "speedBlock_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "story_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "storyCollection_Entry",
      // The element’s URI.
      uri: string | null,
    }
  ) | null >,
};

export interface StatsFragment {
  __typename: "exchangePage_Entry",
  numbersCtaText: string | null,
  hideColocations: boolean | null,
};

export interface ConnectedNetworkDetailsFragment {
  __typename: "network_Entry",
  connections:  Array<( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
      IPv4: string | null,
      IPv6: string | null,
      Speed: string | null,
      Location: string | null,
      VLAN: string | null,
    } | {
      __typename: "news_Entry",
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null >,
};

export interface ConnectedNetworkConnectionFragment {
  __typename: "networkConnection_Entry",
  IPv4: string | null,
  IPv6: string | null,
  Speed: string | null,
  Location: string | null,
  VLAN: string | null,
};

export type ContentBlockFragment = ( {
      __typename: "intro_Entry",
      // The ID of the entity
      id: string | null,
      heading: string | null,
      textHTML:  {
        __typename: "text_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "text_Entry",
      // The ID of the entity
      id: string | null,
      heading: string | null,
      textHTML:  {
        __typename: "text2_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "textWithImage_Entry",
      image:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      heading: string | null,
      textHTML:  {
        __typename: "text3_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
      imageAlignment: string | null,
    } | {
      __typename: "image_Entry",
      image:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      heading: string | null,
      text: string | null,
      buttonText: string | null,
      buttonLink:  Array<( {
          __typename: "city_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "connectedNetworkCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "internal_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "wishlist_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registration_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "document_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "country_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "documentation_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "intro_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "text_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "textWithImage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "image_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graphic_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "video_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "audio_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "table_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "codeSnippet_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "contactForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "logos_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "button_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "sectionEnding_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "users_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "trafficGraph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "applicationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "event_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "eventCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "exchangePage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "footerLink_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "getStarted_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "info_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "menu_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "network_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkConnection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "news_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletter_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletterCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partner_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "search_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "service_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "benefit_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "speedBlock_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "story_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "storyCollection_Entry",
          // The element’s URI.
          uri: string | null,
        }
      ) | null >,
      textAlignment: string | null,
    } | {
      __typename: "graphic_Entry",
      image:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcOriginal: string | null,
          // The width in pixels or null if it’s not an image.
          widthOriginal: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcOriginal: string | null,
          // The width in pixels or null if it’s not an image.
          widthOriginal: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "video_Entry",
      videoUrl: string | null,
    } | {
      __typename: "audio_Entry",
      podcastUrl: string | null,
      podcastDescription: string | null,
    } | {
      __typename: "table_Entry",
      heading: string | null,
      table:  {
        __typename: "table_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "codeSnippet_Entry",
      programmingLanguage: string | null,
      snippet:  {
        __typename: "snippet_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "contactForm_Entry",
      // The ID of the entity
      id: string | null,
      ctaText: string | null,
      buttonText: string | null,
      compactDisplay: boolean | null,
      documentUpload: boolean | null,
      description:  {
        __typename: "description3_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "logos_Entry",
      logos:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The element’s title.
          title: string | null,
          // The ID of the entity
          id: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The element’s title.
          title: string | null,
          // The ID of the entity
          id: string | null,
        }
      ) | null >,
    } | {
      __typename: "button_Entry",
      // The ID of the entity
      id: string | null,
      label: string | null,
      linkEntry:  Array<( {
          __typename: "city_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "connectedNetworkCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "internal_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "wishlist_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registration_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "document_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "country_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "documentation_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "intro_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "text_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "textWithImage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "image_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graphic_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "video_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "audio_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "table_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "codeSnippet_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "contactForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "logos_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "button_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "sectionEnding_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "users_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "trafficGraph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "applicationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "event_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "eventCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "exchangePage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "footerLink_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "getStarted_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "info_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "menu_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "network_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkConnection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "news_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletter_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletterCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partner_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "search_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "service_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "benefit_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "speedBlock_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "story_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "storyCollection_Entry",
          // The element’s URI.
          uri: string | null,
        }
      ) | null >,
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
      // The ID of the entity
      id: string | null,
      heading: string | null,
      users:  Array<( {
          __typename: "User",
          // The user’s full name.
          fullName: string | null,
          functionTitle: string | null,
          // The user’s photo.
          photo: ( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              url: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              url: string | null,
            }
          ) | null,
        }
      ) | null >,
    } | {
      __typename: "trafficGraph_Entry",
      // The ID of the entity
      id: string | null,
      dataset:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
          // The element’s title.
          title: string | null,
          interval: string | null,
          peakIn: string | null,
          peakOut: string | null,
          averageIn: string | null,
          averageOut: string | null,
          currentIn: string | null,
          currentOut: string | null,
          averageInputData:  Array< {
            __typename: "averageInputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
          averageOutputData:  Array< {
            __typename: "averageOutputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
          peakOutputData:  Array< {
            __typename: "peakOutputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
          peakInputData:  Array< {
            __typename: "peakInputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) | null >,
    } | {
      __typename: "applicationForm_Entry",
      // The ID of the entity
      id: string | null,
      buttonText: string | null,
      applicationType: string | null,
    } | {
      __typename: "registrationForm_Entry",
      // The ID of the entity
      id: string | null,
      ctaText: string | null,
      buttonText: string | null,
      compactDisplay: boolean | null,
      description:  {
        __typename: "description4_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    }
  );

export interface ExchangePageEventsFragment {
  __typename: "exchangePage_Entry",
  featuredEvent:  Array<( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
      // The element’s title.
      title: string | null,
      location: string | null,
      startDate: string | null,
      endDate: string | null,
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null >,
};

export interface EventSummaryFragment {
  __typename: "event_Entry",
  // The element’s title.
  title: string | null,
  location: string | null,
  startDate: string | null,
  endDate: string | null,
  // The ID of the entity
  id: string | null,
  // The element’s URI.
  uri: string | null,
};

export interface FeaturedEventFragment {
  __typename: "event_Entry",
  // The element’s title.
  title: string | null,
  location: string | null,
  startDate: string | null,
  endDate: string | null,
  // The ID of the entity
  id: string | null,
  // The element’s URI.
  uri: string | null,
  heroImage:  Array<( {
      __typename: "images_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcSmall: string | null,
      // The width in pixels or null if it’s not an image.
      widthSmall: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcMedium: string | null,
      // The width in pixels or null if it’s not an image.
      widthMedium: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcLarge: string | null,
      // The width in pixels or null if it’s not an image.
      widthLarge: number | null,
      // The element’s title.
      title: string | null,
    } | {
      __typename: "uploadAssets_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcSmall: string | null,
      // The width in pixels or null if it’s not an image.
      widthSmall: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcMedium: string | null,
      // The width in pixels or null if it’s not an image.
      widthMedium: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcLarge: string | null,
      // The width in pixels or null if it’s not an image.
      widthLarge: number | null,
      // The element’s title.
      title: string | null,
    }
  ) | null >,
};

export interface FooterLinkFragment {
  __typename: "footerLink_Entry",
  // The ID of the entity
  id: string | null,
  // The element’s title.
  title: string | null,
  linkEntry:  Array<( {
      __typename: "city_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "connectedNetworkCollection_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "partnerContactRequest_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "internal_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "networkContactRequest_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "wishlist_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "registration_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "document_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "country_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "documentation_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "intro_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "text_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "textWithImage_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "image_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "graphic_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "video_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "audio_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "table_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "codeSnippet_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "contactForm_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "logos_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "button_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "sectionEnding_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "users_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "trafficGraph_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "applicationForm_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "registrationForm_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "event_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "eventCollection_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "exchangePage_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "footerLink_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "getStarted_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "graph_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "info_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "menu_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "network_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "networkConnection_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "news_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "newsCollection_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "newsletter_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "newsletterCollection_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "partner_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "partnerCollection_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "search_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "service_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "benefit_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "speedBlock_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "story_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "storyCollection_Entry",
      // The element’s URI.
      uri: string | null,
    }
  ) | null >,
};

export interface MenuFragment {
  __typename: "menu_Entry",
  // The ID of the entity
  id: string | null,
  // The element’s title.
  title: string | null,
  linkEntry:  Array<( {
      __typename: "city_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "connectedNetworkCollection_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "partnerContactRequest_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "internal_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "networkContactRequest_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "wishlist_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "registration_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "document_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "country_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "documentation_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "intro_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "text_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "textWithImage_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "image_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "graphic_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "video_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "audio_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "table_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "codeSnippet_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "contactForm_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "logos_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "button_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "sectionEnding_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "users_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "trafficGraph_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "applicationForm_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "registrationForm_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "event_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "eventCollection_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "exchangePage_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "footerLink_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "getStarted_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "graph_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "info_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "menu_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "network_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "networkConnection_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "news_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "newsCollection_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "newsletter_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "newsletterCollection_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "partner_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "partnerCollection_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "search_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "service_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "benefit_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "speedBlock_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "story_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "storyCollection_Entry",
      // The element’s URI.
      uri: string | null,
    }
  ) | null >,
  externalLink: string | null,
  // The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query.
  ancestors:  Array<( {
      __typename: "city_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "connectedNetworkCollection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "partnerContactRequest_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "internal_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "networkContactRequest_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "wishlist_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "registration_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "document_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "country_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "documentation_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "intro_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "text_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "textWithImage_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "image_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "graphic_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "video_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "audio_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "table_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "codeSnippet_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "contactForm_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "logos_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "button_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "sectionEnding_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "users_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "trafficGraph_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "applicationForm_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "registrationForm_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "event_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "eventCollection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "exchangePage_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "footerLink_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "getStarted_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "graph_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "info_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "menu_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "network_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "networkConnection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "news_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "newsCollection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "newsletter_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "newsletterCollection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "partner_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "partnerCollection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "search_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "service_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "benefit_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "speedBlock_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "story_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "storyCollection_Entry",
      // The element’s title.
      title: string | null,
    }
  ) >,
  menuDropdownType: string | null,
  // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
  children:  Array<( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
    } | {
      __typename: "menu_Entry",
      // The element’s title.
      title: string | null,
      // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
      children:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s title.
          title: string | null,
          linkEntry:  Array<( {
              __typename: "city_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "connectedNetworkCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partnerContactRequest_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "internal_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "networkContactRequest_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "wishlist_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "registration_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "document_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "country_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "documentation_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "intro_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "text_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "textWithImage_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "image_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "graphic_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "video_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "audio_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "table_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "codeSnippet_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "contactForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "logos_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "button_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "sectionEnding_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "users_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "trafficGraph_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "applicationForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "registrationForm_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "event_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "eventCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "exchangePage_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "footerLink_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "getStarted_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "graph_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "info_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "menu_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "network_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "networkConnection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "news_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsletter_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "newsletterCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partner_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "partnerCollection_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "search_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "service_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "benefit_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "speedBlock_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "story_Entry",
              // The element’s URI.
              uri: string | null,
            } | {
              __typename: "storyCollection_Entry",
              // The element’s URI.
              uri: string | null,
            }
          ) | null >,
          externalLink: string | null,
          // The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query.
          ancestors:  Array<( {
              __typename: "city_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "connectedNetworkCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "partnerContactRequest_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "internal_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "networkContactRequest_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "wishlist_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "registration_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "document_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "country_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "documentation_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "intro_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "text_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "textWithImage_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "image_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "graphic_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "video_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "audio_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "table_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "codeSnippet_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "contactForm_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "logos_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "button_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "sectionEnding_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "users_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "trafficGraph_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "applicationForm_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "registrationForm_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "event_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "eventCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "exchangePage_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "footerLink_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "getStarted_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "graph_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "info_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "menu_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "network_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "networkConnection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "news_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "newsCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "newsletter_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "newsletterCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "partner_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "partnerCollection_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "search_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "service_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "benefit_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "speedBlock_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "story_Entry",
              // The element’s title.
              title: string | null,
            } | {
              __typename: "storyCollection_Entry",
              // The element’s title.
              title: string | null,
            }
          ) >,
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) >,
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
    } | {
      __typename: "storyCollection_Entry",
    }
  ) >,
};

export interface MenuColumnFragment {
  __typename: "menu_Entry",
  // The element’s title.
  title: string | null,
  // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
  children:  Array<( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
    } | {
      __typename: "menu_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s title.
      title: string | null,
      linkEntry:  Array<( {
          __typename: "city_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "connectedNetworkCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "internal_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "wishlist_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registration_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "document_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "country_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "documentation_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "intro_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "text_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "textWithImage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "image_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graphic_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "video_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "audio_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "table_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "codeSnippet_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "contactForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "logos_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "button_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "sectionEnding_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "users_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "trafficGraph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "applicationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "event_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "eventCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "exchangePage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "footerLink_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "getStarted_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "info_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "menu_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "network_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkConnection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "news_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletter_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletterCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partner_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "search_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "service_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "benefit_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "speedBlock_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "story_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "storyCollection_Entry",
          // The element’s URI.
          uri: string | null,
        }
      ) | null >,
      externalLink: string | null,
      // The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query.
      ancestors:  Array<( {
          __typename: "city_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "connectedNetworkCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "partnerContactRequest_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "internal_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "networkContactRequest_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "wishlist_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "registration_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "document_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "country_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "documentation_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "intro_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "text_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "textWithImage_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "image_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "graphic_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "video_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "audio_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "table_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "codeSnippet_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "contactForm_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "logos_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "button_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "sectionEnding_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "users_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "trafficGraph_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "applicationForm_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "event_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "eventCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "exchangePage_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "footerLink_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "getStarted_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "graph_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "info_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "menu_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "network_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "networkConnection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "news_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "newsCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "newsletter_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "newsletterCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "partner_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "partnerCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "search_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "service_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "benefit_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "speedBlock_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "story_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "storyCollection_Entry",
          // The element’s title.
          title: string | null,
        }
      ) >,
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
    } | {
      __typename: "storyCollection_Entry",
    }
  ) >,
};

export interface MenuItemFragment {
  __typename: "menu_Entry",
  // The ID of the entity
  id: string | null,
  // The element’s title.
  title: string | null,
  linkEntry:  Array<( {
      __typename: "city_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "connectedNetworkCollection_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "partnerContactRequest_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "internal_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "networkContactRequest_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "wishlist_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "registration_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "document_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "country_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "documentation_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "intro_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "text_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "textWithImage_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "image_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "graphic_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "video_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "audio_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "table_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "codeSnippet_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "contactForm_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "logos_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "button_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "sectionEnding_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "users_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "trafficGraph_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "applicationForm_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "registrationForm_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "event_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "eventCollection_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "exchangePage_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "footerLink_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "getStarted_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "graph_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "info_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "menu_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "network_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "networkConnection_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "news_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "newsCollection_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "newsletter_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "newsletterCollection_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "partner_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "partnerCollection_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "search_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "service_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "benefit_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "speedBlock_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "story_Entry",
      // The element’s URI.
      uri: string | null,
    } | {
      __typename: "storyCollection_Entry",
      // The element’s URI.
      uri: string | null,
    }
  ) | null >,
  externalLink: string | null,
  // The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query.
  ancestors:  Array<( {
      __typename: "city_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "connectedNetworkCollection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "partnerContactRequest_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "internal_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "networkContactRequest_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "wishlist_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "registration_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "document_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "country_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "documentation_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "intro_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "text_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "textWithImage_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "image_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "graphic_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "video_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "audio_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "table_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "codeSnippet_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "contactForm_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "logos_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "button_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "sectionEnding_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "users_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "trafficGraph_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "applicationForm_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "registrationForm_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "event_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "eventCollection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "exchangePage_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "footerLink_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "getStarted_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "graph_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "info_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "menu_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "network_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "networkConnection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "news_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "newsCollection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "newsletter_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "newsletterCollection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "partner_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "partnerCollection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "search_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "service_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "benefit_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "speedBlock_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "story_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "storyCollection_Entry",
      // The element’s title.
      title: string | null,
    }
  ) >,
};

export interface HeroFragment {
  __typename: "exchangePage_Entry",
  description:  {
    __typename: "description_CkeditorField",
    // The parsed content as HTML.
    html: string | null,
  } | null,
  heroImage:  Array<( {
      __typename: "images_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcSmall: string | null,
      // The width in pixels or null if it’s not an image.
      widthSmall: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcMedium: string | null,
      // The width in pixels or null if it’s not an image.
      widthMedium: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcLarge: string | null,
      // The width in pixels or null if it’s not an image.
      widthLarge: number | null,
      // The element’s title.
      title: string | null,
    } | {
      __typename: "uploadAssets_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcSmall: string | null,
      // The width in pixels or null if it’s not an image.
      widthSmall: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcMedium: string | null,
      // The width in pixels or null if it’s not an image.
      widthMedium: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcLarge: string | null,
      // The width in pixels or null if it’s not an image.
      widthLarge: number | null,
      // The element’s title.
      title: string | null,
    }
  ) | null >,
};

export interface NewsItemFragment {
  __typename: "news_Entry",
  // The ID of the entity
  id: string | null,
  // The element’s URI.
  uri: string | null,
  // The element’s title.
  title: string | null,
  heroImage:  Array<( {
      __typename: "images_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src: string | null,
      // The width in pixels or null if it’s not an image.
      width: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src2x: string | null,
      // The width in pixels or null if it’s not an image.
      width2x: number | null,
      // The element’s title.
      title: string | null,
    } | {
      __typename: "uploadAssets_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src: string | null,
      // The width in pixels or null if it’s not an image.
      width: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src2x: string | null,
      // The width in pixels or null if it’s not an image.
      width2x: number | null,
      // The element’s title.
      title: string | null,
    }
  ) | null >,
  // The entry’s post date.
  postDate: string | null,
};

export interface NewsItemsFragment {
  __typename: "news_Entry",
  // The ID of the entity
  id: string | null,
  // The element’s URI.
  uri: string | null,
  // The element’s title.
  title: string | null,
  heroImage:  Array<( {
      __typename: "images_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src: string | null,
      // The width in pixels or null if it’s not an image.
      width: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src2x: string | null,
      // The width in pixels or null if it’s not an image.
      width2x: number | null,
      // The element’s title.
      title: string | null,
    } | {
      __typename: "uploadAssets_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src: string | null,
      // The width in pixels or null if it’s not an image.
      width: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src2x: string | null,
      // The width in pixels or null if it’s not an image.
      width2x: number | null,
      // The element’s title.
      title: string | null,
    }
  ) | null >,
  // The entry’s post date.
  postDate: string | null,
};

export interface PricingPageFragment {
  __typename: "info_Entry",
  // The ID of the entity
  id: string | null,
  contentBlocks:  Array<( {
      __typename: "intro_Entry",
      // The ID of the entity
      id: string | null,
      heading: string | null,
      textHTML:  {
        __typename: "text_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "text_Entry",
      // The ID of the entity
      id: string | null,
      heading: string | null,
      textHTML:  {
        __typename: "text2_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "textWithImage_Entry",
      image:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      heading: string | null,
      textHTML:  {
        __typename: "text3_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
      imageAlignment: string | null,
    } | {
      __typename: "image_Entry",
      image:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      heading: string | null,
      text: string | null,
      buttonText: string | null,
      buttonLink:  Array<( {
          __typename: "city_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "connectedNetworkCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "internal_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "wishlist_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registration_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "document_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "country_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "documentation_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "intro_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "text_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "textWithImage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "image_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graphic_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "video_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "audio_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "table_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "codeSnippet_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "contactForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "logos_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "button_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "sectionEnding_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "users_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "trafficGraph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "applicationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "event_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "eventCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "exchangePage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "footerLink_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "getStarted_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "info_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "menu_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "network_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkConnection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "news_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletter_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletterCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partner_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "search_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "service_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "benefit_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "speedBlock_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "story_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "storyCollection_Entry",
          // The element’s URI.
          uri: string | null,
        }
      ) | null >,
      textAlignment: string | null,
    } | {
      __typename: "graphic_Entry",
      image:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcOriginal: string | null,
          // The width in pixels or null if it’s not an image.
          widthOriginal: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcOriginal: string | null,
          // The width in pixels or null if it’s not an image.
          widthOriginal: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "video_Entry",
      videoUrl: string | null,
    } | {
      __typename: "audio_Entry",
      podcastUrl: string | null,
      podcastDescription: string | null,
    } | {
      __typename: "table_Entry",
      heading: string | null,
      table:  {
        __typename: "table_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "codeSnippet_Entry",
      programmingLanguage: string | null,
      snippet:  {
        __typename: "snippet_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "contactForm_Entry",
      // The ID of the entity
      id: string | null,
      ctaText: string | null,
      buttonText: string | null,
      compactDisplay: boolean | null,
      documentUpload: boolean | null,
      description:  {
        __typename: "description3_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "logos_Entry",
      logos:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The element’s title.
          title: string | null,
          // The ID of the entity
          id: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The element’s title.
          title: string | null,
          // The ID of the entity
          id: string | null,
        }
      ) | null >,
    } | {
      __typename: "button_Entry",
      // The ID of the entity
      id: string | null,
      label: string | null,
      linkEntry:  Array<( {
          __typename: "city_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "connectedNetworkCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "internal_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "wishlist_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registration_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "document_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "country_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "documentation_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "intro_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "text_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "textWithImage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "image_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graphic_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "video_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "audio_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "table_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "codeSnippet_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "contactForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "logos_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "button_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "sectionEnding_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "users_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "trafficGraph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "applicationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "event_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "eventCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "exchangePage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "footerLink_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "getStarted_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "info_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "menu_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "network_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkConnection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "news_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletter_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletterCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partner_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "search_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "service_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "benefit_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "speedBlock_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "story_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "storyCollection_Entry",
          // The element’s URI.
          uri: string | null,
        }
      ) | null >,
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
      // The ID of the entity
      id: string | null,
      heading: string | null,
      users:  Array<( {
          __typename: "User",
          // The user’s full name.
          fullName: string | null,
          functionTitle: string | null,
          // The user’s photo.
          photo: ( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              url: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              url: string | null,
            }
          ) | null,
        }
      ) | null >,
    } | {
      __typename: "trafficGraph_Entry",
      // The ID of the entity
      id: string | null,
      dataset:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
          // The element’s title.
          title: string | null,
          interval: string | null,
          peakIn: string | null,
          peakOut: string | null,
          averageIn: string | null,
          averageOut: string | null,
          currentIn: string | null,
          currentOut: string | null,
          averageInputData:  Array< {
            __typename: "averageInputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
          averageOutputData:  Array< {
            __typename: "averageOutputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
          peakOutputData:  Array< {
            __typename: "peakOutputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
          peakInputData:  Array< {
            __typename: "peakInputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) | null >,
    } | {
      __typename: "applicationForm_Entry",
      // The ID of the entity
      id: string | null,
      buttonText: string | null,
      applicationType: string | null,
    } | {
      __typename: "registrationForm_Entry",
      // The ID of the entity
      id: string | null,
      ctaText: string | null,
      buttonText: string | null,
      compactDisplay: boolean | null,
      description:  {
        __typename: "description4_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    }
  ) | null >,
};

export interface RelatedStoryFragment {
  __typename: "story_Entry",
  // The ID of the entity
  id: string | null,
  // The element’s URI.
  uri: string | null,
  // The element’s title.
  title: string | null,
  // The entry’s post date.
  postDate: string | null,
  heroImage:  Array<( {
      __typename: "images_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcSmall: string | null,
      // The width in pixels or null if it’s not an image.
      widthSmall: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcMedium: string | null,
      // The width in pixels or null if it’s not an image.
      widthMedium: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcLarge: string | null,
      // The width in pixels or null if it’s not an image.
      widthLarge: number | null,
      // The element’s title.
      title: string | null,
    } | {
      __typename: "uploadAssets_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcSmall: string | null,
      // The width in pixels or null if it’s not an image.
      widthSmall: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcMedium: string | null,
      // The width in pixels or null if it’s not an image.
      widthMedium: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcLarge: string | null,
      // The width in pixels or null if it’s not an image.
      widthLarge: number | null,
      // The element’s title.
      title: string | null,
    }
  ) | null >,
  service:  Array<( {
      __typename: "city_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "connectedNetworkCollection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "partnerContactRequest_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "internal_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "networkContactRequest_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "wishlist_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "registration_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "document_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "country_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "documentation_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "intro_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "text_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "textWithImage_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "image_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "graphic_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "video_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "audio_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "table_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "codeSnippet_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "contactForm_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "logos_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "button_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "sectionEnding_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "users_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "trafficGraph_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "applicationForm_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "registrationForm_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "event_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "eventCollection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "exchangePage_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "footerLink_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "getStarted_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "graph_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "info_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "menu_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "network_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "networkConnection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "news_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "newsCollection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "newsletter_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "newsletterCollection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "partner_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "partnerCollection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "search_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "service_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "benefit_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "speedBlock_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "story_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "storyCollection_Entry",
      // The element’s title.
      title: string | null,
    }
  ) | null >,
};

export interface RelatedEventFragment {
  __typename: "event_Entry",
  // The ID of the entity
  id: string | null,
  // The element’s URI.
  uri: string | null,
  // The element’s title.
  title: string | null,
  // The entry’s post date.
  postDate: string | null,
  heroImage:  Array<( {
      __typename: "images_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcSmall: string | null,
      // The width in pixels or null if it’s not an image.
      widthSmall: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcMedium: string | null,
      // The width in pixels or null if it’s not an image.
      widthMedium: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcLarge: string | null,
      // The width in pixels or null if it’s not an image.
      widthLarge: number | null,
      // The element’s title.
      title: string | null,
    } | {
      __typename: "uploadAssets_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcSmall: string | null,
      // The width in pixels or null if it’s not an image.
      widthSmall: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcMedium: string | null,
      // The width in pixels or null if it’s not an image.
      widthMedium: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcLarge: string | null,
      // The width in pixels or null if it’s not an image.
      widthLarge: number | null,
      // The element’s title.
      title: string | null,
    }
  ) | null >,
};

export interface RelatedServiceFragment {
  __typename: "service_Entry",
  // The ID of the entity
  id: string | null,
  // The element’s URI.
  uri: string | null,
  // The element’s title.
  title: string | null,
  // The entry’s post date.
  postDate: string | null,
  relatedItemImage:  Array<( {
      __typename: "images_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcSmall: string | null,
      // The width in pixels or null if it’s not an image.
      widthSmall: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcMedium: string | null,
      // The width in pixels or null if it’s not an image.
      widthMedium: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcLarge: string | null,
      // The width in pixels or null if it’s not an image.
      widthLarge: number | null,
      // The element’s title.
      title: string | null,
    } | {
      __typename: "uploadAssets_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcSmall: string | null,
      // The width in pixels or null if it’s not an image.
      widthSmall: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcMedium: string | null,
      // The width in pixels or null if it’s not an image.
      widthMedium: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcLarge: string | null,
      // The width in pixels or null if it’s not an image.
      widthLarge: number | null,
      // The element’s title.
      title: string | null,
    }
  ) | null >,
};

export interface RelatedInfoFragment {
  __typename: "info_Entry",
  // The ID of the entity
  id: string | null,
  // The element’s URI.
  uri: string | null,
  // The element’s title.
  title: string | null,
  // The entry’s post date.
  postDate: string | null,
  relatedItemImage:  Array<( {
      __typename: "images_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcSmall: string | null,
      // The width in pixels or null if it’s not an image.
      widthSmall: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcMedium: string | null,
      // The width in pixels or null if it’s not an image.
      widthMedium: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcLarge: string | null,
      // The width in pixels or null if it’s not an image.
      widthLarge: number | null,
      // The element’s title.
      title: string | null,
    } | {
      __typename: "uploadAssets_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcSmall: string | null,
      // The width in pixels or null if it’s not an image.
      widthSmall: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcMedium: string | null,
      // The width in pixels or null if it’s not an image.
      widthMedium: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcLarge: string | null,
      // The width in pixels or null if it’s not an image.
      widthLarge: number | null,
      // The element’s title.
      title: string | null,
    }
  ) | null >,
};

export interface RelatedDocumentationFragment {
  __typename: "documentation_Entry",
  // The ID of the entity
  id: string | null,
  // The element’s URI.
  uri: string | null,
  // The element’s title.
  title: string | null,
  // The entry’s post date.
  postDate: string | null,
  relatedItemImage:  Array<( {
      __typename: "images_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcSmall: string | null,
      // The width in pixels or null if it’s not an image.
      widthSmall: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcMedium: string | null,
      // The width in pixels or null if it’s not an image.
      widthMedium: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcLarge: string | null,
      // The width in pixels or null if it’s not an image.
      widthLarge: number | null,
      // The element’s title.
      title: string | null,
    } | {
      __typename: "uploadAssets_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcSmall: string | null,
      // The width in pixels or null if it’s not an image.
      widthSmall: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcMedium: string | null,
      // The width in pixels or null if it’s not an image.
      widthMedium: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcLarge: string | null,
      // The width in pixels or null if it’s not an image.
      widthLarge: number | null,
      // The element’s title.
      title: string | null,
    }
  ) | null >,
};

export interface RelatedNewsFragment {
  __typename: "news_Entry",
  // The ID of the entity
  id: string | null,
  // The element’s URI.
  uri: string | null,
  // The element’s title.
  title: string | null,
  // The entry’s post date.
  postDate: string | null,
  heroImage:  Array<( {
      __typename: "images_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcSmall: string | null,
      // The width in pixels or null if it’s not an image.
      widthSmall: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcMedium: string | null,
      // The width in pixels or null if it’s not an image.
      widthMedium: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcLarge: string | null,
      // The width in pixels or null if it’s not an image.
      widthLarge: number | null,
      // The element’s title.
      title: string | null,
    } | {
      __typename: "uploadAssets_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcSmall: string | null,
      // The width in pixels or null if it’s not an image.
      widthSmall: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcMedium: string | null,
      // The width in pixels or null if it’s not an image.
      widthMedium: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcLarge: string | null,
      // The width in pixels or null if it’s not an image.
      widthLarge: number | null,
      // The element’s title.
      title: string | null,
    }
  ) | null >,
};

export type RelatedFragment = ( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      relatedItemImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      relatedItemImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      relatedItemImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s URI.
      uri: string | null,
      // The element’s title.
      title: string | null,
      // The entry’s post date.
      postDate: string | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      service:  Array<( {
          __typename: "city_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "connectedNetworkCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "partnerContactRequest_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "internal_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "networkContactRequest_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "wishlist_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "registration_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "document_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "country_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "documentation_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "intro_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "text_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "textWithImage_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "image_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "graphic_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "video_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "audio_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "table_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "codeSnippet_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "contactForm_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "logos_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "button_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "sectionEnding_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "users_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "trafficGraph_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "applicationForm_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "event_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "eventCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "exchangePage_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "footerLink_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "getStarted_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "graph_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "info_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "menu_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "network_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "networkConnection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "news_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "newsCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "newsletter_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "newsletterCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "partner_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "partnerCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "search_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "service_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "benefit_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "speedBlock_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "story_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "storyCollection_Entry",
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "storyCollection_Entry",
    }
  );

export interface FeaturedStoryFragment {
  __typename: "story_Entry",
  // The ID of the entity
  id: string | null,
  // The element’s title.
  title: string | null,
  // The element’s URI.
  uri: string | null,
  heroImage:  Array<( {
      __typename: "images_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcSmall: string | null,
      // The width in pixels or null if it’s not an image.
      widthSmall: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcMedium: string | null,
      // The width in pixels or null if it’s not an image.
      widthMedium: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcLarge: string | null,
      // The width in pixels or null if it’s not an image.
      widthLarge: number | null,
      // The element’s title.
      title: string | null,
    } | {
      __typename: "uploadAssets_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcSmall: string | null,
      // The width in pixels or null if it’s not an image.
      widthSmall: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcMedium: string | null,
      // The width in pixels or null if it’s not an image.
      widthMedium: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcLarge: string | null,
      // The width in pixels or null if it’s not an image.
      widthLarge: number | null,
      // The element’s title.
      title: string | null,
    }
  ) | null >,
  description:  {
    __typename: "description_CkeditorField",
    // The parsed content as HTML.
    html: string | null,
  } | null,
  service:  Array<( {
      __typename: "city_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "connectedNetworkCollection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "partnerContactRequest_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "internal_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "networkContactRequest_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "wishlist_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "registration_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "document_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "country_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "documentation_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "intro_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "text_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "textWithImage_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "image_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "graphic_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "video_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "audio_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "table_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "codeSnippet_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "contactForm_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "logos_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "button_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "sectionEnding_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "users_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "trafficGraph_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "applicationForm_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "registrationForm_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "event_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "eventCollection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "exchangePage_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "footerLink_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "getStarted_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "graph_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "info_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "menu_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "network_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "networkConnection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "news_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "newsCollection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "newsletter_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "newsletterCollection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "partner_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "partnerCollection_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "search_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "service_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "benefit_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "speedBlock_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "story_Entry",
      // The element’s title.
      title: string | null,
    } | {
      __typename: "storyCollection_Entry",
      // The element’s title.
      title: string | null,
    }
  ) | null >,
  // The entry’s post date.
  postDate: string | null,
};

export interface FeaturedStoriesFragment {
  __typename: "exchangePage_Entry",
  featuredStories:  Array<( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s title.
      title: string | null,
      // The element’s URI.
      uri: string | null,
      heroImage:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      description:  {
        __typename: "description_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
      service:  Array<( {
          __typename: "city_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "connectedNetworkCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "partnerContactRequest_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "internal_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "networkContactRequest_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "wishlist_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "registration_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "document_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "country_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "documentation_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "intro_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "text_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "textWithImage_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "image_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "graphic_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "video_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "audio_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "table_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "codeSnippet_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "contactForm_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "logos_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "button_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "sectionEnding_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "users_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "trafficGraph_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "applicationForm_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "event_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "eventCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "exchangePage_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "footerLink_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "getStarted_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "graph_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "info_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "menu_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "network_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "networkConnection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "news_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "newsCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "newsletter_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "newsletterCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "partner_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "partnerCollection_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "search_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "service_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "benefit_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "speedBlock_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "story_Entry",
          // The element’s title.
          title: string | null,
        } | {
          __typename: "storyCollection_Entry",
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      // The entry’s post date.
      postDate: string | null,
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null >,
};

export interface ServiceHowItWorksFragment {
  __typename: "service_Entry",
  // The ID of the entity
  id: string | null,
  contentBlocks:  Array<( {
      __typename: "intro_Entry",
      // The ID of the entity
      id: string | null,
      heading: string | null,
      textHTML:  {
        __typename: "text_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "text_Entry",
      // The ID of the entity
      id: string | null,
      heading: string | null,
      textHTML:  {
        __typename: "text2_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "textWithImage_Entry",
      image:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      heading: string | null,
      textHTML:  {
        __typename: "text3_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
      imageAlignment: string | null,
    } | {
      __typename: "image_Entry",
      image:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          urlLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
      heading: string | null,
      text: string | null,
      buttonText: string | null,
      buttonLink:  Array<( {
          __typename: "city_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "connectedNetworkCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "internal_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "wishlist_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registration_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "document_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "country_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "documentation_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "intro_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "text_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "textWithImage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "image_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graphic_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "video_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "audio_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "table_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "codeSnippet_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "contactForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "logos_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "button_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "sectionEnding_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "users_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "trafficGraph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "applicationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "event_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "eventCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "exchangePage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "footerLink_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "getStarted_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "info_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "menu_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "network_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkConnection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "news_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletter_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletterCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partner_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "search_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "service_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "benefit_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "speedBlock_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "story_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "storyCollection_Entry",
          // The element’s URI.
          uri: string | null,
        }
      ) | null >,
      textAlignment: string | null,
    } | {
      __typename: "graphic_Entry",
      image:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcOriginal: string | null,
          // The width in pixels or null if it’s not an image.
          widthOriginal: number | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcSmall: string | null,
          // The width in pixels or null if it’s not an image.
          widthSmall: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcMedium: string | null,
          // The width in pixels or null if it’s not an image.
          widthMedium: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcLarge: string | null,
          // The width in pixels or null if it’s not an image.
          widthLarge: number | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          srcOriginal: string | null,
          // The width in pixels or null if it’s not an image.
          widthOriginal: number | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "video_Entry",
      videoUrl: string | null,
    } | {
      __typename: "audio_Entry",
      podcastUrl: string | null,
      podcastDescription: string | null,
    } | {
      __typename: "table_Entry",
      heading: string | null,
      table:  {
        __typename: "table_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "codeSnippet_Entry",
      programmingLanguage: string | null,
      snippet:  {
        __typename: "snippet_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "contactForm_Entry",
      // The ID of the entity
      id: string | null,
      ctaText: string | null,
      buttonText: string | null,
      compactDisplay: boolean | null,
      documentUpload: boolean | null,
      description:  {
        __typename: "description3_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    } | {
      __typename: "logos_Entry",
      logos:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The element’s title.
          title: string | null,
          // The ID of the entity
          id: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src: string | null,
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          src2x: string | null,
          // The element’s title.
          title: string | null,
          // The ID of the entity
          id: string | null,
        }
      ) | null >,
    } | {
      __typename: "button_Entry",
      // The ID of the entity
      id: string | null,
      label: string | null,
      linkEntry:  Array<( {
          __typename: "city_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "connectedNetworkCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "internal_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkContactRequest_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "wishlist_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registration_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "document_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "country_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "documentation_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "intro_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "text_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "textWithImage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "image_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graphic_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "video_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "audio_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "table_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "codeSnippet_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "contactForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "logos_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "button_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "sectionEnding_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "users_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "trafficGraph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "applicationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "registrationForm_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "event_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "eventCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "exchangePage_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "footerLink_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "getStarted_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "graph_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "info_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "menu_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "network_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "networkConnection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "news_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletter_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "newsletterCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partner_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "partnerCollection_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "search_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "service_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "benefit_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "speedBlock_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "story_Entry",
          // The element’s URI.
          uri: string | null,
        } | {
          __typename: "storyCollection_Entry",
          // The element’s URI.
          uri: string | null,
        }
      ) | null >,
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
      // The ID of the entity
      id: string | null,
      heading: string | null,
      users:  Array<( {
          __typename: "User",
          // The user’s full name.
          fullName: string | null,
          functionTitle: string | null,
          // The user’s photo.
          photo: ( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              url: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              url: string | null,
            }
          ) | null,
        }
      ) | null >,
    } | {
      __typename: "trafficGraph_Entry",
      // The ID of the entity
      id: string | null,
      dataset:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
          // The element’s title.
          title: string | null,
          interval: string | null,
          peakIn: string | null,
          peakOut: string | null,
          averageIn: string | null,
          averageOut: string | null,
          currentIn: string | null,
          currentOut: string | null,
          averageInputData:  Array< {
            __typename: "averageInputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
          averageOutputData:  Array< {
            __typename: "averageOutputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
          peakOutputData:  Array< {
            __typename: "peakOutputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
          peakInputData:  Array< {
            __typename: "peakInputData_TableRow",
            time: string | null,
            value: string | null,
          } | null > | null,
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) | null >,
    } | {
      __typename: "applicationForm_Entry",
      // The ID of the entity
      id: string | null,
      buttonText: string | null,
      applicationType: string | null,
    } | {
      __typename: "registrationForm_Entry",
      // The ID of the entity
      id: string | null,
      ctaText: string | null,
      buttonText: string | null,
      compactDisplay: boolean | null,
      description:  {
        __typename: "description4_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
    }
  ) | null >,
};

export interface ServiceMenuParentFragment {
  __typename: "menu_Entry",
  // The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query.
  children:  Array<( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
    } | {
      __typename: "menu_Entry",
      linkEntry:  Array<( {
          __typename: "city_Entry",
        } | {
          __typename: "connectedNetworkCollection_Entry",
        } | {
          __typename: "partnerContactRequest_Entry",
        } | {
          __typename: "internal_Entry",
        } | {
          __typename: "networkContactRequest_Entry",
        } | {
          __typename: "wishlist_Entry",
        } | {
          __typename: "registration_Entry",
        } | {
          __typename: "document_Entry",
        } | {
          __typename: "country_Entry",
        } | {
          __typename: "documentation_Entry",
        } | {
          __typename: "intro_Entry",
        } | {
          __typename: "text_Entry",
        } | {
          __typename: "textWithImage_Entry",
        } | {
          __typename: "image_Entry",
        } | {
          __typename: "graphic_Entry",
        } | {
          __typename: "video_Entry",
        } | {
          __typename: "audio_Entry",
        } | {
          __typename: "table_Entry",
        } | {
          __typename: "codeSnippet_Entry",
        } | {
          __typename: "contactForm_Entry",
        } | {
          __typename: "logos_Entry",
        } | {
          __typename: "button_Entry",
        } | {
          __typename: "sectionEnding_Entry",
        } | {
          __typename: "users_Entry",
        } | {
          __typename: "trafficGraph_Entry",
        } | {
          __typename: "applicationForm_Entry",
        } | {
          __typename: "registrationForm_Entry",
        } | {
          __typename: "event_Entry",
        } | {
          __typename: "eventCollection_Entry",
        } | {
          __typename: "exchangePage_Entry",
        } | {
          __typename: "footerLink_Entry",
        } | {
          __typename: "getStarted_Entry",
        } | {
          __typename: "graph_Entry",
        } | {
          __typename: "info_Entry",
        } | {
          __typename: "menu_Entry",
        } | {
          __typename: "network_Entry",
        } | {
          __typename: "networkConnection_Entry",
        } | {
          __typename: "news_Entry",
        } | {
          __typename: "newsCollection_Entry",
        } | {
          __typename: "newsletter_Entry",
        } | {
          __typename: "newsletterCollection_Entry",
        } | {
          __typename: "partner_Entry",
        } | {
          __typename: "partnerCollection_Entry",
        } | {
          __typename: "search_Entry",
        } | {
          __typename: "service_Entry",
          // The ID of the entity
          id: string | null,
          // The element’s title.
          title: string | null,
          description:  {
            __typename: "description_CkeditorField",
            // The parsed content as HTML.
            html: string | null,
          } | null,
          // The element’s URI.
          uri: string | null,
          // The element’s slug.
          slug: string | null,
          icon:  Array<( {
              __typename: "images_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              url: string | null,
              // The element’s title.
              title: string | null,
            } | {
              __typename: "uploadAssets_Asset",
              // The full URL of the asset. This field accepts the same fields as the `transform` directive.
              url: string | null,
              // The element’s title.
              title: string | null,
            }
          ) | null >,
        } | {
          __typename: "benefit_Entry",
        } | {
          __typename: "speedBlock_Entry",
        } | {
          __typename: "story_Entry",
        } | {
          __typename: "storyCollection_Entry",
        }
      ) | null >,
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
    } | {
      __typename: "storyCollection_Entry",
    }
  ) >,
};

export interface ServiceMenuFragment {
  __typename: "menu_Entry",
  linkEntry:  Array<( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
      // The ID of the entity
      id: string | null,
      // The element’s title.
      title: string | null,
      description:  {
        __typename: "description_CkeditorField",
        // The parsed content as HTML.
        html: string | null,
      } | null,
      // The element’s URI.
      uri: string | null,
      // The element’s slug.
      slug: string | null,
      icon:  Array<( {
          __typename: "images_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          url: string | null,
          // The element’s title.
          title: string | null,
        } | {
          __typename: "uploadAssets_Asset",
          // The full URL of the asset. This field accepts the same fields as the `transform` directive.
          url: string | null,
          // The element’s title.
          title: string | null,
        }
      ) | null >,
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
    } | {
      __typename: "storyCollection_Entry",
    }
  ) | null >,
};

export interface ServiceFragment {
  __typename: "service_Entry",
  // The ID of the entity
  id: string | null,
  // The element’s title.
  title: string | null,
  description:  {
    __typename: "description_CkeditorField",
    // The parsed content as HTML.
    html: string | null,
  } | null,
  // The element’s URI.
  uri: string | null,
  // The element’s slug.
  slug: string | null,
  icon:  Array<( {
      __typename: "images_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      url: string | null,
      // The element’s title.
      title: string | null,
    } | {
      __typename: "uploadAssets_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      url: string | null,
      // The element’s title.
      title: string | null,
    }
  ) | null >,
};

export interface FeaturedStoryCollectionItemFragment {
  __typename: "story_Entry",
  // The ID of the entity
  id: string | null,
  // The element’s URI.
  uri: string | null,
  // The element’s title.
  title: string | null,
  description:  {
    __typename: "description_CkeditorField",
    // The parsed content as HTML.
    html: string | null,
  } | null,
  heroImage:  Array<( {
      __typename: "images_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcSmall: string | null,
      // The width in pixels or null if it’s not an image.
      widthSmall: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcMedium: string | null,
      // The width in pixels or null if it’s not an image.
      widthMedium: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcLarge: string | null,
      // The width in pixels or null if it’s not an image.
      widthLarge: number | null,
      // The element’s title.
      title: string | null,
    } | {
      __typename: "uploadAssets_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcSmall: string | null,
      // The width in pixels or null if it’s not an image.
      widthSmall: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcMedium: string | null,
      // The width in pixels or null if it’s not an image.
      widthMedium: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      srcLarge: string | null,
      // The width in pixels or null if it’s not an image.
      widthLarge: number | null,
      // The element’s title.
      title: string | null,
    }
  ) | null >,
  // The entry’s post date.
  postDate: string | null,
};

export interface NewsCollectionItemFragment {
  __typename: "news_Entry",
  // The ID of the entity
  id: string | null,
  // The element’s URI.
  uri: string | null,
  // The element’s title.
  title: string | null,
  description:  {
    __typename: "description_CkeditorField",
    // The parsed content as HTML.
    html: string | null,
  } | null,
  heroImage:  Array<( {
      __typename: "images_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src: string | null,
      // The width in pixels or null if it’s not an image.
      width: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src2x: string | null,
      // The width in pixels or null if it’s not an image.
      width2x: number | null,
      // The element’s title.
      title: string | null,
    } | {
      __typename: "uploadAssets_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src: string | null,
      // The width in pixels or null if it’s not an image.
      width: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src2x: string | null,
      // The width in pixels or null if it’s not an image.
      width2x: number | null,
      // The element’s title.
      title: string | null,
    }
  ) | null >,
  // The entry’s post date.
  date: string | null,
};

export interface NewsletterCollectionItemFragment {
  __typename: "newsletter_Entry",
  // The ID of the entity
  id: string | null,
  // The element’s URI.
  uri: string | null,
  // The element’s title.
  title: string | null,
  newsletterUrl: string | null,
  newsletterDate: string | null,
  heroImage:  Array<( {
      __typename: "images_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src: string | null,
      // The width in pixels or null if it’s not an image.
      width: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src2x: string | null,
      // The width in pixels or null if it’s not an image.
      width2x: number | null,
      // The element’s title.
      title: string | null,
    } | {
      __typename: "uploadAssets_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src: string | null,
      // The width in pixels or null if it’s not an image.
      width: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src2x: string | null,
      // The width in pixels or null if it’s not an image.
      width2x: number | null,
      // The element’s title.
      title: string | null,
    }
  ) | null >,
  // The entry’s post date.
  date: string | null,
};

export interface EventCollectionItemFragment {
  __typename: "event_Entry",
  // The ID of the entity
  id: string | null,
  // The element’s URI.
  uri: string | null,
  // The element’s title.
  title: string | null,
  description:  {
    __typename: "description_CkeditorField",
    // The parsed content as HTML.
    html: string | null,
  } | null,
  heroImage:  Array<( {
      __typename: "images_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src: string | null,
      // The width in pixels or null if it’s not an image.
      width: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src2x: string | null,
      // The width in pixels or null if it’s not an image.
      width2x: number | null,
      // The element’s title.
      title: string | null,
    } | {
      __typename: "uploadAssets_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src: string | null,
      // The width in pixels or null if it’s not an image.
      width: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src2x: string | null,
      // The width in pixels or null if it’s not an image.
      width2x: number | null,
      // The element’s title.
      title: string | null,
    }
  ) | null >,
  startDate: string | null,
  endDate: string | null,
  // The entry’s post date.
  date: string | null,
  location: string | null,
};

export interface StoryCollectionItemFragment {
  __typename: "story_Entry",
  // The ID of the entity
  id: string | null,
  // The element’s URI.
  uri: string | null,
  // The element’s title.
  title: string | null,
  description:  {
    __typename: "description_CkeditorField",
    // The parsed content as HTML.
    html: string | null,
  } | null,
  heroImage:  Array<( {
      __typename: "images_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src: string | null,
      // The width in pixels or null if it’s not an image.
      width: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src2x: string | null,
      // The width in pixels or null if it’s not an image.
      width2x: number | null,
      // The element’s title.
      title: string | null,
    } | {
      __typename: "uploadAssets_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src: string | null,
      // The width in pixels or null if it’s not an image.
      width: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src2x: string | null,
      // The width in pixels or null if it’s not an image.
      width2x: number | null,
      // The element’s title.
      title: string | null,
    }
  ) | null >,
  // The entry’s post date.
  date: string | null,
};

export interface InfoCollectionItemFragment {
  __typename: "info_Entry",
  // The ID of the entity
  id: string | null,
  // The element’s URI.
  uri: string | null,
  // The element’s title.
  title: string | null,
  description:  {
    __typename: "description_CkeditorField",
    // The parsed content as HTML.
    html: string | null,
  } | null,
};

export interface DocumentationCollectionItemFragment {
  __typename: "documentation_Entry",
  // The ID of the entity
  id: string | null,
  // The element’s URI.
  uri: string | null,
  // The element’s title.
  title: string | null,
  description:  {
    __typename: "description_CkeditorField",
    // The parsed content as HTML.
    html: string | null,
  } | null,
};

export interface ServiceCollectionItemFragment {
  __typename: "service_Entry",
  // The ID of the entity
  id: string | null,
  // The element’s URI.
  uri: string | null,
  // The element’s title.
  title: string | null,
  description:  {
    __typename: "description_CkeditorField",
    // The parsed content as HTML.
    html: string | null,
  } | null,
  heroImage:  Array<( {
      __typename: "images_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src: string | null,
      // The width in pixels or null if it’s not an image.
      width: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src2x: string | null,
      // The width in pixels or null if it’s not an image.
      width2x: number | null,
      // The element’s title.
      title: string | null,
    } | {
      __typename: "uploadAssets_Asset",
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src: string | null,
      // The width in pixels or null if it’s not an image.
      width: number | null,
      // The full URL of the asset. This field accepts the same fields as the `transform` directive.
      src2x: string | null,
      // The width in pixels or null if it’s not an image.
      width2x: number | null,
      // The element’s title.
      title: string | null,
    }
  ) | null >,
};

export type EntryTypesFragment = ( {
      __typename: "city_Entry",
    } | {
      __typename: "connectedNetworkCollection_Entry",
    } | {
      __typename: "partnerContactRequest_Entry",
    } | {
      __typename: "internal_Entry",
    } | {
      __typename: "networkContactRequest_Entry",
    } | {
      __typename: "wishlist_Entry",
    } | {
      __typename: "registration_Entry",
    } | {
      __typename: "document_Entry",
    } | {
      __typename: "country_Entry",
    } | {
      __typename: "documentation_Entry",
    } | {
      __typename: "intro_Entry",
    } | {
      __typename: "text_Entry",
    } | {
      __typename: "textWithImage_Entry",
    } | {
      __typename: "image_Entry",
    } | {
      __typename: "graphic_Entry",
    } | {
      __typename: "video_Entry",
    } | {
      __typename: "audio_Entry",
    } | {
      __typename: "table_Entry",
    } | {
      __typename: "codeSnippet_Entry",
    } | {
      __typename: "contactForm_Entry",
    } | {
      __typename: "logos_Entry",
    } | {
      __typename: "button_Entry",
    } | {
      __typename: "sectionEnding_Entry",
    } | {
      __typename: "users_Entry",
    } | {
      __typename: "trafficGraph_Entry",
    } | {
      __typename: "applicationForm_Entry",
    } | {
      __typename: "registrationForm_Entry",
    } | {
      __typename: "event_Entry",
    } | {
      __typename: "eventCollection_Entry",
    } | {
      __typename: "exchangePage_Entry",
    } | {
      __typename: "footerLink_Entry",
    } | {
      __typename: "getStarted_Entry",
    } | {
      __typename: "graph_Entry",
    } | {
      __typename: "info_Entry",
    } | {
      __typename: "menu_Entry",
    } | {
      __typename: "network_Entry",
    } | {
      __typename: "networkConnection_Entry",
    } | {
      __typename: "news_Entry",
    } | {
      __typename: "newsCollection_Entry",
    } | {
      __typename: "newsletter_Entry",
    } | {
      __typename: "newsletterCollection_Entry",
    } | {
      __typename: "partner_Entry",
    } | {
      __typename: "partnerCollection_Entry",
    } | {
      __typename: "search_Entry",
    } | {
      __typename: "service_Entry",
    } | {
      __typename: "benefit_Entry",
    } | {
      __typename: "speedBlock_Entry",
    } | {
      __typename: "story_Entry",
    } | {
      __typename: "storyCollection_Entry",
    }
  );
